webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseUrl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__oauth__ = __webpack_require__(73);






var client = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_3__baseUrl__["a" /* default */].getBaseUrl(),
  json: true,
  withCredentials: true
});

/* harmony default export */ __webpack_exports__["a"] = ({
  getBaseUrl: function getBaseUrl() {
    return __WEBPACK_IMPORTED_MODULE_3__baseUrl__["a" /* default */].getBaseUrl();
  },
  execute: function execute(method, resource, data, getAllResp) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt('return', client({
                method: method,
                url: resource,
                data: data
              }, {
                withCredentials: true
              }).then(function (req) {
                if (getAllResp) return req;else return req.data;
              }).catch(function (error) {
                if (error.response !== undefined && error.response.status === 401) {
                  if (resource === "oauth") alert("C'è stato un errore di autenticazione. Sembra che tu abbia effettuato l'accesso con un account social diverso da quello associato al tuo account.\nPuoi cliccare su 'Ripristina account' per riassociare un account social al tuo account.");

                  if (location.pathname !== "/") location.href = "https://giustup.it/home";
                  // location.href = "https://landing.giustup.it";
                  return false;
                }
                // this.$router.push({name: "Home"});
                else if (error.response !== undefined && error.response.status === 505) {
                    //abbonamento scaduto, redirect abbonamento
                    location.href = "/utente";
                  } else {
                    throw error;
                  }
              }));

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  encodeQueryData: function encodeQueryData(data) {
    var ret = [];
    for (var d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }return ret.join('&');
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_js__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
    cleanHtml: function cleanHtml(html) {
        return html.split('&nbsp;').join(' ');
    },
    getAvatarUrl: function getAvatarUrl(codFisc) {
        return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].getBaseUrl() + 'utente/' + codFisc + '/immagine?nocache=' + Math.random();
    },
    formatDate: function formatDate(d) {
        return ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    },
    getCookie: function getCookie(cName) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + cName + '=');
        if (parts.length === 2) return parts.pop().split(';').shift();
        return "";
    },
    setCookie: function setCookie(cName, cValue, expDays) {
        var d = new Date();
        d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cName + "=" + cValue + ";" + expires + ";path=/";
    }
});

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_js__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
  searchDiMerito: function searchDiMerito(data) {
    return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].execute('get', 'cercasentenze/dimerito?' + __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].encodeQueryData(data));
  },
  searchAmministrative: function searchAmministrative(data) {
    return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].execute('get', 'cercasentenze/amministrative?' + __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].encodeQueryData(data));
  },
  getTribunali: function getTribunali() {
    return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].execute('get', 'cercasentenze/tribunali');
  },
  getMaterie: function getMaterie(filter) {
    return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].execute('get', 'cercasentenze/materie?' + __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].encodeQueryData(filter));
  },
  getSediAmministrative: function getSediAmministrative() {
    return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].execute('get', 'cercasentenze/sediAmministrative');
  }
});

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUrl__ = __webpack_require__(83);
var ClientOAuth2 = __webpack_require__(433);
//REMEMBER: remove Authorization from headers in order to work with Facebook




var redirect = __WEBPACK_IMPORTED_MODULE_0__baseUrl__["a" /* default */].getBaseUrlFrontend() + "oauth";

var providers = {
    'Facebook': new ClientOAuth2({
        clientId: '409126416211794',
        clientSecret: '5a1ac910974e9aa96e1d2b897d018ed8',
        accessTokenUri: 'https://graph.facebook.com/v8.0/oauth/access_token',
        authorizationUri: 'https://www.facebook.com/v8.0/dialog/oauth',
        redirectUri: redirect,
        scopes: ['email'],
        query: {
            state: {}
        }
    }),
    'Google': new ClientOAuth2({
        clientId: '906425901636-atta89mqhl7k1sasitok650hipdf18ij.apps.googleusercontent.com',
        clientSecret: 'SnvsXSCzG-495Jv7sbABm1yA',
        accessTokenUri: 'https://www.googleapis.com/oauth2/v4/token',
        authorizationUri: 'https://accounts.google.com/o/oauth2/v2/auth',
        redirectUri: redirect,
        scopes: ['email'],
        query: {
            'prompt': 'consent',
            'access_type': 'offline',
            state: {}
        }
    })
};

/* harmony default export */ __webpack_exports__["a"] = ({
    get: function get(provider) {
        return providers[provider];
    }
});

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BASE_URL = window.webpackHotUpdate !== undefined ? "https://localhost:5001/" : "https://api.giustup.it/";
var BASE_URL_FRONTEND = window.webpackHotUpdate !== undefined ? "http://localhost:8080/" : "https://giustup.it/";

/* harmony default export */ __webpack_exports__["a"] = ({
  getBaseUrl: function getBaseUrl() {
    return BASE_URL;
  },
  getBaseUrlFrontend: function getBaseUrlFrontend() {
    return BASE_URL_FRONTEND;
  }
});

/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4c3699c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__ = __webpack_require__(551);
function injectStyle (ssrContext) {
  __webpack_require__(550)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Menu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4c3699c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Menu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_oauth_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router_index_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Preferenze_vue__ = __webpack_require__(564);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: "app",
    data: function data() {
        return {
            nominativo: "",
            admin: false,
            giorniRimasti: null,
            codFisc: "",
            loaded: false
        };
    },

    // watch: {
    //   nominativo(newNominativo, oldNominativo) {
    //     if (newNominativo)
    //       this.$forceUpdate();
    //   }
    // },
    methods: {
        getUsername: function getUsername() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute("get", "utente/fullname");

                            case 2:
                                data = _context.sent;

                                _this.nominativo = data.nome;
                                _this.giorniRimasti = data.giorniRimasti;

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        getAdmin: function getAdmin() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute("get", "utente/isadmin");

                            case 2:
                                data = _context2.sent;

                                _this2.admin = data;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        },
        getAvatarUrl: function getAvatarUrl(codFisc) {
            return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].getBaseUrl() + "utente/" + codFisc + "/immagine?nocache=" + Math.random();
        },
        getProfiloLoggato: function getProfiloLoggato() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute("get", "profilo/me");

                            case 2:
                                data = _context3.sent;

                                _this3.codFisc = data.codFisc;

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3);
            }))();
        },
        checkLogged: function checkLogged() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute("get", "oauth");

                            case 2:
                                data = _context4.sent;
                                return _context4.abrupt('return', data);

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4);
            }))();
        },
        cancelNominativo: function cancelNominativo() {
            this.nominativo = "";
            console.log(this.nominativo);
        }
    },
    mounted: function mounted() {
        var _this5 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return _this5.checkLogged();

                        case 2:
                            if (!_context5.sent) {
                                _context5.next = 9;
                                break;
                            }

                            _context5.next = 5;
                            return _this5.getUsername();

                        case 5:
                            _context5.next = 7;
                            return _this5.getAdmin();

                        case 7:
                            _context5.next = 9;
                            return _this5.getProfiloLoggato();

                        case 9:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }))();
    },
    updated: function updated() {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            _context6.next = 2;
                            return _this6.checkLogged();

                        case 2:
                            if (!_context6.sent) {
                                _context6.next = 6;
                                break;
                            }

                            _this6.getUsername();
                            _this6.getAdmin();
                            _this6.getProfiloLoggato();

                        case 6:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }))();
    },

    components: { Preferenze: __WEBPACK_IMPORTED_MODULE_5__components_Preferenze_vue__["a" /* default */] }
});

/***/ }),
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Search_Search__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ThankYou__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sentenza_Sentenza__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Privacy_Privacy__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_OAuth__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Utente_Utente__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Utente_Profilo__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Utente_ModificaProfilo__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pagamento_Pagamento__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pagamento_InfoPagamento__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Newsletter_Newsletter__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Newsletter_NewsletterAmministrative_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Logout__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Attivazione__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Admin_GestioneUtenti__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Admin_Newsletter__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Admin_SocialSentenze__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Admin_ModificaUtente__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Admin_RinnovaAbbonamento_vue__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Pubblica_Massima__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Pubblica_Ricerca__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Pubblica_Newsletter__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Pubblica_UltimeMassime__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__fortawesome_free_solid_svg_icons__ = __webpack_require__(242);































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [
  //TODO: figure out why Home.vue doesn't render
  //FIXME: change it to Home component
  {
    path: '*',
    redirect: '/'
  }, {
    path: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */],
    meta: {
      title: 'GiustUp'
    }
  }, {
    path: '/',
    name: 'ThankYou',
    component: __WEBPACK_IMPORTED_MODULE_4__components_ThankYou__["a" /* default */],
    meta: {
      title: 'GiustUp'
    }
  }, {
    path: '/oauth',
    name: 'Oauth',
    component: __WEBPACK_IMPORTED_MODULE_7__components_OAuth__["a" /* default */]
  }, {
    path: '/attivazione',
    name: 'Attivazione',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Attivazione__["a" /* default */]
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Logout__["a" /* default */]
  }, {
    path: '/search',
    name: 'Search',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Search_Search__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Ricerca sentenze'
    }
  }, {
    path: '/sentenza/:idNodo',
    name: 'Sentenza',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Sentenza_Sentenza__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Visualizza sentenza'
    }
  }, {
    path: '/privacy',
    name: 'Privacy',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Privacy_Privacy__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Privacy'
    }
  }, {
    path: '/utente',
    name: 'Utente',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Utente_Utente__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Profilo utente'
    }
  }, {
    path: '/profilo/:codFisc',
    name: 'Profilo',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Utente_Profilo__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Profilo utente'
    }
  }, {
    path: '/modificaprofilo',
    name: 'ModificaProfilo',
    component: __WEBPACK_IMPORTED_MODULE_10__components_Utente_ModificaProfilo__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Modifica profilo utente'
    }
  }, {
    path: '/pagamento',
    name: 'Pagamento',
    component: __WEBPACK_IMPORTED_MODULE_11__components_Pagamento_Pagamento__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Pagamento'
    }
  }, {
    path: '/pagamentoinfo/:tipopagamento',
    name: 'InfoPagamento',
    component: __WEBPACK_IMPORTED_MODULE_12__components_Pagamento_InfoPagamento__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Pagamento'
    }
  }, {
    path: '/newsletter',
    name: 'Newsletter',
    component: __WEBPACK_IMPORTED_MODULE_13__components_Newsletter_Newsletter__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Newsletter Sentenze di Merito'
    }
  }, {
    path: '/newsletter-amministrative',
    name: 'NewsletterAmministrative',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Newsletter_NewsletterAmministrative_vue__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Newsletter Sentenze Amministrative'
    }
  }, {
    path: '/admin/utenti',
    name: 'GestioneUtenti',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Admin_GestioneUtenti__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Gestione Utenti'
    }
  }, {
    path: '/admin/newsletter',
    name: 'AdminNewsletter',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Admin_Newsletter__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Admin newsletter'
    }
  }, {
    path: '/admin/sentenze',
    name: 'SocialSentenze',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Admin_SocialSentenze__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Gestione sentenze'
    }
  }, {
    path: '/admin/utenti/:userId',
    name: 'ModificaUtente',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Admin_ModificaUtente__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Modifica Utente'
    }
  }, {
    path: '/admin/rinnova/:userId',
    name: 'RinnovaAbbonamento',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Admin_RinnovaAbbonamento_vue__["a" /* default */],
    meta: {
      auth: true,
      title: 'GiustUp - Rinnova Abbonamento'
    }
  }, {
    path: '/massima/:idMassima',
    name: 'Massima',
    component: __WEBPACK_IMPORTED_MODULE_22__components_Pubblica_Massima__["a" /* default */],
    meta: {
      auth: false,
      title: 'GiustUp - Massima'
    }
  }, {
    path: '/massime',
    name: 'RicercaMassime',
    component: __WEBPACK_IMPORTED_MODULE_23__components_Pubblica_Ricerca__["a" /* default */],
    meta: {
      auth: false,
      title: 'GiustUp - Ricerca massime'
    }
  }, {
    path: '/newslettermassime',
    name: 'NewsletterMassime',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Pubblica_Newsletter__["a" /* default */],
    meta: {
      auth: false,
      title: 'GiustUp - Newsletter massime'
    }
  }, {
    path: '/ultimemassime',
    name: 'UltimeMassime',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Pubblica_UltimeMassime__["a" /* default */],
    meta: {
      auth: false,
      title: 'GiustUp - Ultime massime inserite'
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      var y = 0;
      if (to.name === "Search" && from.name === "Sentenza" && to.params.scrollY) y = to.params.scrollY;
      return { x: 0, y: y };
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_baseUrl_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utils_js__ = __webpack_require__(42);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "home",

    mounted: function mounted() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.checkLogged();

                        case 2:
                            if (!_context.sent) {
                                _context.next = 4;
                                break;
                            }

                            _this.$router.replace({ name: "Search" });

                        case 4:
                            _this.checkCookie();

                            //se la pagina è caricata, nascondi l'elemento con id nav-collapse
                            document.addEventListener("DOMContentLoaded", function (event) {
                                document.getElementById("nav-collapse").style.display = "none !important;";
                            });

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },


    methods: {
        // codice copypastato di nuovo
        registra: function registra() {
            if (this.ControllaCF(document.getElementById("txt_cod_fisc").value)) {
                var cod_fisc = document.getElementById("txt_cod_fisc").value.toUpperCase();
                __WEBPACK_IMPORTED_MODULE_5__services_utils_js__["a" /* default */].setCookie("cod_fisc", cod_fisc, 365);

                //send other URL params
                var params = window.location.search;
                if (params == "" || params === undefined) params = "?utm_source=other";
                //send other URL params
                location.href = __WEBPACK_IMPORTED_MODULE_4__services_baseUrl_js__["a" /* default */].getBaseUrlFrontend() + params + "&codfisc=" + cod_fisc;
            } else {
                alert("Codice fiscale non valido!");
            }
        },
        ControllaCF: function ControllaCF(cf) {
            cf = cf.toUpperCase();
            if (cf == '') return false;
            if (!/^[0-9A-Z]{16}$/.test(cf)) return false;
            var map = [1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 1, 0, 5, 7, 9, 13, 15, 17, 19, 21, 2, 4, 18, 20, 11, 3, 6, 8, 12, 14, 16, 10, 22, 25, 24, 23];
            var s = 0;
            for (var i = 0; i < 15; i++) {
                var c = cf.charCodeAt(i);
                if (c < 65) {
                    c = c - 48;
                } else {
                    c = c - 55;
                }

                if (i % 2 == 0) s += map[c];else s += c < 10 ? c : c - 10;
            }
            var atteso = String.fromCharCode(65 + s % 26);
            if (atteso != cf.charAt(15)) return false;
            return true;
        },
        checkCookie: function checkCookie() {
            var user = __WEBPACK_IMPORTED_MODULE_5__services_utils_js__["a" /* default */].getCookie("cod_fisc");
            if (user != "") {
                document.getElementById("txt_cod_fisc").value = user;
            }
        },
        addScript: function addScript(options) {
            var script = document.createElement("script");
            if ((typeof options === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options)) === "object") for (var option in options) {
                script.setAttribute(option, options[option]);
            }
            document.body.appendChild(script);
            return script;
        },
        checkLogged: function checkLogged() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('get', 'oauth');

                            case 2:
                                data = _context2.sent;
                                return _context2.abrupt('return', data);

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this2);
            }))();
        }
    }
});

/***/ }),
/* 208 */,
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ResultDiMerito_vue__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ResultAmministrative_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Sentenza_Commento_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_search_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_service_js__ = __webpack_require__(13);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'search',
  components: { ResultDiMerito: __WEBPACK_IMPORTED_MODULE_8__ResultDiMerito_vue__["a" /* default */], ResultAmministrative: __WEBPACK_IMPORTED_MODULE_9__ResultAmministrative_vue__["a" /* default */], Commento: __WEBPACK_IMPORTED_MODULE_10__Sentenza_Commento_vue__["a" /* default */], InfiniteLoading: __WEBPACK_IMPORTED_MODULE_5_vue_infinite_loading___default.a, Loading: __WEBPACK_IMPORTED_MODULE_6_vue_loading_overlay___default.a },
  data: function data() {
    return {
      form: {
        query: '',
        ordinamento: 'data'
      },
      formDiMerito: {
        tribunale: '',
        materia: '*',
        numero_sentenza: '',
        anno_sentenza: '',
        numero_rg: '',
        anno_rg: '',
        nome_giudice: '',
        cf_giudice: '',
        page: 1
      },
      filterMaterie: {
        liv1: '',
        liv2: ''
      },
      formAmministrative: {
        sede: '',
        numero_provvedimento: '',
        anno_provvedimento: '',
        page: 1
      },
      loading: 0,
      results: {
        diMerito: {
          records: null,
          totalNum: "..."
        },
        amministrative: {
          records: null,
          totalNum: "..."
        }
      },
      data: {
        tribunali: [],
        materie: [],
        materie1: [],
        materie2: [],
        sediAmministrative: [],
        ordinamento: [{
          value: 'data',
          text: 'Data'
        }, {
          value: 'attinenza',
          text: 'Attinenza'
        }]
      },
      commenti: [],
      numeroSentenze: {
        diMerito: '',
        amministrative: ''
      },
      activeTab: 0
    };
  },

  methods: {
    formatNumberSentenze: function formatNumberSentenze(value) {
      return new Intl.NumberFormat('it-IT').format(value);
    },
    checkLogged: function checkLogged() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_service_js__["a" /* default */].execute('get', 'oauth');

              case 2:
                data = _context.sent;
                return _context.abrupt('return', data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    searchNew: function searchNew() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all([_this2.searchNewDiMerito(), _this2.searchNewAmministrative()]);

              case 2:

                if (_this2.$refs.infiniteLoading) {
                  _this2.$refs.infiniteLoading.stateChanger.reset();
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    searchNewDiMerito: function searchNewDiMerito() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formDiMerito.page = 1;
                _this3.results.diMerito.records = [];
                _context3.next = 4;
                return _this3.searchDiMerito();

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    searchNewAmministrative: function searchNewAmministrative() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.formAmministrative.page = 1;
                _this4.results.amministrative.records = [];
                _context4.next = 4;
                return _this4.searchAmministrative();

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },

    // Esegue search ma avanzando di pagina
    searchDiMerito: function searchDiMerito() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var _results$diMerito$rec;

        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this5.loading++;
                data = [];
                _context5.prev = 2;
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].searchDiMerito(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this5.formDiMerito, _this5.form));

              case 5:
                data = _context5.sent;
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](2);

                alert("Errore durante la ricerca!");
                console.log(_context5.t0);

              case 12:
                _this5.results.diMerito.totalNum = data.totalNum;

                (_results$diMerito$rec = _this5.results.diMerito.records).push.apply(_results$diMerito$rec, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.sentenze));

                _this5.formDiMerito.page += 1;
                _this5.loading--;
                return _context5.abrupt('return', data.sentenze.length);

              case 17:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[2, 8]]);
      }))();
    },
    infiniteHandlerDiMerito: function infiniteHandlerDiMerito($state) {
      if (this.results.diMerito.records.length) {
        this.searchDiMerito().then(function (res) {
          if (res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },

    // Esegue search ma avanzando di pagina
    searchAmministrative: function searchAmministrative() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var _results$amministrati;

        var data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this6.loading++;
                data = [];
                _context6.prev = 2;
                _context6.next = 5;
                return __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].searchAmministrative(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this6.formAmministrative, _this6.form));

              case 5:
                data = _context6.sent;
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](2);

                alert("Errore durante la ricerca!");
                console.log(_context6.t0);

              case 12:
                _this6.results.amministrative.totalNum = data.totalNum;

                (_results$amministrati = _this6.results.amministrative.records).push.apply(_results$amministrati, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data.sentenze));

                _this6.formAmministrative.page += 1;
                _this6.loading--;
                return _context6.abrupt('return', data.sentenze.length);

              case 17:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6, [[2, 8]]);
      }))();
    },
    infiniteHandlerAmministrative: function infiniteHandlerAmministrative($state) {
      if (this.results.amministrative.records.length) {
        this.searchAmministrative().then(function (res) {
          if (res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },
    changeMateria1: function changeMateria1(value) {
      var _this7 = this;

      // clean old second level to avoid sending it as a filter
      this.filterMaterie.liv2 = '';
      __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].getMaterie(this.filterMaterie).then(function (data) {
        _this7.data.materie2 = data;
        // update the default value of materia2 to be "Qualsiasi"
        _this7.filterMaterie.liv2 = value;
        // update the default value of materia to be "Qualsiasi"
        _this7.formDiMerito.materia = value + '*';
      });
    },
    changeMateria2: function changeMateria2(value) {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].getMaterie(this.filterMaterie).then(function (data) {
        _this8.data.materie = data;
        // update the default value of materia to be "Qualsiasi"
        _this8.formDiMerito.materia = value + '*';
      });
    },
    pulisciFiltriDiMerito: function pulisciFiltriDiMerito() {
      this.formDiMerito.tribunale = '';
      this.formDiMerito.materia = '*';
      this.formDiMerito.numero_sentenza = '';
      this.formDiMerito.anno_sentenza = '';
      this.formDiMerito.numero_rg = '';
      this.formDiMerito.anno_rg = '';
      this.formDiMerito.nome_giudice = '';
      this.formDiMerito.cf_giudice = '';
      this.filterMaterie.liv1 = '';
      this.filterMaterie.liv2 = '';
    },
    pulisciFiltriAmministrative: function pulisciFiltriAmministrative() {
      this.formAmministrative.sede = '';
      this.formAmministrative.numero_provvedimento = '*';
      this.formAmministrative.anno_provvedimento = '';
    },
    getCommenti: function getCommenti() {
      var _this9 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_service_js__["a" /* default */].execute('get', 'commento');

              case 2:
                _this9.commenti = _context7.sent;

              case 3:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    },
    getNumeroSentenze: function getNumeroSentenze() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee8() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return __WEBPACK_IMPORTED_MODULE_12__services_service_js__["a" /* default */].execute('get', 'cercasentenze/numero');

              case 2:
                _this10.numeroSentenze = _context8.sent;

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    }
  },

  created: function created() {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this11.checkLogged();

            case 2:
              if (_context9.sent) {
                _context9.next = 4;
                break;
              }

              _this11.$router.push({ name: "Home" });

            case 4:
              _context9.next = 6;
              return __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].getTribunali();

            case 6:
              data = _context9.sent;

              _this11.data.tribunali = data;

              _context9.next = 10;
              return __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].getMaterie(_this11.filterMaterie);

            case 10:
              data = _context9.sent;

              _this11.data.materie1 = data;

              _context9.next = 14;
              return __WEBPACK_IMPORTED_MODULE_11__services_search_js__["a" /* default */].getSediAmministrative();

            case 14:
              data = _context9.sent;

              _this11.data.sediAmministrative = data;

              _this11.getCommenti();
              _this11.getNumeroSentenze();
              _this11.$parent._data.loaded = true;
              // this.$router.push({ name: "Home"}  )

            case 19:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this11);
    }))();
  },

  watch: {
    activeTab: function activeTab(newIndex) {
      localStorage.setItem('my-active-tab', newIndex);
    }
  },
  mounted: function mounted() {
    var saved = localStorage.getItem('my-active-tab');
    if (saved !== null) {
      this.activeTab = Number(saved);
    }
  }
});

/***/ }),
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_js__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var getScrollYWrapper = function getScrollYWrapper() {
  return window.scrollY;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      base_url: __WEBPACK_IMPORTED_MODULE_1__services_service_js__["a" /* default */].getBaseUrl()
    };
  },

  props: {
    sentenza: {
      idNodo: String,
      titolo: String,
      contenuto: String,
      idAtto: Number,
      idFascicolo: Number,
      codiceUfficio: String,
      materia: String,
      materiaLiv1: String,
      materiaLiv2: String,
      codiceOggetto: String,
      nomeGiudice: String,
      cfGiudice: String,
      parte: String,
      controparte: String,
      numeroSentenza: Number,
      annoSentenza: Number,
      numeroRuolo: Number,
      annoRuolo: Number,
      gradoGiudizio: String,
      codiceSezione: String,
      attestazione: Date,
      ultimaModifica: Date
    },
    filters: Object,
    index: Number
  },
  methods: {
    goToSentenza: function goToSentenza() {
      this.$router.push({
        name: 'Sentenza',
        params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.sentenza, {
          type: 'diMerito',
          filters: this.filters,
          index: this.index,
          scrollY: getScrollYWrapper()
        })
      });
    }
  }
});

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getScrollYWrapper = function getScrollYWrapper() {
  return window.scrollY;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      base_url: __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].getBaseUrl()
    };
  },

  props: {
    sentenza: {
      idNodo: String,
      titolo: String,
      contenuto: String,
      sede: String,
      sezione: String,
      numRicorso: String,
      annoProvvedimento: String,
      numProvvedimento: String
    },
    filters: Object,
    index: Number
  },
  methods: {
    goToSentenza: function goToSentenza() {
      this.$router.push({
        name: 'Sentenza',
        params: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.sentenza, {
          type: 'amministrativa',
          filters: this.filters,
          index: this.index,
          scrollY: getScrollYWrapper()
        })
      });
    }
  }
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commento_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515d1f22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commento_vue__ = __webpack_require__(473);
function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Commento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_515d1f22_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Commento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utils_js__ = __webpack_require__(42);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      commento: {},
      imgLink: '',
      data: '',
      testo: ''
    };
  },

  props: {
    input: {
      id: Number,
      codFisc: String,
      avvocato: String,
      testo: String,
      premassima: String,
      dataInserimento: String,
      numeroLike: Number,
      like: Boolean,
      sentenzaId: String,
      sentenzaTitolo: String,
      sentenzaMateria: String,
      numeroVisualizzazioni: Number
    },
    showCommenta: Boolean,
    showTitoloSentenza: Boolean,
    showVisualizzazioni: Boolean
  },
  methods: {
    mettiLike: function mettiLike() {
      var _this = this;

      var url = 'commento/' + this.commento.id + '/like';
      __WEBPACK_IMPORTED_MODULE_0__services_service_js__["a" /* default */].execute('post', url).then(function (data) {
        _this.getCommento();
      });
    },
    getCommento: function getCommento() {
      var _this2 = this;

      var url = 'commento/id/' + this.commento.id;
      __WEBPACK_IMPORTED_MODULE_0__services_service_js__["a" /* default */].execute('get', url).then(function (data) {
        _this2.commento = data;
      });
    }
  },
  created: function created() {
    this.commento = this.input;

    this.imgLink = __WEBPACK_IMPORTED_MODULE_1__services_utils_js__["a" /* default */].getAvatarUrl(this.input.codFisc);
    this.data = __WEBPACK_IMPORTED_MODULE_1__services_utils_js__["a" /* default */].formatDate(new Date(this.input.dataInserimento));
    this.testo = __WEBPACK_IMPORTED_MODULE_1__services_utils_js__["a" /* default */].cleanHtml(this.input.testo);
  }
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_oauth_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'thankyou',
  data: function data() {
    return {
      scelta: null,
      showRipristina: false,
      codFisc: null,
      showLogin: false,
      showRegistrazione: false
    };
  },

  methods: {
    login: function login(provider) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var prov, uri;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                prov = __WEBPACK_IMPORTED_MODULE_3__services_oauth_js__["a" /* default */].get(provider);


                prov.options.query.state.provider = provider;
                prov.options.query.state.redirect = _this.$route.query.redirect;
                prov.options.query.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(prov.options.query.state);
                uri = prov.code.getUri();


                location.href = uri;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ripristina: function ripristina() {
      var _this2 = this;

      var data = { 'codfisc': this.$route.query.codfisc };

      __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('post', 'utente/ripristina', data, true).then(function (data) {
        if (data.status === 200) // ok può fare login
          {
            _this2.showLogin = false;
            _this2.showRegistrazione = true;
            alert('Ti arriverà a breve una PEC con un link per associare un account social per eseguire il login.');
          }
      });
    },
    checkLogged: function checkLogged() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('get', 'oauth');

              case 2:
                data = _context2.sent;
                return _context2.abrupt('return', data);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var parameters, logged, body, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              parameters = _this4.$route.query;
              _context3.next = 3;
              return _this4.checkLogged();

            case 3:
              logged = _context3.sent;

              if (!logged) {
                _context3.next = 8;
                break;
              }

              _this4.$router.push({ name: "Search" });
              _context3.next = 19;
              break;

            case 8:
              if (!(parameters.codfisc === undefined || parameters.codfisc === "")) {
                _context3.next = 12;
                break;
              }

              //TODO: change redirect to something appropriate 
              //TODO: figure out how to redirect to another component
              // location.href = "https://google.com"
              //FIXME: use the line below
              _this4.$router.push({ name: "Home" });
              // location.href = "https://landing.giustup.it/";
              _context3.next = 19;
              break;

            case 12:
              body = {
                'codfisc': parameters.codfisc,
                'source': parameters.utm_source
              };
              _context3.next = 15;
              return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('post', 'utente/provider', body, true);

            case 15:
              data = _context3.sent;

              _this4.codFisc = parameters.codfisc.toUpperCase();
              if (data.status === 200) // ok può fare login
                {
                  _this4.scelta = data.data;
                  _this4.showLogin = true;
                } else if (data.status === 201) // appena registrato
                {
                  _this4.showRegistrazione = true;
                } else if (data.status === 204) // non attivo
                {
                  _this4.showRegistrazione = true;
                }

              _this4.$parent._data.loaded = true;

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PdfTron_PdfTron_vue__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sentenza_Commento_vue__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_editor__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_search_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_quill__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_quill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_quill__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sentenza',
  components: {
    PdfTron: __WEBPACK_IMPORTED_MODULE_4__PdfTron_PdfTron_vue__["a" /* default */],
    VueEditor: __WEBPACK_IMPORTED_MODULE_6_vue2_editor__["a" /* VueEditor */],
    Loading: __WEBPACK_IMPORTED_MODULE_7_vue_loading_overlay___default.a,
    Commento: __WEBPACK_IMPORTED_MODULE_5__Sentenza_Commento_vue__["a" /* default */]
  },
  data: function data() {
    return {
      commentoInput: '',
      premassimaInput: '',
      commenti: [],
      lastUpdate: null,
      loading: false,
      customToolbar: [["bold", "italic", "underline", "strike", { list: "ordered" }, { list: "bullet" }, { color: [] }, { background: [] }]],
      idSentenza: this.$route.params.idNodo,
      me: {},
      numeroVisualizzazioni: '',
      testoRicerca: this.$route.params.filters ? this.$route.params.filters.query : "",
      //params for choosing the next and previous sentenza
      showPreviousSentenza: false,
      showNextSentenza: false,
      previousSentenzaParams: {},
      nextSentenzaParams: {},
      numSentenza: null,
      totSentenze: null,
      searchText: this.$route.params.searchText,
      searchOptions: this.$route.params.searchOptions
    };
  },

  methods: {
    getPdfUrl: function getPdfUrl() {
      return __WEBPACK_IMPORTED_MODULE_9__services_service_js__["a" /* default */].getBaseUrl() + "cercasentenze/" + this.idSentenza;
    },
    getCommenti: function getCommenti() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_service_js__["a" /* default */].execute('get', 'commento/' + _this.idSentenza);

              case 2:
                _this.commenti = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getVisualizzazioni: function getVisualizzazioni() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_service_js__["a" /* default */].execute('get', 'cercasentenze/visualizzazioni/' + _this2.idSentenza);

              case 2:
                _this2.numeroVisualizzazioni = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    pubblicaCommento: function pubblicaCommento() {
      var _this3 = this;

      if (this.premassimaInput === '') {
        alert("Inserire una premassima nell'apposita casella.");
        return;
      }
      if (this.commentoInput === '') {
        alert("Inserire un testo per il commento nell'apposita casella.");
        return;
      }

      this.loading = true;

      var data = {
        testo: this.commentoInput,
        premassima: this.premassimaInput,
        sentenzaId: this.idSentenza

        //send commento
      };__WEBPACK_IMPORTED_MODULE_9__services_service_js__["a" /* default */].execute('post', 'commento', data, true).then(function (resp) {
        if (resp.status === 201) {
          _this3.getCommenti();
          _this3.commentoInput = '';
          _this3.premassimaInput = '';

          var content = '\n            Il commento \xE8 stato inserito, ma prima di essere visibile \xE8 necessario che venga approvato da un amministratore.\n            Ricordati inoltre di mantenere aggiornato il tuo profilo. Per aggiornare il tuo profilo adesso clicca QUI.\n          ';
          _this3.$bvToast.toast(content, {
            title: 'Commento inserito!',
            variant: 'primary',
            solid: true,
            autoHideDelay: 15000,
            to: { name: 'ModificaUtente' },
            bodyClass: 'text-decoration-none'
          });

          _this3.loading = false;
        } else {
          _this3.loading = false;
          alert("Qualcosa è andato storto, riprova o contatta un amministratore per favore.");
        }
      });
    },
    getProfiloLoggato: function getProfiloLoggato() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__services_service_js__["a" /* default */].execute('get', 'profilo/me');

              case 2:
                data = _context3.sent;

                _this4.me = data;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getPrevNextSentenze: function getPrevNextSentenze() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var type, form, absIndex, searchFunc, data, sentenze, myIndex, dataPrev, dataSucc, scrollY;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                type = _this5.$route.params.type;
                form = _this5.$route.params.filters;
                absIndex = _this5.$route.params.index;

                if (!(form === undefined || absIndex === undefined)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                form.page = Math.floor(absIndex / 20) + 1;
                searchFunc = type === 'diMerito' ? __WEBPACK_IMPORTED_MODULE_10__services_search_js__["a" /* default */].searchDiMerito : __WEBPACK_IMPORTED_MODULE_10__services_search_js__["a" /* default */].searchAmministrative;
                _context4.next = 9;
                return searchFunc(form);

              case 9:
                data = _context4.sent;
                sentenze = data.sentenze;
                myIndex = sentenze.findIndex(function (x) {
                  return x.idNodo === _this5.idSentenza;
                });

                if (!(myIndex === 0 && form.page > 1)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 15;
                return searchFunc(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, form, { page: form.page - 1 }));

              case 15:
                dataPrev = _context4.sent;

                sentenze = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataPrev.sentenze), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sentenze));
                _context4.next = 29;
                break;

              case 19:
                if (!(myIndex === sentenze.length - 1)) {
                  _context4.next = 29;
                  break;
                }

                _context4.prev = 20;
                _context4.next = 23;
                return searchFunc(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, form, { page: form.page + 1 }));

              case 23:
                dataSucc = _context4.sent;

                sentenze = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(sentenze), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(dataSucc.sentenze));
                _context4.next = 29;
                break;

              case 27:
                _context4.prev = 27;
                _context4.t0 = _context4['catch'](20);

              case 29:
                myIndex = sentenze.findIndex(function (x) {
                  return x.idNodo === _this5.idSentenza;
                });

                _this5.numSentenza = absIndex + 1;
                _this5.totSentenze = data.totalNum;

                scrollY = _this5.$route.params.scrollY;


                if (!(myIndex === 0 && form.page === 1)) {
                  //not the first sentenza of the first page
                  _this5.previousSentenzaParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, sentenze[myIndex - 1], {
                    type: type,
                    filters: form,
                    index: absIndex - 1,
                    scrollY: scrollY
                  });
                  _this5.showPreviousSentenza = true;
                }
                if (!(absIndex + 1 === data.totalNum)) {
                  //not the last sentenza
                  _this5.nextSentenzaParams = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, sentenze[myIndex + 1], {
                    type: type,
                    filters: form,
                    index: absIndex + 1,
                    scrollY: scrollY
                  });
                  _this5.showNextSentenza = true;
                }

              case 35:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[20, 27]]);
      }))();
    }
  },
  created: function created() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this6.$parent._data.loaded = true;

              //await this.getCommenti();
              _context5.next = 3;
              return _this6.getProfiloLoggato();

            case 3:
              _context5.next = 5;
              return _this6.getVisualizzazioni();

            case 5:

              //show or hide previous and next sentenza buttons
              _this6.getPrevNextSentenze();

              //to clean pasted html from PDF
              /*
              this.$refs.editor.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
                  var plaintext = node.innerText.split('\n').join(' ');
                  while (plaintext.indexOf('  ') !== -1){
                    plaintext = plaintext.split('  ').join(' ');
                  }
                  var Delta = Quill.import('delta');
                  let result = new Delta().insert(plaintext);
                  return result;
              });*/

            case 6:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  },
  updated: function updated() {
    /*
    var ref = this
    this.$nextTick(function () {
      if(typeof ref.$refs.editor != 'undefined'){
        let el = document.getElementsByClassName("quillWrapper")[0];
        if(el !== undefined)
          el.onkeydown = function(evt) {
            evt = evt.stopPropagation();
          };
      }
    })*/
  },

  watch: {
    $route: function $route(to, from) {
      /*
      if(to.name === "Sentenza")
        this.getCommenti();
        */
    }
  }
});

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pdftron_webviewer__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pdftron_webviewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pdftron_webviewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_baseUrl__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_search__ = __webpack_require__(62);
//
//
//
//
//
//
//
//







var client = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: __WEBPACK_IMPORTED_MODULE_3__services_baseUrl__["a" /* default */].getBaseUrl(),
  withCredentials: true
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pdfTron',
  serverCacheKey: function serverCacheKey(props) {
    return null;
  },
  props: {
    src: String,
    searchText: String,
    searchOptions: Object
  },
  emits: ['update:searchText', 'update:searchOptions'],
  data: function data() {
    return {
      webViewerInstance: null
    };
  },

  methods: {
    init: function init() {
      var _this = this;

      var pdfUrl = this.src;

      var container = document.getElementById('pdftron');
      container.innerHTML = '';
      __WEBPACK_IMPORTED_MODULE_0__pdftron_webviewer___default()({
        path: window.location.origin + '/static/pdfTron'
      }, container).then(function (instance) {
        var getPdfBlob = function getPdfBlob(data) {
          var arrayBuffer = Buffer.from(data, 'binary');
          var arr = new Uint8Array(arrayBuffer);
          var blob = new Blob([arr], { type: 'application/pdf' });
          return blob;
        };
        var loadDocument = function loadDocument(data) {
          var blob = getPdfBlob(data);
          instance.loadDocument(blob);
        };

        client({
          url: pdfUrl,
          responseType: 'arraybuffer'
        }, {
          withCredentials: true
        }).then(function (req) {
          loadDocument(req.data);

          // show print and download buttons in the header
          instance.setHeaderItems(function (header) {
            header.push({
              type: 'actionButton',
              img: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><defs><style>.cls-1{fill:#abb0c4;}</style></defs><title>icon - header - print - line</title><path class="cls-1" d="M20,6H18V2H6V6H4A2,2,0,0,0,2,8v9a2,2,0,0,0,2,2H6v3H18V19h2a2,2,0,0,0,2-2V8A2,2,0,0,0,20,6ZM8,4h8V6H8Zm8,16H8V16h8Zm4-3H18V14H6v3H4V8H20Zm-4-7h2v2H16Zm-3,0h2v2H13Z"></path></svg>',
              onClick: function onClick() {
                instance.print();
              }
            });
            header.push({
              type: 'actionButton',
              img: '<svg class="downloadIcon" width="80" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 24">\n                        <text x="25" y="16" fill="black">Scarica</text>\n                        <defs><style>.cls-1{fill:#abb0c4;}</style></defs>\n                        <title>icon - header - download</title>\n                        <path class="cls-1" d="M11.55,17,5.09,9.66a.6.6,0,0,1,.45-1H8.67V2.6a.6.6,0,0,1,.6-.6h5.46a.6.6,0,0,1,.6.6V8.67h3.13a.6.6,0,0,1,.45,1L12.45,17A.6.6,0,0,1,11.55,17ZM3.11,20.18V21.6a.4.4,0,0,0,.4.4h17a.4.4,0,0,0,.4-.4V20.18a.4.4,0,0,0-.4-.4h-17A.4.4,0,0,0,3.11,20.18Z"></path>\n                       </svg>\n                ',
              onClick: function onClick() {
                var blob = getPdfBlob(req.data);
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = "Sentenza";
                link.click();
                URL.revokeObjectURL(link.href);
              }
            });
          });

          // adjust the style to properly show the download icon
          var downloadIcon = __WEBPACK_IMPORTED_MODULE_2_jquery___default()("#pdftron iframe").contents().find('.downloadIcon');
          downloadIcon.parent().css("width", "auto");
          downloadIcon.parent().parent().css("width", "auto");
        }).catch(function (error) {
          if (error.response !== undefined && error.response.status === 505) {
            /* Visualizzazione limitata della sentenza
             //abbonamento scaduto, tolgo selezione del testo
            loadDocument(error.response.data);
             instance.disableFeatures([instance.Feature.TextSelection, instance.Feature.Search]);
            instance.disableElements(['printButton', 'downloadButton', 'searchPanel']);
             // Mostro solamente poche righe del documento per volta
            $("#pdftron iframe").contents().find(".document-content-container").css("max-height", "100px");
             this.$modal.show('dialog', {
              title: 'Non sei abbonato alla rivista',
              text: "L'accesso libero non consente di <b>cercare</b> e <b>copiare</b> il testo e di stampare o scaricare la sentenza. Inoltre la visualizzazione della stessa è limitata.",
              buttons: [
                {
                  title: 'Chiudi',
                  handler: () => {
                    this.$modal.hide('dialog')
                  }
                },
                {
                  title: 'Abbonati',
                  handler: () => {
                    location.href = "/utente";
                  }
                }
              ]
            })
            */

            _this.$modal.show('dialog', {
              title: 'Non sei abbonato alla rivista',
              text: "Abbonati per poter visualizzare la sentenza.",
              buttons: [{
                title: 'Chiudi',
                handler: function handler() {
                  _this.$modal.hide('dialog');
                }
              }, {
                title: 'Abbonati',
                handler: function handler() {
                  location.href = "/utente";
                }
              }]
            });
          }
        });

        var docViewer = instance.docViewer;
        var annotManager = instance.annotManager;
        // call methods from instance, docViewer and annotManager as needed

        // you can also access major namespaces from the instance as follows:
        // const Tools = instance.Tools;
        // const Annotations = instance.Annotations;

        instance.setReadOnly(true);
        instance.setLanguage('it');
        instance.disableElements(['toggleNotesButton']);

        docViewer.on('documentLoaded', function () {
          instance.searchTextFull(_this.searchText, _this.searchOptions);
        });
        instance.addSearchListener(function (searchValue, options, results) {
          _this.$emit('update:searchText', searchValue);
          _this.$emit('update:searchOptions', options);
        });

        // hide the gear button
        instance.disableElements(['menuButton']);

        if (!_this.isMobile()) {
          instance.openElements(['searchPanel']);

          docViewer.on('documentLoaded', function () {
            instance.setZoomLevel("150%");
          });
        }

        _this.webViewerInstance = instance;
      });
    },
    isMobile: function isMobile() {
      return 'ontouchstart' in document.documentElement;
    }
  },
  activated: function activated() {
    this.init();
  },
  deactivated: function deactivated() {
    this.webViewerInstance.dispose();
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(218).Buffer))

/***/ }),
/* 218 */,
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'privacy',
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.$parent._data.loaded = true;

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_oauth_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'oauth',
  data: function data() {
    return {};
  },

  methods: {
    sendToken: function sendToken(updatedUser) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var router, state, _data, res, data;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                router = _this.$router;
                state = JSON.parse(_this.$route.query.state);


                console.log(updatedUser);

                if (!state.attivazioneToken) {
                  _context.next = 9;
                  break;
                }

                //associazione social
                _data = {
                  token: state.attivazioneToken,
                  provider: state.provider,
                  oauth: updatedUser.accessToken
                };
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('post', 'utente/associaSocial', _data, true);

              case 7:
                res = _context.sent;


                if (res.status === 200) // associato
                  {} else {
                  alert("Errore di associazione! Riprovare o contattare un amministratore!");
                }

              case 9:
                data = {
                  token: updatedUser.accessToken,
                  provider: state.provider
                };

                __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('post', 'oauth', data, true).then(function (data) {
                  if (state.redirect) {
                    router.push(state.redirect);
                  } else {
                    router.push({ name: "Search" });
                  }
                });

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var state, provider, code, opt, sendToken;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = JSON.parse(_this2.$route.query.state);


              console.log("provider", state.provider);

              provider = __WEBPACK_IMPORTED_MODULE_2__services_oauth_js__["a" /* default */].get(state.provider);
              code = _this2.$route.query.code;
              opt = { //because of Facebook
                query: {
                  'code': code,
                  'client_id': provider.options.clientId,
                  'redirect_uri': provider.options.redirectUri,
                  'client_secret': provider.options.clientSecret
                }
              };
              sendToken = _this2.sendToken;


              provider.code.getToken(location.href, opt).then(function (user) {
                console.log(user);
                if (user.refreshToken) {
                  user.refresh().then(function (updatedUser) {
                    sendToken(updatedUser);
                  });
                } else {
                  sendToken(user);
                }
              });

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import router from '../../router/index.js';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'utente',
  data: function data() {
    return {
      stato: '',
      dataScadenza: '',
      giorniRimasti: '',
      giorniNelMese: ''
    };
  },

  methods: {},
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'utente/info');

            case 2:
              data = _context.sent;

              _this.giorniRimasti = data.giorniRimasti;
              _this.stato = data.attivo ? 'ATTIVO' : 'SCADUTO';
              _this.dataScadenza = new Date(data.dataScadenza).ddmmyyyy();
              _this.giorniNelMese = data.giorniUtilizzoNelMese + (data.attivo ? " giorni" : " giorni su un massimo di 3 giorni");

              _this.$parent._data.loaded = true;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilo',
  data: function data() {
    return {
      codFisc: this.$route.params.codFisc,
      profilo: {},
      commenti: []
    };
  },

  methods: {
    getAvatarUrl: function getAvatarUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].getBaseUrl() + 'utente/' + this.codFisc + '/immagine?nocache=' + Math.random();
    },
    getCvUrl: function getCvUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].getBaseUrl() + 'utente/' + this.codFisc + '/cv';
    },
    getUser: function getUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'profilo/' + _this.codFisc);

              case 2:
                data = _context.sent;

                _this.profilo = data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCommenti: function getCommenti() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'profilo/' + _this2.codFisc + '/commenti');

              case 2:
                data = _context2.sent;

                _this2.commenti = data;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    formatDate: function formatDate(d) {
      return ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
    },
    cleanHtml: function cleanHtml(html) {
      if (html === null || html === undefined) return null;
      return html.split('&nbsp;').join(' ');
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'utente/info');

            case 2:
              _context3.next = 4;
              return _this3.getUser();

            case 4:
              _context3.next = 6;
              return _this3.getCommenti();

            case 6:

              _this3.$parent._data.loaded = true;

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ordiniDiAppartenenza_js__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_editor__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar_cropper__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_avatar_cropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_avatar_cropper__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modificaProfilo',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_4_vue2_editor__["a" /* VueEditor */],
    AvatarCropper: __WEBPACK_IMPORTED_MODULE_5_vue_avatar_cropper___default.a
  },
  data: function data() {
    return {
      profilo: {},
      customToolbar: [["bold", "italic", "underline", "strike", { list: "ordered" }, { list: "bullet" }, { color: [] }, { background: [] }]],
      data: {
        ordine: __WEBPACK_IMPORTED_MODULE_3__ordiniDiAppartenenza_js__["a" /* default */]
      },
      userAvatar: '',
      fileCv: null
    };
  },

  methods: {
    handleUploaded: function handleUploaded(response, form, xhr) {
      this.userAvatar = undefined;
      this.userAvatar = this.getAvatarUrl();
    },
    getAvatarUrl: function getAvatarUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].getBaseUrl() + 'utente/' + this.profilo.codFisc + '/immagine?nocache=' + Math.random();
    },
    getUploadAvatarUrl: function getUploadAvatarUrl() {
      return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].getBaseUrl() + 'utente/immagine';
    },
    getUser: function getUser() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'profilo/me');

              case 2:
                data = _context.sent;

                _this.profilo = data;
                _this.userAvatar = _this.getAvatarUrl();

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    aggiornaProfilo: function aggiornaProfilo() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.profilo.annoIscrizoneOrdine = parseInt(_this2.profilo.annoIscrizoneOrdine);
                _context2.prev = 1;
                _context2.next = 4;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('post', 'profilo', _this2.profilo);

              case 4:
                data = _context2.sent;

                alert("Profilo salvato con successo!");
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                alert("Errore durante il salvataggio!");

              case 11:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8]]);
      }))();
    },
    caricaCv: function caricaCv() {
      var _this3 = this;

      if (this.fileCv == null || this.fileCv === undefined) {
        alert("Selezionare un file PDF da caricare!");
        return;
      }

      var formData = new FormData();

      formData.append("files", this.fileCv);
      __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('post', 'utente/cv', formData).then(function (data) {
        _this3.getUser();
        alert("CV caricato con successo!");
      });
    }
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.getUser();

            case 2:

              _this4.$parent._data.loaded = true;

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__province_json__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__province_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__province_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_pagamento_js__ = __webpack_require__(509);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'pagamento',
    data: function data() {
        return {
            tipoPagamento: 'bonifico',
            tipoPagamentoOptions: [{ value: 'bonifico', text: 'Bonifico' }, { value: 'paypal', text: 'PayPal/Carta di credito' }],
            provincia: null,
            provinciaOptions: [{ value: null, text: "Provincia", disabled: true }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__province_json___default.a)),
            showBonifico: false,
            showPaypal: false,
            denominazione: "",
            citta: "",
            indirizzo: "",
            cap: "",
            email: "",
            cf: "",
            piva: "",
            telefono: ""
        };
    },

    methods: {
        pagamento: function pagamento() {
            var _this = this;

            //check params
            var err = "";
            if (this.denominazione === "") err = "Campo denominazione incompleto!";else if (this.citta === "") err = "Campo città incompleto!";else if (this.indirizzo === "") err = "Campo indirizzo incompleto!";else if (this.cap === "") err = "Campo CAP incompleto!";else if (this.provincia == null) err = "Campo provincia incompleto!";else if (this.email === "") err = "Campo email incompleto!";else if (this.cf === "") err = "Campo CF incompleto!";
            //else if(this.piva == "")
            //    err = "Campo Partita IVA incompleto!";
            if (err != "") {
                alert(err);
                return;
            }

            //send post request
            var data = {
                denominazione: this.denominazione,
                citta: this.citta,
                indirizzo: this.indirizzo,
                cap: this.cap,
                provincia: this.provincia,
                email: this.email,
                cf: this.cf,
                piva: this.piva,
                telefono: this.telefono,
                tipoPagamento: this.tipoPagamento,
                regimeForfettario: this.regimeForfettario
            };
            __WEBPACK_IMPORTED_MODULE_5__services_pagamento_js__["a" /* default */].pagamento(data).then(function (res) {
                console.log(res);

                //show info about payment
                _this.$router.push({ name: "InfoPagamento", params: { tipopagamento: _this.tipoPagamento } });
            });
        }
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('get', 'utente/info');

                        case 2:

                            _this2.$parent._data.loaded = true;

                        case 3:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }))();
    }
});

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'InfoPagamento',
  data: function data() {
    return {
      showBonifico: this.$route.params.tipopagamento == 'bonifico',
      showPaypal: this.$route.params.tipopagamento == 'paypal'
    };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_search_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'newsletter',
    data: function data() {
        return {
            materieTable: {
                fields: [{
                    key: 'testoRicerca',
                    label: 'Testo',
                    sortable: true
                }, {
                    key: 'materia1livello',
                    label: 'Categoria',
                    sortable: true
                }, {
                    key: 'materia2livello',
                    label: 'Materia',
                    sortable: true
                }, {
                    key: 'materia',
                    label: 'Sottomateria',
                    sortable: true
                }, {
                    key: 'tribunale',
                    label: 'Tribunale',
                    sortable: true
                }, {
                    key: 'select',
                    label: '',
                    sortable: false
                }],
                items: []
            },
            trattamento: true,
            data: {
                tribunali: [],
                materie: [],
                materie1: [],
                materie2: []
            },
            filterMaterie: {
                liv1: '',
                liv2: ''
            },
            form: {
                materia: '',
                organo: '',
                testo: ''
            },
            newsletterCommenti: ''
        };
    },

    methods: {
        changeMateria1: function changeMateria1(value) {
            var _this = this;

            var data = {
                liv1: this.filterMaterie.liv1
            };
            __WEBPACK_IMPORTED_MODULE_2__services_search_js__["a" /* default */].getMaterie(data).then(function (data) {
                _this.data.materie2 = data;
            });
        },
        changeMateria2: function changeMateria2(value) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_2__services_search_js__["a" /* default */].getMaterie(this.filterMaterie).then(function (data) {
                _this2.data.materie = data;
            });
        },
        addMateria: function addMateria() {
            var _this3 = this;

            //check params
            var errMsg = null;
            if (!this.trattamento) errMsg = "Il consenso al trattamento dei dati è obbligatorio!";

            if (errMsg != null) {
                alert(errMsg);
                return;
            }

            //send request      
            __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('post', 'newsletter', this.form, true).then(function (data) {
                if (data.status === 201) {
                    _this3.getMaterie();
                } else {
                    alert("Errore nell'inserimento della materia!");
                }
            });
        },
        getMaterie: function getMaterie() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('get', 'newsletter');

                            case 2:
                                _this4.materieTable.items = _context.sent;

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this4);
            }))();
        },
        delMateria: function delMateria(item) {
            var _this5 = this;

            var data = {
                materia: item.materiaCodice,
                organo: item.tribunaleCodice,
                testo: item.testoRicerca
            };
            __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('post', 'newsletter/elimina', data, true).then(function (data) {
                if (data.status === 204) {
                    _this5.getMaterie();
                } else {
                    alert("Errore nell'eliminazione della materia!");
                }
            });
        },
        loadCampi: function loadCampi() {
            var materia = this.$route.params.materia;
            if (materia !== undefined) {
                this.filterMaterie.liv1 = materia.substring(0, 1);
                this.filterMaterie.liv2 = materia.substring(0, 3);
                this.form.materia = materia;
                this.changeMateria1();
                this.changeMateria2();
            }

            var tribunale = this.$route.params.tribunale;
            if (tribunale !== undefined) this.form.organo = tribunale;

            var testo = this.$route.params.testo;
            if (testo !== undefined) this.form.testo = testo;
        },
        getNewsletterCommenti: function getNewsletterCommenti() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var data;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('get', 'newsletter/newslettercommenti');

                            case 2:
                                data = _context2.sent;


                                _this6.newsletterCommenti = data;

                            case 4:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6);
            }))();
        },
        updateNewsletterCommenti: function updateNewsletterCommenti() {
            __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('put', 'newsletter/newslettercommenti');
        }
    },
    created: function created() {
        var _this7 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__services_search_js__["a" /* default */].getTribunali();

                        case 2:
                            _this7.data.tribunali = _context3.sent;
                            _context3.next = 5;
                            return __WEBPACK_IMPORTED_MODULE_2__services_search_js__["a" /* default */].getMaterie(_this7.filterMaterie);

                        case 5:
                            _this7.data.materie1 = _context3.sent;
                            _context3.next = 8;
                            return _this7.getMaterie();

                        case 8:
                            _this7.loadCampi();

                            _context3.next = 11;
                            return _this7.getNewsletterCommenti();

                        case 11:

                            _this7.$parent._data.loaded = true;

                        case 12:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this7);
        }))();
    },

    watch: {
        $route: function $route(to, from) {
            if (to.name === "Newsletter") {
                this.loadCampi();
            }
        }
    }
});

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_search_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'newsletter',
    data: function data() {
        return {
            newsletterTable: {
                fields: [{
                    key: 'testoRicerca',
                    label: 'Testo',
                    sortable: true
                }, {
                    key: 'sede',
                    label: 'Sede',
                    sortable: true
                }, {
                    key: 'select',
                    label: '',
                    sortable: false
                }],
                items: []
            },
            trattamento: true,
            data: {
                sedi: []
            },
            form: {
                sede: '',
                testo: ''
            }
        };
    },

    methods: {
        addNewsletter: function addNewsletter() {
            var _this = this;

            //check params
            var errMsg = null;
            if (!this.trattamento) errMsg = "Il consenso al trattamento dei dati è obbligatorio!";

            if (errMsg != null) {
                alert(errMsg);
                return;
            }

            //send request      
            __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('post', 'newsletter/amministrative', this.form, true).then(function (data) {
                if (data.status === 201) {
                    _this.getNewsletters();
                } else {
                    alert("Errore nell'inserimento della materia!");
                }
            });
        },
        getNewsletters: function getNewsletters() {
            var _this2 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('get', 'newsletter/amministrative');

                            case 2:
                                _this2.newsletterTable.items = _context.sent;

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        delNewsletter: function delNewsletter(item) {
            var _this3 = this;

            var data = {
                sede: item.sedeCodice,
                testo: item.testoRicerca
            };
            __WEBPACK_IMPORTED_MODULE_3__services_service_js__["a" /* default */].execute('post', 'newsletter/amministrative/elimina', data, true).then(function (data) {
                if (data.status === 204) {
                    _this3.getNewsletters();
                } else {
                    alert("Errore nell'eliminazione della materia!");
                }
            });
        },
        loadCampi: function loadCampi() {
            var sede = this.$route.params.sede;
            if (sede !== undefined) this.form.sede = sede;

            var testo = this.$route.params.testo;
            if (testo !== undefined) this.form.testo = testo;
        }
    },
    created: function created() {
        var _this4 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_2__services_search_js__["a" /* default */].getSediAmministrative();

                        case 2:
                            _this4.data.sedi = _context2.sent;
                            _context2.next = 5;
                            return _this4.getNewsletters();

                        case 5:
                            _this4.loadCampi();

                            _this4.$parent._data.loaded = true;

                        case 7:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this4);
        }))();
    },

    watch: {
        $route: function $route(to, from) {
            if (to.name === "NewsletterAmministrative") {
                this.loadCampi();
            }
        }
    }
});

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'logout',
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // this.$emit('logout');
              // console.log("test")
              _this.$parent._data.nominativo = '';
              _this.$parent._data.codFisc = '';
              __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('post', 'oauth/logout', undefined, true);
              // api.execute('post', 'privacy/consent', {ip: "x", agreed: "asdasdas"})
              // location.href = "https://landing.giustup.it";
              // location.href = "/home";
              //refresh App.vue
              _this.$router.push({ name: "Home" });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_oauth_js__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'attivazione',
  data: function data() {
    return {};
  },

  methods: {
    login: function login(provider) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var prov, uri;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                prov = __WEBPACK_IMPORTED_MODULE_3__services_oauth_js__["a" /* default */].get(provider);

                //salva token di attivazione nella richiesta

                prov.options.query.state.provider = provider;
                prov.options.query.state.attivazioneToken = _this.$route.query.token;
                prov.options.query.state = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(prov.options.query.state);
                uri = prov.code.getUri();


                location.assign(uri);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var parameters, body, error, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              parameters = _this2.$route.query;

              if (!(parameters.token === undefined)) {
                _context2.next = 5;
                break;
              }

              // location.href = "https://landing.giustup.it/";
              _this2.$router.push({ name: "Home" });
              _context2.next = 17;
              break;

            case 5:
              body = { 'token': parameters.token };
              error = true;
              _context2.prev = 7;
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('post', 'utente/verificaAttivazione', body, true);

            case 10:
              data = _context2.sent;

              if (data.status === 200) // ok token valido
                {
                  error = false;
                }
              _context2.next = 16;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2['catch'](7);

            case 16:
              if (error) {
                // token non valido
                // location.href = "https://landing.giustup.it/";
                _this2.$router.push({ name: "Home" });
              } else {
                // ok token valido
                _this2.$parent._data.loaded = true;
              }

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[7, 14]]);
    }))();
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gestioneutenti',
  data: function data() {
    return {
      columns: [{
        title: 'Nome',
        sortable: true,
        cellStyle: this.cellStyle,
        formatter: function formatter(value, row, index, field) {
          var href = '/profilo/' + row.codFisc;
          return '<a href="' + href + '" target="_blank_">' + row.nome + '</a>';
        }
      }, {
        title: 'Cognome',
        field: 'cognome',
        sortable: true,
        cellStyle: this.cellStyle
      }, {
        title: 'Codice Fiscale',
        field: 'codFisc',
        sortable: true,
        cellStyle: this.cellStyle
      }, {
        title: 'Abilitato',
        field: 'abilitato',
        cellStyle: this.cellStyle
      }, {
        title: 'Data scadenza',
        field: 'dataScadenza',
        sortable: true,
        cellStyle: this.cellStyle
      }, {
        title: 'Ha profilo',
        field: 'haProfilo',
        sortable: true,
        cellStyle: this.cellStyle
      }, {
        title: 'Ha commentato',
        field: 'haCommentato',
        sortable: true,
        cellStyle: this.cellStyle
      }, {
        title: 'Ha login',
        field: 'haLogin',
        sortable: true,
        cellStyle: this.cellStyle
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          var href = '/admin/utenti/' + row.codFisc;
          return '<a type="button" class="btn btn-primary" href="' + href + '">Modifica</a>';
        }
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          var href = 'https://www.enotula.it/giustup.php?username=' + row.codFisc + '&piva=' + row.piva + '&codFiscPagante=' + row.codFiscPagante;
          return '<a type="button" class="btn btn-primary" target="_blank_" href="' + href + '">Fatture emesse</a>';
        }
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          if (row.stato != 'fattura') return '';
          var href = '/admin/rinnova/' + row.codFisc;
          return '<a type="button" class="btn btn-primary" href="' + href + '">Fattura & Rinnova</a>';
        }
      }],
      data: [],
      options: {
        search: true,
        pagination: true
      },
      tipoAvvocati: '',
      numLoggati: ''
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'utente/admin');

              case 2:
                _this.data = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    cellStyle: function cellStyle(value, row, index, field) {
      return {
        classes: row.stato
      };
    },
    showOnly: function showOnly() {
      var param = this.tipoAvvocati;
      var filter = {
        stato: param
      };
      if (param === '') filter = {};
      $('#table').bootstrapTable('filterBy', filter);
    },
    getLoggati: function getLoggati() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'utente/admin/loggati');

              case 2:
                _this2.numLoggati = _context2.sent;

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getData();

            case 2:
              _this3.getLoggati();

              _this3.$parent._data.loaded = true;

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);




//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newsletter',
  data: function data() {
    return {
      columns: [{
        title: '',
        field: 'numero',
        sortable: true,
        align: 'left'
      }, {
        title: 'Codice Fiscale',
        field: 'codFisc',
        sortable: true,
        align: 'left'
      }, {
        title: 'Materia iscrizione',
        field: 'materia',
        sortable: true
      }, {
        title: 'Tribunale',
        field: 'tribunale',
        sortable: true
      }, {
        title: 'Testo',
        field: 'testoRicerca',
        sortable: true
      }],
      rows: [],
      options: {
        search: true,
        treeEnable: false,
        treeShowField: 'codFisc',
        idField: 'id',
        parentIdField: 'pid',
        rootParentId: 'root',
        onPostBody: function onPostBody(data) {
          $('#table').treegrid();
          $('#table').treegrid('collapseAll');
        }
      }
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result, avvocati, data, idx, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, avv;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('get', 'newsletter/admin');

              case 2:
                result = _context.sent;
                avvocati = {};
                data = result.map(function (x) {
                  x.id = x.codFisc + x.materiaCodice + "-" + x.tribunaleCodice + "-" + x.testoRicerca;
                  x.pid = x.codFisc;

                  if (avvocati[x.codFisc] === undefined) avvocati[x.codFisc] = 0;
                  avvocati[x.codFisc]++;

                  return x;
                });
                idx = 1;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 9;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(avvocati)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  avv = _step.value;

                  data.push({
                    id: avv,
                    codFisc: avv + " (" + avvocati[avv] + ")",
                    pid: "root",
                    numero: idx
                  });
                  idx += 1;
                }

                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](9);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 17:
                _context.prev = 17;
                _context.prev = 18;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 20:
                _context.prev = 20;

                if (!_didIteratorError) {
                  _context.next = 23;
                  break;
                }

                throw _iteratorError;

              case 23:
                return _context.finish(20);

              case 24:
                return _context.finish(17);

              case 25:
                _this.rows = data;

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 13, 17, 25], [18,, 20, 24]]);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getData();

            case 2:

              _this2.$parent._data.loaded = true;

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_editor__ = __webpack_require__(123);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'socialsentenze',
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_3_vue2_editor__["a" /* VueEditor */]
  },
  data: function data() {
    return {
      commentoInput: '',
      commentoId: null,
      premassimaEdit: false,
      customToolbar: [["bold", "italic", "underline", "strike", { list: "ordered" }, { list: "bullet" }, { color: [] }, { background: [] }]],
      columns: [{
        title: 'Id',
        field: 'id',
        visible: false
      }, {
        title: 'Sentenza Id',
        field: 'sentenzaId',
        visible: false
      }, {
        title: 'Avvocato',
        field: 'avvocato',
        sortable: true
      }, {
        title: 'Testo',
        formatter: function formatter(value, row, index, field) {
          return '<b>' + row.premassima + '</b><hr/>' + row.testo;
        },
        sortable: true,
        class: 'text-justify'
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          return '<button type="button" class="btn btn-info">Modifica</button>';
        },
        events: {
          'click .btn': this.modifica
        }
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          return '<button type="button" class="btn btn-danger">Elimina</button>';
        },
        events: {
          'click .btn': this.eliminaCommento
        }
      }, {
        title: 'Data inserimento',
        field: 'dataInserimento',
        sortable: true
      }, {
        title: 'Materia',
        field: 'sentenzaMateria',
        sortable: true
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          var href = '/sentenza/' + row.sentenzaId;
          return '<a type="button" class="btn btn-primary" target="_blank_" href="' + href + '">Apri sentenza</a>';
        }
      }, {
        title: '',
        formatter: function formatter(value, row, index, field) {
          if (row.approvata) return '<button type="button" class="btn btn-info">Modifica premassima</button>';
          return '<button type="button" class="btn btn-success">Approva</button>';
        },
        events: {
          'click .btn-success': this.modalApprova,
          'click .btn-info': this.modalModificaPremassima
        }
      }],
      commenti: [],
      options: {
        search: true
      }
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('get', 'commento/admin');

              case 2:
                _this.commenti = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    modalModificaPremassima: function modalModificaPremassima(event, value, row, index) {
      this.premassimaEdit = true;
      this.modalApprova(event, value, row, index);
    },
    modalApprova: function modalApprova(event, value, row, index) {
      this.commentoInput = row.premassima;

      this.commentoId = row.id;
      this.$refs['premassima-modal'].show();
    },
    approva: function approva() {
      var _this2 = this;

      var url = 'commento/' + this.commentoId;

      var data = {
        premassima: this.commentoInput
      };

      var that = this;
      __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('put', url, data).then(function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(data) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (that.premassimaEdit) {
                    _context2.next = 3;
                    break;
                  }

                  _context2.next = 3;
                  return __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('post', url);

                case 3:

                  that.getData();
                  that.chiudModalPremassima();

                case 5:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    modifica: function modifica(event, value, row, index) {
      this.commentoInput = row.testo;
      this.commentoId = row.id;
      this.$refs['edit-modal'].show();
    },
    eliminaCommento: function eliminaCommento(event, value, row, index) {
      if (confirm("Eliminare il commento?")) {
        var url = 'commento/' + row.id;

        var that = this;
        __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('delete', url).then(function (data) {
          that.getData();
        });
      }
    },
    salvaCommento: function salvaCommento() {
      var url = 'commento/' + this.commentoId;

      var data = {
        testo: this.commentoInput
      };

      var that = this;
      __WEBPACK_IMPORTED_MODULE_2__services_service_js__["a" /* default */].execute('put', url, data).then(function (data) {
        that.getData();
        that.chiudModal();
      });
    },
    chiudModal: function chiudModal() {
      this.$refs['edit-modal'].hide();
    },
    chiudModalPremassima: function chiudModalPremassima() {
      this.premassimaEdit = false;
      this.$refs['premassima-modal'].hide();
    }
  },
  created: function created() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this3.getData();

            case 2:

              _this3.$parent._data.loaded = true;

            case 3:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_js__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'utente',
  data: function data() {
    return {
      utente: {
        nome: '',
        cognome: '',
        pec: '',
        emailUtente: '',
        denominazione: '',
        indirizzo: '',
        citta: '',
        cap: '',
        provincia: '',
        emailPagante: '',
        codFiscPagante: '',
        piva: '',
        corrispettivo: '',
        dataScadenza: '',
        codiceUfficio: '',
        fatturaDaEmettere: false
      }
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var userId = this.$route.params.userId;
      __WEBPACK_IMPORTED_MODULE_0__services_service_js__["a" /* default */].execute('get', 'utente/admin/' + userId).then(function (data) {
        _this.utente = data;
      });
    },
    aggiorna: function aggiorna() {
      var _this2 = this;

      var userId = this.$route.params.userId;
      __WEBPACK_IMPORTED_MODULE_0__services_service_js__["a" /* default */].execute('put', 'utente/admin/' + userId, this.utente).then(function (data) {
        _this2.utente = data;

        _this2.$router.push({ name: "GestioneUtenti" });
      });
    }
  },
  mounted: function mounted() {
    this.getData();

    this.$parent._data.loaded = true;
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_js__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'utente',
  data: function data() {
    return {
      utente: {
        nome: '',
        cognome: '',
        pec: '',
        emailUtente: '',
        denominazione: '',
        indirizzo: '',
        citta: '',
        cap: '',
        provincia: '',
        emailPagante: '',
        codFiscPagante: '',
        piva: '',
        corrispettivo: '',
        dataScadenza: '',
        codiceUfficio: '',
        fatturaDaEmettere: false
      }
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      var userId = this.$route.params.userId;
      __WEBPACK_IMPORTED_MODULE_0__services_service_js__["a" /* default */].execute('get', 'utente/admin/' + userId).then(function (data) {
        _this.utente = data;
      });
    },
    rinnova: function rinnova() {
      var _this2 = this;

      var userId = this.$route.params.userId;
      var url = 'utente/admin/' + userId + '/fattura';
      __WEBPACK_IMPORTED_MODULE_0__services_service_js__["a" /* default */].execute('post', url, undefined, true).then(function (resp) {
        if (resp.status === 200) {
          _this2.getData();
        } else {
          alert("Errore estensione data scadenza!");
        }
      });
    },
    fattura: function fattura() {}
  },
  mounted: function mounted() {
    this.getData();

    this.$parent._data.loaded = true;
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utils_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Menu_vue__ = __webpack_require__(87);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'massima',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a,
    Menu: __WEBPACK_IMPORTED_MODULE_6__Menu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      idCommento: this.$route.params.idMassima,
      massima: {},
      imgLink: '',
      data: ''
    };
  },

  methods: {
    getMassima: function getMassima() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('get', 'commento/id/' + _this.idCommento);

              case 2:
                _this.massima = _context.sent;


                _this.imgLink = __WEBPACK_IMPORTED_MODULE_5__services_utils_js__["a" /* default */].getAvatarUrl(_this.massima.codFisc);
                _this.data = __WEBPACK_IMPORTED_MODULE_5__services_utils_js__["a" /* default */].formatDate(new Date(_this.massima.dataInserimento));

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getMassima();

            case 2:

              _this2.$parent._data.loaded = true;

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {};
    }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_search_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_utils_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Premassima_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Menu_vue__ = __webpack_require__(87);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ricerca',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_4_vue_loading_overlay___default.a,
    InfiniteLoading: __WEBPACK_IMPORTED_MODULE_3_vue_infinite_loading___default.a,
    Premassima: __WEBPACK_IMPORTED_MODULE_9__Premassima_vue__["a" /* default */],
    Menu: __WEBPACK_IMPORTED_MODULE_10__Menu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      records: null,
      form: {
        query: '',
        materia: '',
        page: 1
      },
      data: {
        materie: [],
        materie1: [],
        materie2: []
      },
      filterMaterie: {
        liv1: '',
        liv2: ''
      }
    };
  },

  methods: {
    searchNew: function searchNew() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.form.page = 1;
                _this.records = [];

                _context.next = 4;
                return _this.search();

              case 4:
                if (_this.$refs.infiniteLoading) {
                  _this.$refs.infiniteLoading.stateChanger.reset();
                }

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    search: function search() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _records;

        var data, url;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                data = [];
                _context2.prev = 2;
                url = 'commento?' + __WEBPACK_IMPORTED_MODULE_6__services_service_js__["a" /* default */].encodeQueryData(_this2.form);
                _context2.next = 6;
                return __WEBPACK_IMPORTED_MODULE_6__services_service_js__["a" /* default */].execute('get', url);

              case 6:
                data = _context2.sent;
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](2);

                alert("Errore durante la ricerca!");

              case 12:

                (_records = _this2.records).push.apply(_records, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(data));

                _this2.form.page += 1;
                _this2.loading = false;
                return _context2.abrupt('return', data.length);

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 9]]);
      }))();
    },
    infiniteHandler: function infiniteHandler($state) {
      if (this.records.length) {
        this.search().then(function (res) {
          if (res) {
            $state.loaded();
          } else {
            $state.complete();
          }
        });
      } else {
        $state.complete();
      }
    },
    changeMateria1: function changeMateria1(value) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_search_js__["a" /* default */].getMaterie(this.filterMaterie).then(function (data) {
        _this3.data.materie2 = data;
      });
    },
    changeMateria2: function changeMateria2(value) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_search_js__["a" /* default */].getMaterie(this.filterMaterie).then(function (data) {
        _this4.data.materie = data;
      });
    }
  },
  created: function created() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("test");
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__services_service_js__["a" /* default */].execute('get', 'oauth');

            case 3:
              console.log("test");
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_7__services_search_js__["a" /* default */].getMaterie(_this5.filterMaterie);

            case 6:
              data = _context3.sent;

              _this5.data.materie1 = data;

              _this5.$parent._data.loaded = true;

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Premassima_vue__ = __webpack_require__(239);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a44ffc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Premassima_vue__ = __webpack_require__(556);
function injectStyle (ssrContext) {
  __webpack_require__(555)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Premassima_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72a44ffc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Premassima_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utils_js__ = __webpack_require__(42);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: '',
      imgLink: ''
    };
  },

  props: {
    premassima: {
      id: String,
      sentenzaTitolo: String,
      testo: String,
      premassima: String,
      avvocato: String,
      codFisc: String,
      sentenzaMateria: String,
      sentenzaSottoMateria: String,
      dataInserimento: String
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.data = __WEBPACK_IMPORTED_MODULE_3__services_utils_js__["a" /* default */].formatDate(new Date(_this.premassima.dataInserimento));
              _this.imgLink = __WEBPACK_IMPORTED_MODULE_3__services_utils_js__["a" /* default */].getAvatarUrl(_this.premassima.codFisc);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utils_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Menu_vue__ = __webpack_require__(87);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newsletterMassime',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a,
    Menu: __WEBPACK_IMPORTED_MODULE_6__Menu_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      text: ''
    };
  },

  methods: {
    addEmail: function addEmail() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  'email': _this.text
                };
                _context.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('post', 'newsletter/iscrizionepubblica', data);

              case 3:
                alert("Iscrizione avvenuta con successo!");

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.$parent._data.loaded = true;

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_loading_overlay_dist_vue_loading_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utils_js__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Premassima_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Menu_vue__ = __webpack_require__(87);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'massima',
  components: {
    Loading: __WEBPACK_IMPORTED_MODULE_2_vue_loading_overlay___default.a,
    Menu: __WEBPACK_IMPORTED_MODULE_7__Menu_vue__["a" /* default */],
    Premassima: __WEBPACK_IMPORTED_MODULE_6__Premassima_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      massime: []
    };
  },

  methods: {
    getMassime: function getMassime() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_4__services_service_js__["a" /* default */].execute('get', 'commento');

              case 2:
                _this.massime = _context.sent;

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getMassime();

            case 2:

              _this2.$parent._data.loaded = true;

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 242 */,
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_utils_js__ = __webpack_require__(42);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var COOKIE_NAME = 'agreed';
var COOKIE_DAYS = 365;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preferenze',
  data: function data() {
    return {
      preferences: {
        tecnici: "1",
        analytics: "1",
        profilazione: "1",
        funzionalità: "1"
      },
      PREFERENCESALL: {
        tecnici: "1",
        analytics: "1",
        profilazione: "1",
        funzionalità: "1"
      },
      PREFERENCESNECESSARY: {
        tecnici: "1",
        analytics: "1",
        profilazione: "0",
        funzionalità: "0"
      }
    };
  },
  mounted: function mounted() {
    var cookie = __WEBPACK_IMPORTED_MODULE_4__services_utils_js__["a" /* default */].getCookie(COOKIE_NAME);
    if (cookie === "") this.showModal();else {
      this.preferences = JSON.parse(cookie);
    }
  },


  methods: {
    showModal: function showModal() {
      document.getElementById('modal').style.display = "block";
    },
    closeModal: function closeModal() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.getElementById('modal').style.display = "none";

                if (__WEBPACK_IMPORTED_MODULE_4__services_utils_js__["a" /* default */].getCookie(COOKIE_NAME)) {
                  _context.next = 5;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_4__services_utils_js__["a" /* default */].setCookie(COOKIE_NAME, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.PREFERENCESNECESSARY), COOKIE_DAYS);
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */].execute("post", "privacy/consent", { agreed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this.PREFERENCESNECESSARY) });

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showPreferences: function showPreferences() {
      document.getElementById('preferenzeModal').style.display = "block";
    },
    closePreferences: function closePreferences() {
      document.getElementById('preferenzeModal').style.display = "none";
    },
    acceptSelected: function acceptSelected() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__services_utils_js__["a" /* default */].setCookie(COOKIE_NAME, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.preferences), COOKIE_DAYS);
                document.getElementById('modal').style.display = "none";
                document.getElementById('preferenzeModal').style.display = "none";
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */].execute("post", "privacy/consent", { agreed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this2.preferences) });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    acceptAll: function acceptAll() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__services_utils_js__["a" /* default */].setCookie(COOKIE_NAME, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this3.PREFERENCESALL), COOKIE_DAYS);
                document.getElementById('modal').style.display = "none";
                document.getElementById('preferenzeModal').style.display = "none";
                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */].execute("post", "privacy/consent", { agreed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this3.PREFERENCESALL) });

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    showDesc: function showDesc(tipo, descrizione) {
      var y = document.getElementById(tipo);
      var x = document.getElementById(descrizione);
      if (x.style.display == "") {
        x.style.display = "block";
        y.style.backgroundColor = "#4993ff";
        y.style.transition = "background-color 0.4s";
      } else {
        x.style.display = "";
        y.style.backgroundColor = "#0a58ca";
        y.style.transition = "background-color 0.4s";
      }
    }
  }
});

/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gtm__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gtm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_gtm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_plugin_load_script__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_youtube_embed__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal_dist_ssr_nocss__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_js_modal_dist_ssr_nocss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal_dist_ssr_nocss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal_dist_styles_css__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_js_modal_dist_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_js_modal_dist_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_table_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_service_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fortawesome_free_brands_svg_icons__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fortawesome_vue_fontawesome__ = __webpack_require__(622);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
























__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["B" /* faSearch */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["m" /* faCookie */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["b" /* faAngleDoubleDown */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["r" /* faGavel */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["f" /* faBook */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["s" /* faHashtag */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["h" /* faCalendarDay */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["i" /* faCalendarWeek */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["a" /* faAddressCard */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["H" /* faUserGraduate */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["w" /* faKeyboard */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["I" /* faUserTie */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["p" /* faFilePdf */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["v" /* faInfoCircle */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["A" /* faQuestion */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["G" /* faUserCircle */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["C" /* faSignOutAlt */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["k" /* faCog */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["q" /* faFileSignature */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["j" /* faCheck */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["D" /* faSortAmountDownAlt */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["F" /* faThumbsUp */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["o" /* faExternalLinkAlt */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["y" /* faPaperclip */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["n" /* faEnvelope */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["e" /* faAt */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["E" /* faStamp */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["x" /* faMapMarkerAlt */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["z" /* faPhone */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["u" /* faImage */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["g" /* faBroom */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["l" /* faComment */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["t" /* faHome */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["c" /* faArrowLeft */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_14__fortawesome_free_solid_svg_icons__["d" /* faArrowRight */]);

__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_15__fortawesome_free_brands_svg_icons__["a" /* faFacebook */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_15__fortawesome_free_brands_svg_icons__["b" /* faGoogle */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_15__fortawesome_free_brands_svg_icons__["d" /* faTwitter */]);
__WEBPACK_IMPORTED_MODULE_13__fortawesome_fontawesome_svg_core__["c" /* library */].add(__WEBPACK_IMPORTED_MODULE_15__fortawesome_free_brands_svg_icons__["c" /* faLinkedin */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_16__fortawesome_vue_fontawesome__["a" /* FontAwesomeIcon */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_plugin_load_script__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_youtube_embed__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_js_modal_dist_ssr_nocss___default.a, { dialog: true });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_gtm___default.a, {
  id: ['GTM-5NXXMXL'],
  queryParams: {},
  enabled: true,
  debug: true,
  loadScript: true,
  vueRouter: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  ignoredViews: []
});

// router.beforeEach(async (to, from) => {
//   const excludedEndpoints = []
//   if (!(await service.execute('get', 'oauth')))
//     location.href = "https://www.giustup.it";

//     console.log("a")
// })


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  watch: {
    '$route': function $route(to, from) {
      document.title = to.meta.title || 'Your Website';
    }
  }
});

/* My custom scripts */
Date.prototype.ddmmyyyy = function () {
  var yyyy = this.getFullYear();
  var mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : this.getMonth() + 1;
  var dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();
  return "".concat(dd).concat("-").concat(mm).concat("-").concat(yyyy);
};

/***/ }),
/* 391 */,
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109734ad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(567);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109734ad_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(207);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd1c906_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(441)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd1c906_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('center',[_c('h3',{staticStyle:{"color":"#1ca836"}},[_vm._v("\n                Consulta tutte le sentenze di merito\n            ")]),_vm._v(" "),_c('h4',[_c('b',[_vm._v("\n                    Le sentenze dei Tribunali e delle Corti d'Appello\n\n                ")])]),_vm._v(" "),_c('h4',[_c('u',[_vm._v("\n                    Registrazione GRATUITA\n                ")])]),_vm._v(" "),_c('h5',[_vm._v("(Inserendo il codice fiscale)")]),_vm._v(" "),_c('p',[_vm._v("Registrazione gratuita consentita ad Avvocati e operatori di giustizia per la consultazione senza\n                costi di tutte le sentenze dei Tribunali e delle Corti d'Appello. Se sei un operatore di giustizia\n                (magistrato, curatore, perito, etc.) e non ricevi la PEC dopo aver inserito il codice fiscale,\n                scrivi a admin@giustup.it. L'abbonamento Premium consente ricerca avanzata e funzioni di estrazione.\n            ")]),_vm._v(" "),_c('iframe',{attrs:{"width":"280","height":"157","src":"https://www.youtube.com/embed/rgJGt4dDESo","title":"YouTube video player","frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}),_vm._v(" "),_c('h3',{staticClass:"h3",staticStyle:{"color":"#1ca836"}},[_vm._v("PROVA!")]),_vm._v(" "),_c('h4',{staticStyle:{"color":"#1ca836"}},[_vm._v(" Non spendi niente e puoi consultare tutto ")]),_vm._v("\n            PER VERIFICARE CHE TU SIA AVVOCATO O OPERATORE DI GIUSTIZIA INSERISCI IL TUO CODICE FISCALE"),_c('br')]),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"3px"}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"contents",staticStyle:{"text-align":"center","max-width":"555px"}},[_c('div',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",staticStyle:{"text-align":"center"},attrs:{"type":"text","id":"txt_cod_fisc","name":"text_codfisc","aria-describedby":"emailHelp","placeholder":"CODICE FISCALE"}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn",staticStyle:{"padding-left":"0.5rem"}},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.registra()}}},[_vm._v("ACCEDI O REGISTRATI")])])])])])])],1),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_183353a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(474);
function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_183353a0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDiMerito_vue__ = __webpack_require__(211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb13b8f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultDiMerito_vue__ = __webpack_require__(468);
function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultDiMerito_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb13b8f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultDiMerito_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{staticClass:"border-primary"},[_c('b-row',[_c('b-col',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.goToSentenza()}}},[_c('p',{staticClass:"font-weight-bold",staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.sentenza.titolo))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"m-2 text-center",attrs:{"sm":"2"}},[_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){return _vm.goToSentenza()}}},[_c('img',{attrs:{"src":_vm.base_url + 'cercasentenze/thumbnail/' + _vm.sentenza.idNodo}}),_vm._v(" "),_c('br'),_vm._v("Testo integrale\n      ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-justify"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sentenza.contenuto)}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"sm":"12"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('sentenza-extra-info-'+_vm.sentenza.idAtto),expression:"'sentenza-extra-info-'+sentenza.idAtto"}],attrs:{"variant":"outline-dark"}},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" Altre info\n      ")],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-center m-2",staticStyle:{"font-size":"smaller"},attrs:{"sm":"12"}},[_c('b-collapse',{attrs:{"id":'sentenza-extra-info-'+_vm.sentenza.idAtto}},[_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"book"}}),_vm._v(" CATEGORIA:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.materiaLiv1))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"book"}}),_vm._v(" MATERIA:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.materiaLiv2))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"book"}}),_vm._v(" SOTTOMATERIA:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.materia))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"gavel"}}),_vm._v(" CODICE UFFICIO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.codiceUfficio))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"user-graduate"}}),_vm._v(" NOME GIUDICE:\n          ")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.nomeGiudice))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"address-card"}}),_vm._v(" CF GIUDICE:\n          ")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.cfGiudice))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"user-tie"}}),_vm._v(" PARTE:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.parte))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"user-tie"}}),_vm._v(" CONTROPARTE:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.controparte))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" ID ATTO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.idAtto))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" ID FASCICOLO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.idFascicolo))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" NUMERO SENTENZA:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.numeroSentenza))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" ANNO SENTENZA:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.annoSentenza))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" NUMERO RUOLO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.numeroRuolo))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" ANNO RUOLO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.annoRuolo))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"gavel"}}),_vm._v(" GRADO GIUDIZIO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.gradoGiudizio))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" CODICE SEZIONE:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.codiceSezione))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" ATTESTAZIONE:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.attestazione))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" ULTIMA MODIFICA:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.ultimaModifica))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultAmministrative_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c80f61e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultAmministrative_vue__ = __webpack_require__(471);
function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultAmministrative_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c80f61e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultAmministrative_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',{staticClass:"border-success"},[_c('b-row',[_c('b-col',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.goToSentenza()}}},[_c('p',{staticClass:"font-weight-bold text-success",staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.sentenza.titolo))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"m-2 text-center",attrs:{"sm":"2"}},[_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){return _vm.goToSentenza()}}},[_c('img',{attrs:{"src":_vm.base_url + 'cercasentenze/thumbnail/' + _vm.sentenza.idNodo}}),_vm._v(" "),_c('br'),_vm._v("Testo integrale\n      ")])],1),_vm._v(" "),_c('b-col',{staticClass:"text-justify"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.sentenza.contenuto)}})]),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}})],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"sm":"12"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('sentenza-extra-info-'+_vm.sentenza.idAtto),expression:"'sentenza-extra-info-'+sentenza.idAtto"}],attrs:{"variant":"outline-dark"}},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" Altre info\n      ")],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-center m-2",staticStyle:{"font-size":"smaller"},attrs:{"sm":"12"}},[_c('b-collapse',{attrs:{"id":'sentenza-extra-info-'+_vm.sentenza.idAtto}},[_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"book"}}),_vm._v(" SEDE:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.sede))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"book"}}),_vm._v(" SEZIONE:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.sezione))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" NUMERO PROVVEDIMENTO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.numProvvedimento))]),_vm._v(" "),_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" ANNO PROVVEDIMENTO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.annoProvvedimento))])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"font-weight-bold",attrs:{"md":"6","lg":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v(" NUMERO RICORSO:")],1),_vm._v(" "),_c('b-col',{attrs:{"md":"6","lg":"3"}},[_vm._v(_vm._s(_vm.sentenza.numRicorso))])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-left mb-1",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'Profilo', params: { codFisc: _vm.commento.codFisc } }}},[_c('img',{attrs:{"src":_vm.imgLink,"width":"25"}}),_vm._v("  \n            "),_c('b',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.commento.avvocato))])])]},proxy:true},{key:"footer",fn:function(){return [_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[(_vm.commento.numeroLike > 0)?_c('small',{staticClass:"text-muted"},[_vm._v("\n                  Piace a "+_vm._s(_vm.commento.numeroLike)+" persone\n                ")]):_vm._e(),_vm._v(" "),(_vm.commento.numeroLike > 0 && _vm.showVisualizzazioni)?_c('small',{staticClass:"text-muted"},[_vm._v("\n                   - \n                ")]):_vm._e(),_vm._v(" "),(_vm.showVisualizzazioni)?_c('small',{staticClass:"text-muted"},[_vm._v("\n                  Visualizzato da "+_vm._s(_vm.commento.numeroVisualizzazioni)+" persone\n                ")]):_vm._e()])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{class:{ 'text-primary': _vm.commento.like },staticStyle:{"width":"100%"},attrs:{"variant":"light"},on:{"click":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"prepend",undefined,$event.key,undefined)){ return null; }return _vm.mettiLike(_vm.commento.id)}}},[_c('font-awesome-icon',{attrs:{"icon":"thumbs-up"}}),_vm._v("\n                    Mi piace\n                ")],1)],1),_vm._v(" "),(_vm.showCommenta)?_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticStyle:{"width":"100%"},attrs:{"to":{ name: 'Sentenza', params: { idNodo: _vm.commento.sentenzaId } },"variant":"light"}},[_c('font-awesome-icon',{attrs:{"icon":"comment"}}),_vm._v("\n                    Commenta\n                ")],1)],1):_vm._e()],1)]},proxy:true}])},[_vm._v(" "),(_vm.showTitoloSentenza)?_c('b-card-body',{staticClass:"text-center p-2"},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'Massima', params: { idMassima: _vm.commento.id } }}},[_c('b',[_vm._v(_vm._s(_vm.commento.sentenzaTitolo))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Materia: "+_vm._s(_vm.commento.sentenzaMateria))]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Sottomateria: "+_vm._s(_vm.commento.sentenzaSottoMateria))])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-justify",domProps:{"innerHTML":_vm._s(_vm.commento.premassima)}}),_vm._v(" "),_c('b-button',{attrs:{"to":{ name: 'Massima', params: { idMassima: _vm.commento.id } },"variant":"outline-secondary","size":"sm"}},[_vm._v("\n      Leggi la versione estesa...\n    ")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right"},[_vm._v("Pubblicato il "+_vm._s(_vm.data))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[_c('h2',{staticClass:"text-center"},[_vm._v("Ricerca sentenze")]),_vm._v(" "),_c('div',{staticClass:"row m-0"},[_c('p',{staticClass:"col-6 text-right mb-0"},[_vm._v("Sentenze totali di merito:")]),_vm._v(" "),_c('b',{staticClass:"text-primary col-6 text-left"},[_vm._v(_vm._s(_vm.formatNumberSentenze(_vm.numeroSentenze.diMerito)))]),_vm._v(" "),_c('p',{staticClass:"col-6 text-right"},[_vm._v("Sentenze totali amministrative:")]),_vm._v(" "),_c('b',{staticClass:"text-success col-6 text-left"},[_vm._v(_vm._s(_vm.formatNumberSentenze(_vm.numeroSentenze.amministrative)))])]),_vm._v(" "),_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('b-card',{staticClass:"m-md-4 px-md-5 px-sm-0 border-0"},[_c('b-input-group',{staticClass:"px-md-5 px-sm-0"},[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"keyboard"}})],1)],1),_vm._v(" "),_c('b-form-input',{staticClass:"text-center",attrs:{"id":"input-query","placeholder":"Cerca una sentenza..."},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.searchNew()}},model:{value:(_vm.form.query),callback:function ($$v) {_vm.$set(_vm.form, "query", $$v)},expression:"form.query"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"id":"info-search-text","variant":"outline-info"}},[_c('font-awesome-icon',{attrs:{"icon":"question"}})],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-success"},on:{"click":function($event){$event.preventDefault();return _vm.searchNew()}}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)],1)],1),_vm._v(" "),_c('b-popover',{attrs:{"target":"info-search-text","triggers":"hover","placement":"bottom"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('b',[_vm._v("Sintassi di ricerca")])]},proxy:true}])},[_vm._v(" "),_c('i',[_vm._v("parola")]),_vm._v(" (cerca una o più parole slegate tra loro)"),_c('br'),_vm._v(" "),_c('i',[_vm._v("=parola")]),_vm._v(" (cerca una parola esatta)"),_c('br'),_vm._v(" "),_c('i',[_vm._v("-parola")]),_vm._v(" (rimuove una parola dalla ricerca)"),_c('br'),_vm._v(" "),_c('i',[_vm._v("\"frase\"")]),_vm._v(" (cerca la frase esatta)"),_c('br'),_vm._v(" "),_c('i',[_vm._v("pa*")]),_vm._v(" (cerca tutte le parole che iniziano con pa)\n    ")])],1),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[((_vm.results.diMerito.records && _vm.results.diMerito.records.length) || (_vm.results.amministrative.records && _vm.results.amministrative.records.length))?_c('b-row',{staticClass:"justify-content-end"},[_c('b-col',{attrs:{"sm":"2"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"sort-amount-down-alt"}})],1)],1),_vm._v(" "),_c('b-form-select',{attrs:{"id":"ordinamento","options":_vm.data.ordinamento},on:{"change":function($event){return _vm.searchNew()}},model:{value:(_vm.form.ordinamento),callback:function ($$v) {_vm.$set(_vm.form, "ordinamento", $$v)},expression:"form.ordinamento"}})],1)],1)],1):_vm._e(),_vm._v(" "),((_vm.results.diMerito.records && _vm.results.diMerito.records.length) || (_vm.results.amministrative.records && _vm.results.amministrative.records.length))?_c('b-row',[_c('b-col',[_c('b-tabs',{attrs:{"content-class":"mt-3","align":"center"},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"bg-primary text-white px-3 py-2 rounded-top d-inline-block"},[_vm._v("\n                Sentenze di MERITO"),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.results.diMerito.totalNum)+" risultati")])])]},proxy:true}],null,false,1575997341)},[_vm._v(" "),_c('div',{staticClass:"mb-2 text-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.ricerca-avanzata-di-merito",modifiers:{"ricerca-avanzata-di-merito":true}}],attrs:{"variant":"outline-secondary"}},[_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Opzioni avanzate")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"angle-double-down"}})],1)],1),_vm._v(" "),_c('b-collapse',{staticClass:"text-left px-md-5 px-sm-0 mt-4",attrs:{"id":"ricerca-avanzata-di-merito"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"tribunale"}},[_vm._v("ORGANO GIUDIZIARIO:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"gavel"}})],1)],1),_vm._v(" "),_c('b-form-select',{attrs:{"id":"tribunale"},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}],null,false,152146516),model:{value:(_vm.formDiMerito.tribunale),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "tribunale", $$v)},expression:"formDiMerito.tribunale"}},[_vm._v(" "),_vm._l((_vm.data.tribunali),function(trib){return _c('option',{key:trib.key,domProps:{"value":trib.key}},[_vm._v(_vm._s(trib.value))])})],2)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"materia"}},[_vm._v("MATERIA:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-select',{attrs:{"id":"materia_1","options":_vm.data.materie1},on:{"change":_vm.changeMateria1},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}],null,false,152146516),model:{value:(_vm.filterMaterie.liv1),callback:function ($$v) {_vm.$set(_vm.filterMaterie, "liv1", $$v)},expression:"filterMaterie.liv1"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-select',{attrs:{"id":"materia_2","options":_vm.data.materie2},on:{"change":_vm.changeMateria2},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":_vm.filterMaterie.liv1}},[_vm._v("Qualsiasi")])]},proxy:true}],null,false,926128699),model:{value:(_vm.filterMaterie.liv2),callback:function ($$v) {_vm.$set(_vm.filterMaterie, "liv2", $$v)},expression:"filterMaterie.liv2"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"book"}})],1)],1),_vm._v(" "),_c('b-form-select',{attrs:{"id":"materia","options":_vm.data.materie},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":_vm.filterMaterie.liv2 + "*"}},[_vm._v("Qualsiasi")])]},proxy:true}],null,false,2340691001),model:{value:(_vm.formDiMerito.materia),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "materia", $$v)},expression:"formDiMerito.materia"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"numero_sentenza"}},[_vm._v("NUMERO SENTENZA:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"numero_sentenza","type":"number"},model:{value:(_vm.formDiMerito.numero_sentenza),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "numero_sentenza", $$v)},expression:"formDiMerito.numero_sentenza"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"anno_sentenza"}},[_vm._v("ANNO SENTENZA:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"anno_sentenza","type":"number"},model:{value:(_vm.formDiMerito.anno_sentenza),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "anno_sentenza", $$v)},expression:"formDiMerito.anno_sentenza"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":".numero_rg"}},[_vm._v("NUMERO R.G.:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"numero_rg","type":"number"},model:{value:(_vm.formDiMerito.numero_rg),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "numero_rg", $$v)},expression:"formDiMerito.numero_rg"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"anno_rg"}},[_vm._v("ANNO R.G.:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"anno_rg","type":"number"},model:{value:(_vm.formDiMerito.anno_rg),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "anno_rg", $$v)},expression:"formDiMerito.anno_rg"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"nome_giudice"}},[_vm._v("NOME GIUDICE:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"user-graduate"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"nome_giudice","type":"text"},model:{value:(_vm.formDiMerito.nome_giudice),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "nome_giudice", $$v)},expression:"formDiMerito.nome_giudice"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"cf_giudice"}},[_vm._v("CF GIUDICE:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"address-card"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"cf_giudice","type":"text"},model:{value:(_vm.formDiMerito.cf_giudice),callback:function ($$v) {_vm.$set(_vm.formDiMerito, "cf_giudice", $$v)},expression:"formDiMerito.cf_giudice"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){return _vm.pulisciFiltriDiMerito()}}},[_c('font-awesome-icon',{attrs:{"icon":"broom"}}),_vm._v(" Pulisci ricerca\n                  ")],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-success"},on:{"click":function($event){return _vm.searchNewDiMerito()}}},[_c('font-awesome-icon',{attrs:{"icon":"search"}}),_vm._v(" Filtra\n                  ")],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-jumbotron',{staticClass:"p-3",attrs:{"lead":"Vuoi rimanere aggiornato sulle nuove sentenze pubblicate?"}},[_c('router-link',{attrs:{"to":{ name: 'Newsletter', params: { materia: _vm.formDiMerito.materia, tribunale: _vm.formDiMerito.tribunale, testo: _vm.form.query } }}},[_c('b-button',{attrs:{"variant":"outline-info"}},[_vm._v("\n                      RICEVI AGGIORNAMENTI SETTIMANALI PER QUESTA RICERCA\n                    ")])],1),_vm._v(" "),_c('b-button',{attrs:{"id":"info-newsletter"}},[_c('font-awesome-icon',{attrs:{"icon":"question"}})],1),_vm._v(" "),_c('b-popover',{attrs:{"target":"info-newsletter","triggers":"hover","placement":"bottom"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n                      Selezionando il Tribunale e la materia di tuo interesse riceverai una mail settimanale con le ultime\n                      sentenze pubblicate al riguardo\n                    ")]},proxy:true}],null,false,4003204631)})],1)],1)],1),_vm._v(" "),(_vm.results.diMerito.records && !_vm.results.diMerito.records.length)?_c('h4',[_vm._v("Nessun risultato trovato!")]):_vm._e(),_vm._v(" "),(_vm.results.diMerito.records && _vm.results.diMerito.records.length)?_c('h5',[_vm._v("Trovati "),_c('b',[_vm._v(_vm._s(_vm.results.diMerito.totalNum))]),_vm._v(" risultati")]):_vm._e(),_vm._v(" "),(_vm.results.diMerito.records)?_c('b-list-group',[_vm._l((_vm.results.diMerito.records),function(result,index){return _c('result-di-merito',{key:result.id_atto,attrs:{"sentenza":result,"index":index,"filters":Object.assign({}, _vm.formDiMerito, _vm.form)}})}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",on:{"infinite":_vm.infiniteHandlerDiMerito}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],2):_vm._e()],1),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"bg-success text-white px-3 py-2 rounded-top d-inline-block"},[_vm._v("\n                Sentenze AMMINISTRATIVE"),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.results.amministrative.totalNum)+" risultati")])])]},proxy:true}],null,false,3111766450)},[_vm._v(" "),_c('div',{staticClass:"mb-2 text-right"},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.ricerca-avanzata-amministrative",modifiers:{"ricerca-avanzata-amministrative":true}}],attrs:{"variant":"outline-secondary"}},[_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Opzioni avanzate")]),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"angle-double-down"}})],1)],1),_vm._v(" "),_c('b-collapse',{staticClass:"text-left px-md-5 px-sm-0 mt-4",attrs:{"id":"ricerca-avanzata-amministrative"}},[_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"sede"}},[_vm._v("SEDE:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"9"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"gavel"}})],1)],1),_vm._v(" "),_c('b-form-select',{attrs:{"id":"sede"},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}],null,false,152146516),model:{value:(_vm.formAmministrative.sede),callback:function ($$v) {_vm.$set(_vm.formAmministrative, "sede", $$v)},expression:"formAmministrative.sede"}},[_vm._v(" "),_vm._l((_vm.data.sediAmministrative),function(trib){return _c('option',{key:trib.key,domProps:{"value":trib.key}},[_vm._v(_vm._s(trib.value))])})],2)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"numero_provvedimento"}},[_vm._v("NUMERO PROVVEDIMENTO:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"numero_provvedimento","type":"number"},model:{value:(_vm.formAmministrative.numero_provvedimento),callback:function ($$v) {_vm.$set(_vm.formAmministrative, "numero_provvedimento", $$v)},expression:"formAmministrative.numero_provvedimento"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"anno_provvedimento"}},[_vm._v("ANNO PROVVEDIMENTO:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}})],1)],1),_vm._v(" "),_c('b-form-input',{attrs:{"id":"anno_provvedimento","type":"number"},model:{value:(_vm.formAmministrative.anno_provvedimento),callback:function ($$v) {_vm.$set(_vm.formAmministrative, "anno_provvedimento", $$v)},expression:"formAmministrative.anno_provvedimento"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"outline-danger"},on:{"click":function($event){return _vm.pulisciFiltriAmministrative()}}},[_c('font-awesome-icon',{attrs:{"icon":"broom"}}),_vm._v(" Pulisci ricerca\n                  ")],1),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-success"},on:{"click":function($event){return _vm.searchNewAmministrative()}}},[_c('font-awesome-icon',{attrs:{"icon":"search"}}),_vm._v(" Filtra\n                  ")],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-jumbotron',{staticClass:"p-3",attrs:{"lead":"Vuoi rimanere aggiornato sulle nuove sentenze pubblicate?"}},[_c('router-link',{attrs:{"to":{ name: 'NewsletterAmministrative', params: { sede: _vm.formAmministrative.sede, testo: _vm.form.query } }}},[_c('b-button',{attrs:{"variant":"outline-info"}},[_vm._v("\n                      RICEVI AGGIORNAMENTI SETTIMANALI PER QUESTA RICERCA\n                    ")])],1),_vm._v(" "),_c('b-button',{attrs:{"id":"info-newsletter"}},[_c('font-awesome-icon',{attrs:{"icon":"question"}})],1),_vm._v(" "),_c('b-popover',{attrs:{"target":"info-newsletter","triggers":"hover","placement":"bottom"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("\n                      Selezionando la sede di tuo interesse riceverai una mail settimanale con le ultime\n                      sentenze pubblicate al riguardo\n                    ")]},proxy:true}],null,false,3516627897)})],1)],1)],1),_vm._v(" "),(_vm.results.amministrative.records && !_vm.results.amministrative.records.length)?_c('h4',[_vm._v("Nessun risultato trovato!")]):_vm._e(),_vm._v(" "),(_vm.results.amministrative.records && _vm.results.amministrative.records.length)?_c('h5',[_vm._v("Trovati "),_c('b',[_vm._v(_vm._s(_vm.results.amministrative.totalNum))]),_vm._v(" risultati")]):_vm._e(),_vm._v(" "),(_vm.results.amministrative.records)?_c('b-list-group',[_vm._l((_vm.results.amministrative.records),function(result,index){return _c('result-amministrative',{key:result.id_atto,attrs:{"sentenza":result,"index":index,"filters":Object.assign({}, _vm.formAmministrative, _vm.form)}})}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",on:{"infinite":_vm.infiniteHandlerAmministrative}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],2):_vm._e()],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThankYou_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec8bdcf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThankYou_vue__ = __webpack_require__(478);
function injectStyle (ssrContext) {
  __webpack_require__(476)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ThankYou_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec8bdcf0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ThankYou_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 476 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 477 */,
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"thankyou",attrs:{"fluid":""}},[_c('h3',{staticClass:"mt-2"},[_vm._v("Bentornato su GiustUp!")]),_vm._v(" "),_c('p',{staticClass:"mt-5"},[_vm._v("Codice fiscale: "),_c('b',[_vm._v(_vm._s(_vm.codFisc))])]),_vm._v(" "),(_vm.showLogin)?_c('div',[_c('p',{staticClass:"mt-2"},[_vm._v("Effettua l'accesso con il social network associato:")]),_vm._v(" "),(_vm.scelta == 'Google')?_c('b-button',{staticClass:"btn-login google",on:{"click":function($event){return _vm.login('Google')}}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'google']}}),_vm._v("    \n      Google\n    ")],1):_vm._e(),_vm._v(" "),(_vm.scelta == 'Facebook')?_c('p',[_vm._v("Facebook non è più supportato. Si prega di ripristinare il proprio account col tasto qui sotto per scegliere un altro social di accesso.")]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.showRegistrazione)?_c('div',[_c('h4',{staticClass:"mt-4 text-success"},[_c('b',[_vm._v("Attiva il tuo account!")])]),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v("\n      Il tuo account non è ancora stato confermato, controlla la tua casella email PEC per attivare il tuo account."),_c('br'),_vm._v("\n      Nel caso in cui il codice fiscale non corrisponda a un "),_c('b',[_vm._v("avvocato iscritto nel REGINDE")]),_vm._v(" non sarà possibile attivare l'account!\n    ")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-button',{staticClass:"mt-5",attrs:{"variant":"outline-primary float-right"},on:{"click":function($event){_vm.showRipristina = !_vm.showRipristina}}},[_c('font-awesome-icon',{attrs:{"icon":"cog"}}),_vm._v("\n        Ripristina account\n      ")],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"0","md":"3"}})],1),_vm._v(" "),_c('div',[(_vm.showRipristina)?_c('b-card',{staticClass:"text-center mt-1"},[_c('div',[_c('p',[_vm._v("Col pulsante sottostante potrai ripristare il tuo account. "),_c('br'),_vm._v("\n        Ti invieremo una PEC per farti riconfermare l'account e potrai decidere il tuo futuro metodo di accesso a GiustUp.")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.ripristina()}}},[_vm._v("\n          Ripristina account\n        ")])],1)]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sentenza_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da15060_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sentenza_vue__ = __webpack_require__(488);
function injectStyle (ssrContext) {
  __webpack_require__(480)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sentenza_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3da15060_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sentenza_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 480 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfTron_vue__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c88db4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfTron_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(482)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfTron_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14c88db4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfTron_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"pdftron"}}),_vm._v(" "),_c('v-dialog')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"sentenza",attrs:{"fluid":""}},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',[_c('b-col',{staticClass:"py-3 text-left d-none d-sm-block",attrs:{"sm":"2","cols":"6"}},[_c('router-link',{attrs:{"to":{ name: 'Newsletter', params: { materia: _vm.$route.params.codiceOggetto, testo: _vm.testoRicerca } }}},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Aggiornami")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"py-3 text-left",attrs:{"sm":"2","cols":"6"}},[(_vm.showPreviousSentenza)?_c('router-link',{attrs:{"to":{ name: 'Sentenza', params: Object.assign({}, _vm.previousSentenzaParams, 
                    {searchText: this.searchText,
                    searchOptions: this.searchOptions}) }}},[_c('b-button',{attrs:{"variant":"success"}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}}),_vm._v("\n              Sentenza precedente\n            ")],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"d-none d-sm-block",attrs:{"sm":"4"}},[_c('p',{staticClass:"text-muted mt-2"},[_vm._v("Sentenza n. "+_vm._s(_vm.numSentenza)+" di "+_vm._s(_vm.totSentenze))])]),_vm._v(" "),_c('b-col',{staticClass:"py-3 text-right",attrs:{"sm":"2","cols":"6"}},[(_vm.showNextSentenza)?_c('router-link',{attrs:{"to":{ name: 'Sentenza', params: Object.assign({}, _vm.nextSentenzaParams, 
                    {searchText: this.searchText,
                    searchOptions: this.searchOptions}) }}},[_c('b-button',{attrs:{"variant":"success"}},[_vm._v("\n              Sentenza successiva\n              "),_c('font-awesome-icon',{attrs:{"icon":"arrow-right"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"py-3 text-right d-none d-sm-block",attrs:{"sm":"2"}},[_c('router-link',{attrs:{"to":{ name: 'Search', params: { scrollY: _vm.$route.params.scrollY } }}},[_c('b-button',{attrs:{"variant":"danger"}},[_vm._v("Chiudi")])],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"d-flex d-sm-none"},[_c('b-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"text-muted mt-2"},[_vm._v("Sentenza n. "+_vm._s(_vm.numSentenza)+" di "+_vm._s(_vm.totSentenze))])]),_vm._v(" "),_c('b-col',{staticClass:"py-3 text-left",attrs:{"cols":"6"}},[_c('router-link',{attrs:{"to":{ name: 'Newsletter', params: { materia: _vm.$route.params.codiceOggetto, testo: _vm.testoRicerca } }}},[_c('b-button',{attrs:{"variant":"info"}},[_vm._v("Aggiornami")])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"py-3 text-right",attrs:{"cols":"6"}},[_c('router-link',{attrs:{"to":{ name: 'Search', params: { scrollY: _vm.$route.params.scrollY } }}},[_c('b-button',{attrs:{"variant":"danger"}},[_vm._v("Chiudi")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticStyle:{"min-height":"90vh"},attrs:{"sm":"12"}},[_c('keep-alive',[_c('pdf-tron',{attrs:{"src":_vm.getPdfUrl(),"searchText":_vm.searchText,"searchOptions":_vm.searchOptions},on:{"update:searchText":function($event){_vm.searchText = $event},"update:searchOptions":function($event){_vm.searchOptions = $event}}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__ = __webpack_require__(219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfb7dbc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(490)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Privacy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfb7dbc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Privacy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy"},[_c('p',{staticClass:"P5"},[_c('b',{staticClass:"T1"},[_vm._v("\n      CONDIZIONI GENERALI DI ADESIONE ED "),_c('br'),_vm._v("INFORMATIVA SUL TRATTAMENTO DEI DATI")])]),_vm._v(" "),_c('p',{staticClass:"P1"},[_c('span',{staticClass:"T2"},[_vm._v("Ai sensi del D.lgs 30 giugno 2003 n. 196, al Regolamento UE n. 679/2016 del 27 aprile 2016, (General Data Protection Regulation - G.D.P.R.)")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T3"},[_vm._v("1. Trattamento e accesso del pubblico ai documenti ufficiali (art. 86 del G.D.P.R)")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il Motore di Ricerca GiustUp.it è sincronizzato con il Portale dei Servizi Telematici (PST) del Ministero della Giustizia e consente la ricerca e la visualizzazione delle sentenze ai soli Avvocati iscritti nel REGINDE. L'accesso al Motore di Ricerca GiustUp.it è quindi consentito unicamente tramite autenticazione crittografica forte, limitatamente alla categoria degli Avvocati abilitati sul REGINDE, e solo mediante utilizzo della Carta Nazionale dei Servizi con dispositivo di firma digitale.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L'attivazione iniziale dell'accesso tramite CNS, confermata con la presente informativa, consente l'accesso gratuito al Motore di Ricerca per i primi trenta giorni, decorsi i quali la consultazione sarà possibile solo previa sottoscrizione dell'abbonamento annuale.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il Motore di Ricerca GiustUp.it consente soltanto alla categoria Avvocati iscritti nel REGINDE la messa a disposizione e la consultazione delle sentenze, esclusa pertanto ogni forma di diffusione verso soggetti indeterminati. Accedendo al Motore di ricerca GiustUp.it, l'Avvocato abilitato accetta le condizioni generali riportate nella presente informativa trasmessa tramite posta elettronica certificata, con effetti di condizioni generali di contratto ed obbligo di effettuare il trattamento dei dati personali nei termini di seguito indicati e comunque nei limiti di legge.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Con l'accesso al Motore di Ricerca GiustUp.it l'Avvocato, destinatario della presente informativa, si impegna a trattare i Dati Personali contenuti all'interno delle sentenze in conformità con quanto previsto dal D.lgs 30 giugno 2003 n. 196, al Regolamento UE n. 679/2016 del 27 aprile 2016, (General Data Protection Regulation - G.D.P.R.), alle linee guida dell'Autorità Garante del Trattamento dei Dati Personali ed al Codice deontologico forense.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L'Avvocato si impegna altresì a non effettuare la Diffusione delle sentenze e dei Dati Personali ai quali ha avuto accesso, non dandone conoscenza a soggetti indeterminati, in qualunque forma, anche mediante la loro messa a disposizione o consultazione.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Qualora l'Avvocato sotto la propria esclusiva responsabilità intenda comunque Diffondere le sentenze, il loro contenuto o la massima dallo stesso predisposta, si assume ogni responsabilità al riguardo, sotto il profilo civilistico, amministrativo e penale.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Ferma la responsabilità esclusiva e personale, l'Avvocato o chiunque altro riceva da quest'ultimo comunicazione delle sentenze scaricate da GiustUp.it proceda alla diffusione delle sentenze per finalità di informatica giuridica è tenuto al rispetto di quanto previsto dall'art. 52 del D.lgs 30 giugno 2003 n. 196, secondo cui “"),_c('span',{staticClass:"T2"},[_vm._v("1. Fermo restando quanto previsto dalle disposizioni concernenti la redazione e il contenuto di sentenze e di altri provvedimenti giurisdizionali dell'autorità giudiziaria di ogni ordine e grado, l'interessato può chiedere per motivi legittimi, con richiesta depositata nella cancelleria o segreteria dell'ufficio che procede prima che sia definito il relativo grado di giudizio, che sia apposta a cura della medesima cancelleria o segreteria, sull'originale della sentenza o del provvedimento, un'annotazione volta a precludere, in caso di riproduzione della sentenza o provvedimento in qualsiasi forma, per finalità di informazione giuridica su riviste giuridiche, supporti elettronici o mediante reti di comunicazione elettronica, l'indicazione delle generalità e di altri dati identificativi del medesimo interessato riportati sulla sentenza o provvedimento.")])]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T2"},[_vm._v("2. Sulla richiesta di cui al comma 1 provvede in calce con decreto, senza ulteriori formalità, l'autorità che pronuncia la sentenza o adotta il provvedimento. La medesima autorità può disporre d'ufficio che sia apposta l'annotazione di cui al comma 1, a tutela dei diritti o della dignità degli interessati.")])]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T2"},[_vm._v("3. Nei casi di cui ai commi 1 e 2, all'atto del deposito della sentenza o provvedimento, la cancelleria o segreteria vi appone e sottoscrive anche con timbro la seguente annotazione, recante l'indicazione degli estremi del presente articolo: \"In caso di diffusione omettere le generalità e gli altri dati identificativi di ...\".")])]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T2"},[_vm._v("4. In caso di diffusione anche da parte di terzi di sentenze o di altri provvedimenti recanti l'annotazione di cui al comma 2, o delle relative massime giuridiche, è omessa l'indicazione delle generalità e degli altri dati identificativi dell'interessato.")])]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T2"},[_vm._v("5. Fermo restando quanto previsto dall'articolo 734-bis del codice penale relativamente alle persone offese da atti di violenza sessuale, chiunque diffonde sentenze o altri provvedimenti giurisdizionali dell'autorità giudiziaria di ogni ordine e grado è tenuto ad omettere in ogni caso, anche in mancanza dell'annotazione di cui al comma 2, le generalità, altri dati identificativi o altri dati anche relativi a terzi dai quali può desumersi anche indirettamente l'identità di minori, oppure delle parti nei procedimenti in materia di rapporti di famiglia e di stato delle persone.")])]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T2"},[_vm._v("6. Le disposizioni di cui al presente articolo si applicano anche in caso di deposito di lodo ai sensi dell'articolo 825 del codice di procedura civile. La parte può formulare agli arbitri la richiesta di cui al comma 1 prima della pronuncia del lodo e gli arbitri appongono sul lodo l'annotazione di cui al comma 3, anche ai sensi del comma 2. Il collegio arbitrale costituito presso la camera arbitrale per i lavori pubblici ai sensi dell'articolo 32 della legge 11 febbraio 1994, n. 109, provvede in modo analogo in caso di richiesta di una parte.")])]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T2"},[_vm._v("7. Fuori dei casi indicati nel presente articolo è ammessa la diffusione in ogni forma del contenuto anche integrale di sentenze e di altri provvedimenti giurisdizionali")]),_vm._v("”.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il trattamento dei dati contenti nei provvedimenti giurisdizionali pubblicati sul Portale dei Servizi Telematici del Ministero della Giustizia, avviene in osservanza di quanto previsto dagli artt. 51 e ss. del D.lgs 196 del 2003 ed ai sensi dell’art. 86 del Regolamento UE n. 679/2016 del 27 aprile 2016, (General Data Protection Regulation - G.D.P.R.), secondo cui “"),_c('span',{staticClass:"T2"},[_vm._v("I dati personali contenuti in documenti ufficiali in possesso di un'autorità pubblica o di un organismo pubblico o privato per l'esecuzione di un compito svolto nell'interesse pubblico possono essere comunicati da tale autorità o organismo conformemente al diritto dell'Unione o degli Stati membri cui l'autorità pubblica o l'organismo pubblico sono soggetti, al fine di conciliare l'accesso del pubblico ai documenti ufficiali e il diritto alla protezione dei dati personali ai sensi del presente regolamento")]),_vm._v("”.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T1"},[_vm._v("2. Informativa sul trattamento dei dati personali degli utenti")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Informativa ai sensi e per gli effetti di cui all'art. 13 e ss. del Regolamento UE n. 679/2016 del 27 aprile 2016, (General Data Protection Regulation - G.D.P.R.) \""),_c('span',{staticClass:"T2"},[_vm._v("relativo alla protezione delle persone fisiche con riguardo al trattamento dei dati personali, nonché alla libera circolazione di tali dati e che abroga la direttiva 95/46/CE (regolamento generale sulla protezione dei dati)")]),_vm._v("\"")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Attuando la procedura di registrazione ai nostri servizi, gli utenti comunicano volontariamente a PressLex della Dott.ssa Chiara Morocchi, Titolare del trattamento, i propri dati personali.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("I dati personali inviati saranno trattati nel rispetto dei principi di protezione dei dati personali stabiliti dal Regolamento UE n. 679/2016 e dalle altre norme vigenti in materia.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il conferimento dei dati à facoltativo. Tuttavia, il mancato conferimento dei dati ritenuti obbligatori (contrassegnati con il segno *) impedirà la corretta registrazione ai siti, nonché la possibilità di fruire dei servizi riservati agli utenti registrati, e, in caso di abbonamento, l'accettazione da parte di PressLex della Dott.ssa Chiara Morocchi della proposta d'ordine e l'esecuzione del relativo contratto.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Titolare, Responsabile della Protezione dei dati e Responsabili del trattamento dei dati Il Titolare del trattamento a PressLex della Dott.ssa Chiara Morocchi (di seguito anche il \"Titolare del trattamento\") e può essere contattato mediante comunicazione scritta da inviarsi a: PressLex della Dott.ssa Chiara Morocchi, Via Dante Alighieri 17, 52027 Castelfranco Piandiscò (AR).")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il Responsabile della Protezione dei dati, nominato dal Titolare del trattamento può essere contattato via e-mail al seguente indirizzo: admin@giustup.it.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T1"},[_vm._v("3. Finalità e modalità del trattamento dei dati")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("I dati personali raccolti con la registrazione o iscrizione ai nostri siti sono trattati al fine di consentire l'accesso ai prodotti, ai servizi e ai contenuti riservati agli utenti registrati.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Nel caso in cui l'utente abbia espresso il consenso al momento dell'attivazione del servizio, o lo esprima successivamente e fino alla revoca dello stesso, i suoi dati personali potranno essere trattati da PressLex della Dott.ssa Chiara Morocchi per:")]),_c('p',{staticClass:"P2"},[_vm._v("- consentire l'accesso a prodotti, servizi e contenuti;")]),_c('p',{staticClass:"P2"},[_vm._v("- inviare newsletter periodiche con i contenuti pubblicati sulla rivista;")]),_c('p',{staticClass:"P2"},[_vm._v("- inviare inviti a convegni, seminari ed eventi inerenti le materie trattate dalla rivista;")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("PressLex della Dott.ssa Chiara Morocchi utilizzerà, inoltre, i dati personali per finalità amministrative e contabili e per l'esecuzione degli obblighi contrattuali nei confronti degli utenti che facciano parte della propria clientela.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Specifiche misure di sicurezza sono osservate da PressLex della Dott.ssa Chiara Morocchi per prevenire la perdita dei dati, usi illeciti, o non corretti, e accessi non autorizzati.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("I dati personali sono registrati e custoditi su database elettronici situati in Italia, in Paesi appartenenti allo Spazio Economico Europeo (SEE) e in Paesi terzi che garantiscono un adeguato livello di protezione dei dati.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il trattamento dei dati personali forniti dagli utenti potrà essere effettuato anche da società, enti o consorzi, nominati responsabili del trattamento ai sensi dell'art. 28 del Regolamento UE citato, che, per conto di PressLex della Dott.ssa Chiara Morocchi, forniscono specifici servizi elaborativi, o attività connesse, strumentali o di supporto.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("I dati personali forniti dagli utenti potranno essere, inoltre, comunicati:")]),_c('p',{staticClass:"P2"},[_vm._v("- a soggetti ai quali la facoltà di accedere ai dati personali sia riconosciuta da disposizioni di legge, da regolamenti o dalla normativa comunitaria;")]),_c('p',{staticClass:"P2"},[_vm._v("- a soggetti nei confronti dei quali la comunicazione sia prevista da norme di legge o di regolamento, ovvero da soggetti pubblici per lo svolgimento delle loro funzioni istituzionali.")]),_c('p',{staticClass:"P2"},[_vm._v("Il periodo di conservazione dei dati personali di cui sopra è in linea con le previsioni normative vigenti.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T1"},[_vm._v("4. Diritti dell'interessato")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L' interessato ha il diritto di chiedere a PressLex della Dott.ssa Chiara Morocchi l'accesso ai dati personali che lo riguardano, nonché la rettifica, la cancellazione, la limitazione, l'opposizione al loro trattamento, se effettuato in modo automatizzato sulla base del consenso o per l'esecuzione del contratto.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L'interessato ha il diritto di revocare il consenso in qualsiasi momento senza pregiudicare la liceità del trattamento basata sul consenso prestato prima della revoca.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L'interessato ha il diritto di proporre reclamo all'Autorità Garante per il trattamento dei dati personali, ai sensi dell'art. 77 del Regolamento UE 679/2016.")]),_c('p',{staticClass:"P3"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T5"},[_vm._v("5. Informativa cookies")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Nei siti di PressLex della Dott.ssa Chiara Morocchi possono essere raccolte informazioni che possono riguardare l'utente, le sue preferenze, o il dispositivo di accesso a Internet (computer, tablet o cellulare) e vengono utilizzate principalmente per adeguare il funzionamento del sito alle aspettative dell'utente, offrendo una migliore esperienza di navigazione e per inviare messaggi promozionali personalizzati.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Inoltre, proseguendo con la navigazione, l'utente acconsente in automatico all'uso dei cookies in conformità alla presente informativa \"Cookie policy\".")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Di seguito à possibile saperne di più sui vari tipi di cookies utilizzati.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Fermo quanto precede, per i nostri siti web e altri servizi on line utilizziamo le seguenti categorie di cookies:")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T6"},[_vm._v("Cookies indispensabili")])]),_c('p',{staticClass:"P4"}),_c('p',{staticClass:"P2"},[_vm._v("Questi cookie sono necessari al corretto funzionamento dei nostri siti web e per utilizzare e/o migliorare le varie funzioni e/o servizi richiesti. Senza questi cookie non sarebbe possibile gestire e automatizzare, a mero titolo esemplificativo, l'autenticazione dell'utente, l'accesso all'area riservata del sito internet, il contenuto del carrello per gli acquisti on line, la fatturazione elettronica, la realizzazione del processo di acquisto di un ordine.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T6"},[_vm._v("Cookies di analisi")])]),_c('p',{staticClass:"P2"},[_vm._v("Questi cookies ci permettono di perfezionare i nostri siti web monitorando ed analizzando il comportamento degli utenti, creando dei loro profili al fine di apportare miglioramenti e di facilitare la navigazione.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Ad esempio, i cookies di analisi possono aiutarci a tener traccia di quali sono le pagine visitate frequentemente, quali sono le preferenze dell'utente, quali prodotti sono già stati visualizzati per evitare che vengano riproposti, se la pubblicità che viene pubblicata sul sito web à efficace o meno, se e quali difficoltà l'utente incontra nell'utilizzo del sito.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Al fine di analizzare le modalità di utilizzo dei siti web, WKI si avvale anche del servizio di analisi web \"Google Analytics\" fornito da Google (https://www.google.com/intl/it_it/analytics/learn/privacy.html)")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Ulteriori informazioni in merito al servizio Google Analytics e alle procedure da seguire per disabilitare i cookies possono essere trovate i seguenti collegamenti:")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("http://www.google.com/intl/en/analytics/privacyoverview.html")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Tali dati non permettono di identificare personalmente l'utente: tutti i dati raccolti sono aggregati e, in quanto tali, anonimi.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T6"},[_vm._v("Cookies pubblicitari e di pubblicità comportamentale")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Questi cookies sono utilizzati da WKI per raccogliere dati sulle abitudini di navigazione e le preferenze dell'utente al fine di sviluppare un profilo specifico per personalizzazioni dell'offerta commerciale, per il compimento di ricerche di mercato o di vendita a distanza.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Nei servizi online a pagamento questi cookies sono un prezioso strumento per consentire a WKI il continuo miglioramento del prodotto, l'offerta di servizi più efficienti e con caratteristiche sempre più prossime alle reali esigenze dell'utente.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L'utente può decidere di rifiutare l'utilizzo di questa categoria di cookies utilizzando lo strumento di opt-out previsto nella pagina delle impostazioni del proprio browser, oppure in base a quanto di seguito specificato.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T6"},[_vm._v("Cookies di terze parti e Social media cookie")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Il nostro sito web può consentire l'utilizzo di cookies di terze parti che potrebbero raccogliere informazioni sugli spostamenti dell'utente in Internet e, in particolare, nell'ambito dei nostri siti web.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Inoltre, alcune pagine sul nostro sito web sono caratterizzate dalla presenza dei cd. \"social plug-in\", i quali permettono di condividere i nostri contenuti su social media network come Facebook, Twitter, Youtube.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("I cookies di terze parti non sono sotto il nostro controllo e, pertanto, per ulteriori informazioni su come la terza parte utilizza i cookies, si consiglia di visitare il sito web della terza parte di cui qui di seguito si riportano gli indirizzi web ove presenti le diverse informative e modalità di gestione dei cookies terze parti:")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Facebook:")]),_c('p',{staticClass:"P2"},[_vm._v("Informativa: https://www.facebook.com/help/cookies/")]),_c('p',{staticClass:"P2"},[_vm._v("Configurazioni: accedere al proprio account, sezione privacy")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T4"},[_vm._v("Twitter:")])]),_c('p',{staticClass:"P2"},[_vm._v("Informativa: https://support.twitter.com/articles/20170514")]),_c('p',{staticClass:"P2"},[_vm._v("Configurazioni: https://twitter.com/settings/security")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("LinkedIn:")]),_c('p',{staticClass:"P2"},[_vm._v("Informativa: https://www.linkedin.com/legal/cookie-policy")]),_c('p',{staticClass:"P2"},[_vm._v("Configurazioni: https://www.linkedin.com/settings/")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Youtube:")]),_c('p',{staticClass:"P2"},[_vm._v("http://www.google.com/policies/privacy/")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T4"},[_vm._v("DoubleClick")])]),_c('p',{staticClass:"P2"},[_vm._v("Informativa: http://www.google.com/doubleclick/index.html")]),_c('p',{staticClass:"P2"},[_vm._v("Configurazioni: http://www.google.com/policies/privacy/ads/")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Criteo")]),_c('p',{staticClass:"P2"},[_vm._v("http://www.criteo.com/en/privacy-policy")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("77Agency")]),_c('p',{staticClass:"P2"},[_vm._v("http://www.77agency.com/privacy-policy")]),_c('p',{staticClass:"P2"},[_vm._v("BlueKnow")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("http://blueknow.com/cookies.php")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Oracle")]),_c('p',{staticClass:"P2"},[_vm._v("https://www.oracle.com/legal/privacy/index.html")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Hotjar")]),_c('p',{staticClass:"P2"},[_vm._v("https://www.hotjar.com/privacy")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Formisimo")]),_c('p',{staticClass:"P2"},[_vm._v("http://www.formisimo.com/privacy-policy")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Rinuncia ai cookies")]),_c('p',{staticClass:"P2"},[_vm._v("In ogni momento, l'utente può rifiutare di accettare tutti o alcuni dei cookies utilizzati.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("L'eventuale scelta dell'utente di disabilitare l'uso dei nostri cookies di profilazione impedirà la successiva memorizzare di ulteriori cookies da parte nostra, mentre i cookies precedentemente installati sul dispositivo dell'utente continueranno ad essere utilizzati sul dispositivo dell'utente. ")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Laddove l'utente volesse cancellare tutti i cookies presenti sul suo dispositivo, potrà farlo semplicemente selezionando, sul proprio browser, le impostazioni che consentono di rifiutarli. ")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Ogni browser ha specifiche istruzioni di configurazione. Ulteriori informazioni in merito alle procedure da seguire per disabilitare i cookies possono essere trovati sul sito internet del fornitore del browser. ")]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T4"},[_vm._v("Google Chrome: https://support.google.com/chrome/answer/95647?hl=it")])]),_c('p',{staticClass:"P2"},[_vm._v("Mozilla Firefox: http://support.mozilla.org/it/kb/Attivare%20e%20disattivare%20i%20cookie ")]),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T4"},[_vm._v("Internet Explorer: http://windows.microsoft.com/it-it/windows7/block-enable-or-allow-cookies ")])]),_c('p',{staticClass:"P2"},[_vm._v("Apple Safari: http://support.apple.com/kb/PH5049")]),_c('p',{staticClass:"P2"},[_vm._v("Gestione di Google Analytics")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Per disabilitare soltanto l'uso dei cookies di Google Analytics l'utente può utilizzare il componente aggiuntivo messo a disposizione da Google al seguente collegamento seguendo la procedura di opt-out indicata da Google https://tools.google.com/dlpage/gaoptout?hl=it")]),_c('p',{staticClass:"P2"},[_vm._v("Gestione cookies di Targeting ed Advertising di terze parti")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Per maggiori informazioni e/o per disabilitare i cookies di Targeting ed Advertising, l'utente à invece pregato di visitare il seguente sito web: http://www.youronlinechoices.com/it.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Fermo restando quanto sopra, si rileva che disabilitando i cookies sarà ancora possibile utilizzare alcune parti dei nostri siti web, ma alcuni servizi potrebbero non essere utilizzabili.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("I dati raccolti attraverso i cookies saranno conservati a seconda della loro natura: i cookies di sessione scadono quando l'utente chiude il browser, i cookies persistenti hanno date di scadenza tipiche che, a meno di particolari eccezioni, non superano i 20 giorni.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_c('span',{staticClass:"T1"},[_vm._v("6. Comunicazioni")])]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Tali dati saranno trattati esclusivamente nell'ambito delle finalità sopraddette e potranno essere comunicati a società controllate, controllanti, affiliate o comunque collegate.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Nel rispetto delle misure minime di sicurezza, i suoi dati potranno altresì essere comunicati a soggetti di pubblica sicurezza e ad altri soggetti pubblici e privati per l'adempimento di obblighi previsti dalla legge anche di natura fiscale, amministrativa, finanziaria e simili. In nessun caso i dati saranno diffusi.")]),_c('p',{staticClass:"P2"}),_c('p',{staticClass:"P2"},[_vm._v("Nel rispetto dei principi di proporzionalità e necessità, i dati non saranno conservati per periodi più lunghi rispetto a quelli indispensabili alla realizzazione delle finalità sopra indicate e, dunque, al servizio offerto o alle specifiche norme di legge.")]),_c('p',{staticClass:"P2"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OAuth_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbdbb17e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OAuth_vue__ = __webpack_require__(494);
function injectStyle (ssrContext) {
  __webpack_require__(493)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OAuth_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dbdbb17e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OAuth_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thankyou"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Utente_vue__ = __webpack_require__(221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ca915c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Utente_vue__ = __webpack_require__(497);
function injectStyle (ssrContext) {
  __webpack_require__(496)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Utente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ca915c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Utente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"utente",attrs:{"fluid":""}},[_c('h4',[_vm._v("Dettagli account")]),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Stato abbonamento:\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"file-signature"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.stato))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Scadenza abbonamento:\n      ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-week"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.dataScadenza))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Giorni rimanenti:  \n      ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.giorniRimasti))])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Giorni di utilizzo nel mese corrente:  \n      ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.giorniNelMese))])],1)],1),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Pagamento' }}},[_c('b-button',{staticClass:"mt-5",attrs:{"variant":"outline-success"}},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" RINNOVA ABBONAMENTO\n    ")],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilo_vue__ = __webpack_require__(222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f70e369_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profilo_vue__ = __webpack_require__(500);
function injectStyle (ssrContext) {
  __webpack_require__(499)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f70e369_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profilo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 499 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"profilo"},[(_vm.profilo.isLoggedUser)?_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('b-button',{attrs:{"variant":"outline-dark","to":{ name: 'ModificaProfilo' }}},[_vm._v("\n        Modifica profilo\n      ")])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":"4"}},[_c('b-img',{attrs:{"src":_vm.getAvatarUrl(),"width":"150","fluid":"","alt":"Immagine profilo"}}),_vm._v(" "),_c('b-row',[(_vm.profilo.facebook || _vm.profilo.twitter || _vm.profilo.linkedin)?_c('b-col',{staticClass:"text-center mb-1 mt-3",attrs:{"cols":"12"}},[_vm._v("\n                Social dell'avvocato:\n              ")]):_vm._e(),_vm._v(" "),_c('b-col',{staticClass:"text-center my-1",attrs:{"cols":"12"}},[(_vm.profilo.facebook)?_c('b-button',{staticClass:"facebook",attrs:{"href":_vm.profilo.facebook,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'facebook']}})],1):_vm._e(),_vm._v(" "),(_vm.profilo.twitter)?_c('b-button',{staticClass:"twitter",attrs:{"href":_vm.profilo.twitter,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'twitter']}})],1):_vm._e(),_vm._v(" "),(_vm.profilo.linkedin)?_c('b-button',{staticClass:"linkedin",attrs:{"href":_vm.profilo.linkedin,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'linkedin']}})],1):_vm._e()],1),_vm._v(" "),_c('b-col',{staticClass:"my-1",attrs:{"cols":"12"}},[(_vm.profilo.sitoWeb)?_c('b-button',{attrs:{"href":_vm.profilo.sitoWeb,"target":"_blank"}},[_vm._v("\n                    Sito web\n                    "),_c('font-awesome-icon',{attrs:{"icon":"external-link-alt"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center mt-3",attrs:{"cols":"12"}},[_c('p',{staticClass:"text-monospace",domProps:{"innerHTML":_vm._s(_vm.cleanHtml(_vm.profilo.descrizione))}})])],1)],1),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"8"}},[_c('b-row',[_c('b-col',[_c('h4',[_c('b',{staticClass:"text-uppercase"},[_vm._v("\n                    "+_vm._s(_vm.profilo.titoloAbbreviato)+" "+_vm._s(_vm.profilo.nome)+" "+_vm._s(_vm.profilo.cognome)+"\n                  ")])])]),_vm._v(" "),_c('b-col',[(_vm.profilo.hasCV)?_c('b-button',{attrs:{"size":"sm","href":_vm.getCvUrl(),"target":"_blank"}},[_vm._v("\n                      Scarica il CV\n                      "),_c('font-awesome-icon',{attrs:{"icon":"paperclip"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"cols":"6","sm":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"user-graduate"}}),_vm._v(" \n                  Ordine di appartenenza:\n              ")],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","sm":"3"}},[_c('b',[_vm._v(_vm._s(_vm.profilo.ordineDiAppartenenza))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","sm":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v("\n                  Anno di iscrizione all'ordine:\n              ")],1),_vm._v(" "),(_vm.profilo.annoIscrizoneOrdine > 0)?_c('b-col',{attrs:{"cols":"6","sm":"3"}},[_c('b',[_vm._v(_vm._s(_vm.profilo.annoIscrizoneOrdine))])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"cols":"6","sm":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"at"}}),_vm._v("\n                  Email:\n              ")],1),_vm._v(" "),_c('b-col',{staticClass:"text-break",attrs:{"cols":"6","sm":"3"}},[_c('b',[_vm._v(_vm._s(_vm.profilo.email))])]),_vm._v(" "),_c('b-col',{attrs:{"cols":"6","sm":"3"}},[_c('font-awesome-icon',{attrs:{"icon":"envelope"}}),_vm._v("\n                  PEC:\n              ")],1),_vm._v(" "),_c('b-col',{staticClass:"text-break",attrs:{"cols":"6","sm":"3"}},[_c('b',[_vm._v(_vm._s(_vm.profilo.pec))])])],1),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',{staticClass:"my-1"},[_c('b-col',{attrs:{"cols":"9"}},[_c('font-awesome-icon',{attrs:{"icon":"stamp"}}),_vm._v("\n                  Abilitazione al patrocinio dinanzi alle Giurisdizioni Superiori:\n              ")],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"3"}},[_c('b',[_vm._v(_vm._s(_vm.profilo.abilitazionePatrocinio ? 'Sì' : 'No'))])])],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{attrs:{"cols":"12 text-center mb-1"}},[_c('b',[_vm._v("Sede principale dello studio")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"map-marker-alt"}}),_vm._v("\n                  Indirizzo:\n                  "),_c('b',[_vm._v(_vm._s(_vm.profilo.sedePrincipaleVia)+" "+_vm._s(_vm.profilo.sedePrincipaleCivico)+", "+_vm._s(_vm.profilo.sedePrincipaleCap)+" "+_vm._s(_vm.profilo.sedePrincipaleCitta))])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"phone"}}),_vm._v("\n                  Telefono:\n                  "),_c('b',[_vm._v(_vm._s(_vm.profilo.sedePrincipaleTelefono))])],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{attrs:{"cols":"12 text-center mb-1 mt-3"}},[_c('b',[_vm._v("Sede secondaria dello studio")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"map-marker-alt"}}),_vm._v("\n                  Indirizzo:\n                  "),_c('b',[_vm._v(_vm._s(_vm.profilo.sedeSecondarialeVia)+" "+_vm._s(_vm.profilo.sedeSecondariaCivico)+", "+_vm._s(_vm.profilo.sedeSecondariaCap)+" "+_vm._s(_vm.profilo.sedeSecondariaCitta))])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"phone"}}),_vm._v("\n                  Telefono:\n                  "),_c('b',[_vm._v(_vm._s(_vm.profilo.sedeSecondariaTelefono))])],1)],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"hashtag"}}),_vm._v("\n                  Totale sentenze massimate o commentate:\n                  "),_c('b',[_vm._v(_vm._s(_vm.profilo.numeroCommenti))])],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('font-awesome-icon',{attrs:{"icon":"calendar-day"}}),_vm._v("\n                  Registrato su GiustUp il: \n                  "),_c('b',[_vm._v(_vm._s(_vm.profilo.dataRegistrazione))])],1)],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"cols":"12"}},[_c('h5',{staticClass:"mb-1"},[_c('b',[_vm._v("Sentenze commentate o massimate:")])]),_vm._v(" "),(_vm.commenti.length == 0)?_c('p',{staticClass:"mt-2"},[_vm._v("Nessuna sentenza commentata o massimata!")]):_vm._e(),_vm._v(" "),_c('b-list-group',_vm._l((_vm.commenti),function(commento){return _c('b-list-group-item',{key:commento.id,staticClass:"flex-column align-items-start",attrs:{"value":commento.id}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('router-link',{attrs:{"to":{ name: 'Sentenza', params: { idNodo: commento.sentenzaId } }}},[_c('h5',{staticClass:"mb-1 font-weight-bold"},[_vm._v(_vm._s(commento.sentenzaTitolo))])]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.formatDate(new Date(commento.dataInserimento))))])],1),_vm._v(" "),_c('div',{staticClass:"text-justify mb-1 mt-3",domProps:{"innerHTML":_vm._s(_vm.cleanHtml(commento.premassima))}}),_vm._v(" "),_c('small',{staticClass:"float-left"},[_vm._v("Piace a "+_vm._s(commento.numeroLike)+" persone; "+_vm._s(commento.numeroVisualizzazioni)+" persone hanno visualizzato la sentenza")])])}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModificaProfilo_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e88d4d8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModificaProfilo_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModificaProfilo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e88d4d8c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModificaProfilo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (["AGRIGENTO", "ALESSANDRIA", "ANCONA", "AOSTA", "AREZZO", "ASCOLI PICENO", "ASTI", "AVELLINO", "AVEZZANO", "BARCELLONA POZZO DI GOTTO", "BARI", "BELLUNO", "BENEVENTO", "BERGAMO", "BIELLA", "BOLOGNA", "BOLZANO", "BRESCIA", "BRINDISI", "BUSTO ARSIZIO", "CAGLIARI", "CALTAGIRONE", "CALTANISSETTA", "CAMPOBASSO", "CASSINO", "CASTROVILLARI", "CATANIA", "CATANZARO", "CHIETI", "CIVITAVECCHIA", "COMO", "COSENZA", "CREMONA", "CROTONE", "CUNEO", "ENNA", "FERMO", "FERRARA", "FIRENZE", "FOGGIA", "FORLI'", "FROSINONE", "GELA", "GENOVA", "GORIZIA", "GROSSETO", "IMPERIA", "ISERNIA", "IVREA", "L'AQUILA", "LA SPEZIA", "LAGONEGRO", "LAMEZIA TERME", "LANCIANO", "LANUSEI", "LARINO", "LATINA", "LECCE", "LECCO", "LIVORNO", "LOCRI", "LODI", "LUCCA", "MACERATA", "MANTOVA", "MARSALA", "MASSA", "MATERA", "MESSINA", "MILANO", "MODENA", "MONZA", "NAPOLI", "NAPOLI NORD", "NOCERA INFERIORE", "NOLA", "NOVARA", "NUORO", "ORISTANO", "PADOVA", "PALERMO", "PALMI", "PAOLA", "PARMA", "PATTI", "PAVIA", "PERUGIA", "PESARO", "PESCARA", "PIACENZA", "PISA", "PISTOIA", "PORDENONE", "POTENZA", "PRATO", "RAGUSA", "RAVENNA", "REGGIO CALABRIA", "REGGIO EMILIA", "RIETI", "RIMINI", "ROMA", "ROVERETO", "ROVIGO", "SALERNO", "SANTA MARIA CAPUA VETERE", "SASSARI", "SAVONA", "SCIACCA", "SIENA", "SIRACUSA", "SONDRIO", "SPOLETO", "SULMONA", "TARANTO", "TEMPIO PAUSANIA", "TERAMO", "TERMINI IMERESE", "TERNI", "TIVOLI", "TORINO", "TORRE ANNUNZIATA", "TRANI", "TRAPANI", "TRENTO", "TREVISO", "TRIESTE", "UDINE", "URBINO", "VALLO DELLA LUCANIA", "VARESE", "VASTO", "VELLETRI", "VENEZIA", "VERBANIA", "VERCELLI", "VERONA", "VIBO VALENTIA", "VICENZA", "VITERBO"]);

/***/ }),
/* 504 */,
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"modificaprofilo",attrs:{"fluid":""}},[_c('h4',[_vm._v("Profilo utente")]),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"6"}},[(_vm.userAvatar)?_c('img',{attrs:{"src":_vm.userAvatar,"width":"150"}}):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"ml-3",attrs:{"id":"pick-avatar"}},[_vm._v("\n        Cambia immagine"),_c('br'),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"image"}})],1),_vm._v(" "),_c('avatar-cropper',{attrs:{"trigger":"#pick-avatar","upload-url":_vm.getUploadAvatarUrl(),"withCredentials":"true","upload-form-name":"files","mimes":"image/png, image/jpeg, image/jpg, image/bmp","labels":{ submit: 'Carica', cancel: 'Annulla' }},on:{"uploaded":_vm.handleUploaded}})],1),_vm._v(" "),_c('b-col',{staticClass:"p-4",attrs:{"sm":"6"}},[(_vm.profilo.hasCV)?_c('p',[_vm._v("Un curriculum è già presente nel tuo profilo, caricandone uno nuovo verrà sovrascitto.")]):_vm._e(),_vm._v(" "),_c('b-form-file',{attrs:{"size":"sm","placeholder":"Scegli un file o rilascialo qui...","drop-placeholder":"Rilascia qui il file...","accept":"application/pdf"},model:{value:(_vm.fileCv),callback:function ($$v) {_vm.fileCv=$$v},expression:"fileCv"}}),_vm._v(" "),_c('b-button',{staticClass:"mt-3",on:{"click":function($event){return _vm.caricaCv()}}},[_vm._v("\n        Carica Curriculum Vitae"),_c('br'),_vm._v(" "),_c('font-awesome-icon',{attrs:{"icon":"paperclip"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_c('b',[_vm._v("Sei un avvocato?")])]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('b-form-checkbox',{model:{value:(_vm.profilo.avvocato),callback:function ($$v) {_vm.$set(_vm.profilo, "avvocato", $$v)},expression:"profilo.avvocato"}},[_vm._v("\n          Sì / No\n      ")])],1)],1),_vm._v(" "),(!_vm.profilo.avvocato)?_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n      Titolo abbreviato:\n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Es: Ing. o Avv."},model:{value:(_vm.profilo.titoloAbbreviato),callback:function ($$v) {_vm.$set(_vm.profilo, "titoloAbbreviato", $$v)},expression:"profilo.titoloAbbreviato"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',{staticClass:"mt-5"},[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Ordine di appartenenza:\n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-select',{attrs:{"options":_vm.data.ordine,"size":"sm"},model:{value:(_vm.profilo.ordineDiAppartenenza),callback:function ($$v) {_vm.$set(_vm.profilo, "ordineDiAppartenenza", $$v)},expression:"profilo.ordineDiAppartenenza"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Anno di iscrizione nell'ordine:\n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"type":"number","placeholder":"Anno di iscrizione nell'ordine"},model:{value:(_vm.profilo.annoIscrizoneOrdine),callback:function ($$v) {_vm.$set(_vm.profilo, "annoIscrizoneOrdine", $$v)},expression:"profilo.annoIscrizoneOrdine"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Abilitazione al patrocinio dinanzi alle Giurisdizioni Superiori:  \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-checkbox',{model:{value:(_vm.profilo.abilitazionePatrocinio),callback:function ($$v) {_vm.$set(_vm.profilo, "abilitazionePatrocinio", $$v)},expression:"profilo.abilitazionePatrocinio"}},[_vm._v("\n          Sì / No\n      ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-center my-3",attrs:{"sm":"12"}},[_c('b',[_vm._v("Sede principale dello studio")])])],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Via: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Via"},model:{value:(_vm.profilo.sedePrincipaleVia),callback:function ($$v) {_vm.$set(_vm.profilo, "sedePrincipaleVia", $$v)},expression:"profilo.sedePrincipaleVia"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Numero civico: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Numero civico"},model:{value:(_vm.profilo.sedePrincipaleCivico),callback:function ($$v) {_vm.$set(_vm.profilo, "sedePrincipaleCivico", $$v)},expression:"profilo.sedePrincipaleCivico"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      CAP: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"CAP"},model:{value:(_vm.profilo.sedePrincipaleCap),callback:function ($$v) {_vm.$set(_vm.profilo, "sedePrincipaleCap", $$v)},expression:"profilo.sedePrincipaleCap"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Città: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Città"},model:{value:(_vm.profilo.sedePrincipaleCitta),callback:function ($$v) {_vm.$set(_vm.profilo, "sedePrincipaleCitta", $$v)},expression:"profilo.sedePrincipaleCitta"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Numero di telefono: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Numero di telefono"},model:{value:(_vm.profilo.sedePrincipaleTelefono),callback:function ($$v) {_vm.$set(_vm.profilo, "sedePrincipaleTelefono", $$v)},expression:"profilo.sedePrincipaleTelefono"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-center my-3",attrs:{"sm":"12"}},[_c('b',[_vm._v("Sede secondaria dello studio")])])],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Via: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Via"},model:{value:(_vm.profilo.sedeSecondariaVia),callback:function ($$v) {_vm.$set(_vm.profilo, "sedeSecondariaVia", $$v)},expression:"profilo.sedeSecondariaVia"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Numero civico: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Numero civico"},model:{value:(_vm.profilo.sedeSecondariaCivico),callback:function ($$v) {_vm.$set(_vm.profilo, "sedeSecondariaCivico", $$v)},expression:"profilo.sedeSecondariaCivico"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      CAP: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"CAP"},model:{value:(_vm.profilo.sedeSecondariaCap),callback:function ($$v) {_vm.$set(_vm.profilo, "sedeSecondariaCap", $$v)},expression:"profilo.sedeSecondariaCap"}})],1),_vm._v(" "),_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Città: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Città"},model:{value:(_vm.profilo.sedeSecondariaCitta),callback:function ($$v) {_vm.$set(_vm.profilo, "sedeSecondariaCitta", $$v)},expression:"profilo.sedeSecondariaCitta"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.profilo.avvocato)?_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Numero di telefono: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('b-form-input',{attrs:{"placeholder":"Numero di telefono"},model:{value:(_vm.profilo.sedeSecondariaTelefono),callback:function ($$v) {_vm.$set(_vm.profilo, "sedeSecondariaTelefono", $$v)},expression:"profilo.sedeSecondariaTelefono"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center my-3",attrs:{"sm":"12"}},[_c('b',[_vm._v("Social networks")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"3"}},[_vm._v("\n      Descrizione personale: \n    ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"3"}},[_c('vue-editor',{ref:"editor",attrs:{"editor-toolbar":_vm.customToolbar,"placeholder":"Descriviti brevemente"},model:{value:(_vm.profilo.descrizione),callback:function ($$v) {_vm.$set(_vm.profilo, "descrizione", $$v)},expression:"profilo.descrizione"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Link al profilo Facebook: \n        ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Link al proflo Facebook"},model:{value:(_vm.profilo.facebook),callback:function ($$v) {_vm.$set(_vm.profilo, "facebook", $$v)},expression:"profilo.facebook"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Link al profilo Twitter: \n        ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Link al proflo Twitter"},model:{value:(_vm.profilo.twitter),callback:function ($$v) {_vm.$set(_vm.profilo, "twitter", $$v)},expression:"profilo.twitter"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Link al profilo Linkedin: \n        ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Link al proflo Linkedin"},model:{value:(_vm.profilo.linkedin),callback:function ($$v) {_vm.$set(_vm.profilo, "linkedin", $$v)},expression:"profilo.linkedin"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"sm":"6"}},[_vm._v("\n          Link al tuo sito web: \n        ")]),_vm._v(" "),_c('b-col',{staticClass:"text-left",attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Link al tuo sito web"},model:{value:(_vm.profilo.sitoWeb),callback:function ($$v) {_vm.$set(_vm.profilo, "sitoWeb", $$v)},expression:"profilo.sitoWeb"}})],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center mt-3",attrs:{"sm":"12"}},[_c('b-button',{staticClass:"mt-1",attrs:{"variant":"outline-success"},on:{"click":function($event){return _vm.aggiornaProfilo()}}},[_vm._v("Salva il mio profilo")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagamento_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2135c49c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagamento_vue__ = __webpack_require__(510);
function injectStyle (ssrContext) {
  __webpack_require__(507)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2135c49c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = [{"value":"AG","text":"AGRIGENTO"},{"value":"AL","text":"ALESSANDRIA"},{"value":"AN","text":"ANCONA"},{"value":"AO","text":"AOSTA"},{"value":"AR","text":"AREZZO"},{"value":"AP","text":"ASCOLI PICENO"},{"value":"AT","text":"ASTI"},{"value":"AV","text":"AVELLINO"},{"value":"BA","text":"BARI"},{"value":"BT","text":"BARLETTA-ANDRIA-TRANI"},{"value":"BL","text":"BELLUNO"},{"value":"BN","text":"BENEVENTO"},{"value":"BG","text":"BERGAMO"},{"value":"BI","text":"BIELLA"},{"value":"BO","text":"BOLOGNA"},{"value":"BZ","text":"BOLZANO"},{"value":"BS","text":"BRESCIA"},{"value":"BR","text":"BRINDISI"},{"value":"CA","text":"CAGLIARI"},{"value":"CL","text":"CALTANISSETTA"},{"value":"CB","text":"CAMPOBASSO"},{"value":"CI","text":"CARBONIA-IGLESIAS"},{"value":"CE","text":"CASERTA"},{"value":"CT","text":"CATANIA"},{"value":"CZ","text":"CATANZARO"},{"value":"CH","text":"CHIETI"},{"value":"CO","text":"COMO"},{"value":"CS","text":"COSENZA"},{"value":"CR","text":"CREMONA"},{"value":"KR","text":"CROTONE"},{"value":"CN","text":"CUNEO"},{"value":"EN","text":"ENNA"},{"value":"FM","text":"FERMO"},{"value":"FE","text":"FERRARA"},{"value":"FI","text":"FIRENZE"},{"value":"FG","text":"FOGGIA"},{"value":"FC","text":"FORLI’-CESENA"},{"value":"FR","text":"FROSINONE"},{"value":"GE","text":"GENOVA"},{"value":"GO","text":"GORIZIA"},{"value":"GR","text":"GROSSETO"},{"value":"IM","text":"IMPERIA"},{"value":"IS","text":"ISERNIA"},{"value":"SP","text":"LA SPEZIA"},{"value":"AQ","text":"L’AQUILA"},{"value":"LT","text":"LATINA"},{"value":"LE","text":"LECCE"},{"value":"LC","text":"LECCO"},{"value":"LI","text":"LIVORNO"},{"value":"LO","text":"LODI"},{"value":"LU","text":"LUCCA"},{"value":"MC","text":"MACERATA"},{"value":"MN","text":"MANTOVA"},{"value":"MS","text":"MASSA-CARRARA"},{"value":"MT","text":"MATERA"},{"value":"VS","text":" MEDIO CAMPIDANO"},{"value":"ME","text":"MESSINA"},{"value":"MI","text":"MILANO"},{"value":"MO","text":"MODENA"},{"value":"MB","text":"MONZA E DELLA BRIANZA"},{"value":"NA","text":"NAPOLI"},{"value":"NO","text":"NOVARA"},{"value":"NU","text":"NUORO"},{"value":"OG","text":"OGLIASTRA"},{"value":"OT","text":"OLBIA-TEMPIO"},{"value":"OR","text":"ORISTANO"},{"value":"PD","text":"PADOVA"},{"value":"PA","text":"PALERMO"},{"value":"PR","text":"PARMA"},{"value":"PV","text":"PAVIA"},{"value":"PG","text":"PERUGIA"},{"value":"PU","text":"PESARO E URBINO"},{"value":"PE","text":"PESCARA"},{"value":"PC","text":"PIACENZA"},{"value":"PI","text":"PISA"},{"value":"PT","text":"PISTOIA"},{"value":"PN","text":"PORDENONE"},{"value":"PZ","text":"POTENZA"},{"value":"PO","text":"PRATO"},{"value":"RG","text":"RAGUSA"},{"value":"RA","text":"RAVENNA"},{"value":"RC","text":"REGGIO DI CALABRIA"},{"value":"RE","text":"REGGIO NELL’EMILIA"},{"value":"RI","text":"RIETI"},{"value":"RN","text":"RIMINI"},{"value":"RM","text":"ROMA"},{"value":"RO","text":"ROVIGO"},{"value":"SA","text":"SALERNO"},{"value":"SS","text":"SASSARI"},{"value":"SV","text":"SAVONA"},{"value":"SI","text":"SIENA"},{"value":"SR","text":"SIRACUSA"},{"value":"SO","text":"SONDRIO"},{"value":"TA","text":"TARANTO"},{"value":"TE","text":"TERAMO"},{"value":"TR","text":"TERNI"},{"value":"TO","text":"TORINO"},{"value":"TP","text":"TRAPANI"},{"value":"TN","text":"TRENTO"},{"value":"TV","text":"TREVISO"},{"value":"TS","text":"TRIESTE"},{"value":"UD","text":"UDINE"},{"value":"VA","text":"VARESE"},{"value":"VE","text":"VENEZIA"},{"value":"VB","text":"VERBANO-CUSIO-OSSOLA"},{"value":"VC","text":"VERCELLI"},{"value":"VR","text":"VERONA"},{"value":"VV","text":"VIBO VALENTIA"},{"value":"VI","text":"VICENZA"},{"value":"VT","text":"VITERBO"},{"value":"EX","text":"** ESTERO **"}]

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__service_js__ = __webpack_require__(13);


/* harmony default export */ __webpack_exports__["a"] = ({
  pagamento: function pagamento(data) {
    return __WEBPACK_IMPORTED_MODULE_0__service_js__["a" /* default */].execute('post', 'utente/pagamento', data);
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagamento"},[_c('b-container',{attrs:{"fluid":""}},[(!_vm.showBonifico && !_vm.showPaypal)?_c('div',[_c('b-row',{staticClass:"mt-2"},[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h5',{staticClass:"p-2 sfondo-giustup",staticStyle:{"width":"max-content","display":"inline"}},[_vm._v("\n                        Abbonati per un anno (senza rinnovi automatici) al costo di € 122,00 IVA inclusa\n                    ")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Denominazione"},model:{value:(_vm.denominazione),callback:function ($$v) {_vm.denominazione=$$v},expression:"denominazione"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Città"},model:{value:(_vm.citta),callback:function ($$v) {_vm.citta=$$v},expression:"citta"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Indirizzo"},model:{value:(_vm.indirizzo),callback:function ($$v) {_vm.indirizzo=$$v},expression:"indirizzo"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"CAP"},model:{value:(_vm.cap),callback:function ($$v) {_vm.cap=$$v},expression:"cap"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.provinciaOptions},model:{value:(_vm.provincia),callback:function ($$v) {_vm.provincia=$$v},expression:"provincia"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"type":"email","placeholder":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Codice Fiscale"},model:{value:(_vm.cf),callback:function ($$v) {_vm.cf=$$v},expression:"cf"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Partita IVA"},model:{value:(_vm.piva),callback:function ($$v) {_vm.piva=$$v},expression:"piva"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-select',{attrs:{"options":_vm.tipoPagamentoOptions},model:{value:(_vm.tipoPagamento),callback:function ($$v) {_vm.tipoPagamento=$$v},expression:"tipoPagamento"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3"},[_c('b-col',{attrs:{"sm":"3"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-input',{attrs:{"placeholder":"Telefono (preferibilmente mobile)"},model:{value:(_vm.telefono),callback:function ($$v) {_vm.telefono=$$v},expression:"telefono"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}})],1),_vm._v(" "),_c('b-button',{staticClass:"mt-5",staticStyle:{"min-width":"350px"},attrs:{"variant":"success"},on:{"click":function($event){$event.preventDefault();return _vm.pagamento()}}},[_vm._v("\n                Abbonati\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.showBonifico)?_c('bonifico'):_vm._e(),_vm._v(" "),(_vm.showPaypal)?_c('paypal'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPagamento_vue__ = __webpack_require__(225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c68b0614_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPagamento_vue__ = __webpack_require__(513);
function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoPagamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c68b0614_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoPagamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagamento"},[_c('b-container',{attrs:{"fluid":""}},[(_vm.showBonifico)?_c('div',{staticClass:"bonifico col-sm-6 offset-sm-3"},[_c('h5',{staticClass:"mb-3"},[_c('b',[_vm._v("La richiesta di abbonamento è stata inviata.")])]),_c('br'),_vm._v("\n      Ricorda di effettuare il pagamento tramite bonifico bancario sul conto corrente indicato di seguito e di trasmettere copia del versamento all'email "),_c('b',[_c('a',{attrs:{"href":"mailto:admin@giustup.it"}},[_vm._v("admin@giustup.it")])]),_vm._v(" o tramite fax al numero "),_c('b',[_vm._v("055.56.09.352")]),_vm._v(". In seguito verrai abilitato il prima possibile e la fattura ti sarà inviata per email entro 24 ore."),_c('br'),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Importo da versare: € 122 IVA Compresa")]),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("PressLex della Dott.ssa Chiara Morocchi")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Banca del Valdarno")]),_c('br'),_vm._v("\n      Filiale di Castelfranco e Pian di Scò (AR)"),_c('br'),_vm._v("\n      IBAN: IT71O0881105453000000303325\n\n    ")]):_vm._e(),_vm._v(" "),(_vm.showPaypal)?_c('div',{staticClass:"paypal col-sm-6 offset-sm-3"},[_c('h5',[_vm._v("Abbonati per un anno al costo di 100€ + IVA")]),_vm._v(" "),_c('form',{staticClass:"mt-5",attrs:{"action":"https://www.paypal.com/cgi-bin/webscr","method":"post","target":"_top"}},[_c('input',{attrs:{"type":"hidden","name":"business","value":"presslex.editrice@gmail.com"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"cmd","value":"_xclick"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"item_name","value":"Abbonamento annuale giustup.it"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"amount","value":"122.00"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currency_code","value":"EUR"}}),_vm._v(" "),_c('input',{attrs:{"type":"image","src":"https://www.paypalobjects.com/it_IT/IT/i/btn/btn_buynowCC_LG.gif","border":"0","name":"submit","alt":"PayPal è il metodo rapido e sicuro per pagare e farsi pagare online."}}),_vm._v(" "),_c('img',{attrs:{"alt":"","border":"0","src":"https://www.paypalobjects.com/it_IT/i/scr/pixel.gif","width":"1","height":"1"}})])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__ = __webpack_require__(226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2809f3d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__ = __webpack_require__(516);
function injectStyle (ssrContext) {
  __webpack_require__(515)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2809f3d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"text-center mb-1 mt-2"},[_c('b',[_vm._v("Rimani aggiornato sulle nuove massime e commenti")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-form-checkbox',{on:{"change":function($event){return _vm.updateNewsletterCommenti()}},model:{value:(_vm.newsletterCommenti),callback:function ($$v) {_vm.newsletterCommenti=$$v},expression:"newsletterCommenti"}},[_vm._v("\n                    Ricevi l'email settimanale\n                ")])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Newsletter - Sentenze di Merito")])])],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',{staticClass:"text-center mb-3 mt-2"},[_c('b',[_vm._v("Aggiungi i parametri di ricerca per i quali desideri ricevere un'email periodica con le ultime sentenze inserite.")])])],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',[_vm._v("\n                Testo\n                "),_c('b-form-input',{staticClass:"text-center mt-3",attrs:{"placeholder":"Testo della ricerca","size":"sm","type":"text"},model:{value:(_vm.form.testo),callback:function ($$v) {_vm.$set(_vm.form, "testo", $$v)},expression:"form.testo"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"pt-4 sfondo-giustup"},[_c('b-col',{attrs:{"sm":"12","md":"4"}},[_vm._v("\n                Categoria\n                "),_c('b-form-select',{attrs:{"options":_vm.data.materie1,"size":"sm"},on:{"change":_vm.changeMateria1},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.filterMaterie.liv1),callback:function ($$v) {_vm.$set(_vm.filterMaterie, "liv1", $$v)},expression:"filterMaterie.liv1"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_vm._v("\n                Materia\n                "),_c('b-form-select',{attrs:{"options":_vm.data.materie2,"size":"sm"},on:{"change":_vm.changeMateria2},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.filterMaterie.liv2),callback:function ($$v) {_vm.$set(_vm.filterMaterie, "liv2", $$v)},expression:"filterMaterie.liv2"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4"}},[_vm._v("\n                Sottomateria\n                "),_c('b-form-select',{attrs:{"options":_vm.data.materie,"size":"sm"},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.form.materia),callback:function ($$v) {_vm.$set(_vm.form, "materia", $$v)},expression:"form.materia"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',{staticClass:"text-center mt-4"},[_vm._v("            \n                Organo giudiziario\n            ")])],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',[_c('b-form-select',{attrs:{"size":"sm"},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.form.organo),callback:function ($$v) {_vm.$set(_vm.form, "organo", $$v)},expression:"form.organo"}},[_vm._v(" "),_vm._l((_vm.data.tribunali),function(trib){return _c('option',{key:trib.key,domProps:{"value":trib.key}},[_vm._v(_vm._s(trib.value))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',{staticClass:"mt-2 mb-2"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addMateria()}}},[_vm._v("Aggiungi alle newsletter")])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center my-3"},[_c('b',[_vm._v("Iscrizioni attuali:")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2 mb-3"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.materieTable.items,"fields":_vm.materieTable.fields,"show-empty":true,"empty-text":"Nessuna iscrizione alle newsletter!"},scopedSlots:_vm._u([{key:"cell(select)",fn:function(data){return [_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.delMateria(data.item)}}},[_vm._v("Elimina")])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsletterAmministrative_vue__ = __webpack_require__(227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6989ae04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsletterAmministrative_vue__ = __webpack_require__(519);
function injectStyle (ssrContext) {
  __webpack_require__(518)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewsletterAmministrative_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6989ae04_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewsletterAmministrative_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 518 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('h3',[_vm._v("Newsletter - Sentenze Amministrative")])])],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',{staticClass:"text-center mb-3 mt-2"},[_c('b',[_vm._v("Aggiungi i parametri di ricerca per i quali desideri ricevere un'email periodica con le ultime sentenze inserite.")])])],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',[_vm._v("\n                Testo\n                "),_c('b-form-input',{staticClass:"text-center mt-3",attrs:{"placeholder":"Testo della ricerca","size":"sm","type":"text"},model:{value:(_vm.form.testo),callback:function ($$v) {_vm.$set(_vm.form, "testo", $$v)},expression:"form.testo"}})],1)],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',{staticClass:"text-center mt-4"},[_vm._v("            \n                Sede\n            ")])],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',[_c('b-form-select',{attrs:{"size":"sm"},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.form.sede),callback:function ($$v) {_vm.$set(_vm.form, "sede", $$v)},expression:"form.sede"}},[_vm._v(" "),_vm._l((_vm.data.sedi),function(trib){return _c('option',{key:trib.key,domProps:{"value":trib.key}},[_vm._v(_vm._s(trib.value))])})],2)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"sfondo-giustup"},[_c('b-col',{staticClass:"mt-2 mb-2"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addNewsletter()}}},[_vm._v("Aggiungi alle newsletter")])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"text-center my-3"},[_c('b',[_vm._v("Iscrizioni attuali:")])])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"mt-2 mb-3"},[_c('b-table',{attrs:{"striped":"","hover":"","items":_vm.newsletterTable.items,"fields":_vm.newsletterTable.fields,"show-empty":true,"empty-text":"Nessuna iscrizione alle newsletter!"},scopedSlots:_vm._u([{key:"cell(select)",fn:function(data){return [_c('b-button',{attrs:{"variant":"danger","size":"sm"},on:{"click":function($event){return _vm.delNewsletter(data.item)}}},[_vm._v("Elimina")])]}}])})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f97b84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__(522);
function injectStyle (ssrContext) {
  __webpack_require__(521)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29f97b84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attivazione_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1a90e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attivazione_vue__ = __webpack_require__(525);
function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Attivazione_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a1a90e0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Attivazione_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"attivazione",attrs:{"fluid":""}},[_c('h3',{staticClass:"mt-2"},[_vm._v("Benvenuto su GiustUp!")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"mt-2"},[_vm._v("Associa un account di un social network per accedere a GiustUp:")]),_vm._v(" "),_c('b-button',{staticClass:"google",on:{"click":function($event){return _vm.login('Google')}}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'google']}}),_vm._v("    \n      Google\n    ")],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestioneUtenti_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33253ba3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestioneUtenti_vue__ = __webpack_require__(528);
function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestioneUtenti_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33253ba3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestioneUtenti_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gestioneutenti"},[_c('b-row',[_c('b-col',{staticClass:"mb-3"},[_vm._v("\n      Utenti attivi nelle ultime 4 ore: \n      "),_c('b',[_vm._v(_vm._s(_vm.numLoggati))])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_vm._v("Legenda:")]),_vm._v(" "),_c('b-col',{staticClass:"abbonato"},[_vm._v("Utente abbonato")]),_vm._v(" "),_c('b-col',{staticClass:"scaduto"},[_vm._v("Utente scaduto")]),_vm._v(" "),_c('b-col',{staticClass:"disabilitato"},[_vm._v("Utente non attivo")]),_vm._v(" "),_c('b-col',{staticClass:"prova"},[_vm._v("Utente in prova")]),_vm._v(" "),_c('b-col',{staticClass:"fattura"},[_vm._v("Fattura da emettere")])],1),_vm._v(" "),_c('b-row',[_c('b-col',{staticClass:"pt-3 text-right"},[_vm._v("\n      Tipi di utenti da mostrare:\n    ")]),_vm._v(" "),_c('b-col',[_c('b-form-select',{staticClass:"mt-3",attrs:{"size":"sm"},on:{"change":_vm.showOnly},model:{value:(_vm.tipoAvvocati),callback:function ($$v) {_vm.tipoAvvocati=$$v},expression:"tipoAvvocati"}},[_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")]),_vm._v(" "),_c('option',{domProps:{"value":"abbonato"}},[_vm._v("Utente abbonato")]),_vm._v(" "),_c('option',{domProps:{"value":"scaduto"}},[_vm._v("Utente scaduto")]),_vm._v(" "),_c('option',{domProps:{"value":"disabilitato"}},[_vm._v("Utente non attivo")]),_vm._v(" "),_c('option',{domProps:{"value":"prova"}},[_vm._v("Utente in prova")]),_vm._v(" "),_c('option',{domProps:{"value":"fattura"}},[_vm._v("Fattura da emettere")])])],1)],1),_vm._v(" "),_c('BootstrapTable',{attrs:{"id":"table","columns":_vm.columns,"data":_vm.data,"options":_vm.options}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46aaf17b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__ = __webpack_require__(538);
function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46aaf17b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter"},[_c('BootstrapTable',{attrs:{"id":"table","columns":_vm.columns,"data":_vm.rows,"options":_vm.options}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialSentenze_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349f310c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialSentenze_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialSentenze_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_349f310c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SocialSentenze_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socialsentenze"},[_c('h3',[_vm._v("Commenti")]),_vm._v(" "),_c('BootstrapTable',{attrs:{"columns":_vm.columns,"data":_vm.commenti,"options":_vm.options}}),_vm._v(" "),_c('b-modal',{ref:"edit-modal",attrs:{"hide-footer":"","title":"Modifica commento"}},[_c('div',{staticClass:"d-block text-center"},[_c('vue-editor',{ref:"editor",attrs:{"editor-toolbar":_vm.customToolbar,"placeholder":"Scrivi la massima o il commento di questa sentenza..."},model:{value:(_vm.commentoInput),callback:function ($$v) {_vm.commentoInput=$$v},expression:"commentoInput"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-success",on:{"click":_vm.salvaCommento}},[_vm._v("Salva")]),_vm._v(" "),_c('b-button',{on:{"click":_vm.chiudModal}},[_vm._v("Chiudi")])],1),_vm._v(" "),_c('b-modal',{ref:"premassima-modal",attrs:{"hide-footer":"","title":"Inserisci la premassima"}},[_c('div',{staticClass:"d-block text-center"},[_c('vue-editor',{ref:"editor",attrs:{"editor-toolbar":_vm.customToolbar,"placeholder":"Scrivi la premassima..."},model:{value:(_vm.commentoInput),callback:function ($$v) {_vm.commentoInput=$$v},expression:"commentoInput"}})],1),_vm._v(" "),_c('b-button',{staticClass:"btn-success",on:{"click":_vm.approva}},[_vm._v("Approva aggiungendo la premassima")]),_vm._v(" "),_c('b-button',{on:{"click":_vm.chiudModalPremassima}},[_vm._v("Chiudi")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModificaUtente_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e15d6aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModificaUtente_vue__ = __webpack_require__(544);
function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModificaUtente_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e15d6aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModificaUtente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utente"},[_vm._v("\n  Nome:\n  "),_c('b-form-input',{attrs:{"placeholder":"Nome"},model:{value:(_vm.utente.nome),callback:function ($$v) {_vm.$set(_vm.utente, "nome", $$v)},expression:"utente.nome"}}),_vm._v("\n  Cognome:\n  "),_c('b-form-input',{attrs:{"placeholder":"Cognome"},model:{value:(_vm.utente.cognome),callback:function ($$v) {_vm.$set(_vm.utente, "cognome", $$v)},expression:"utente.cognome"}}),_vm._v("\n  PEC:\n  "),_c('b-form-input',{attrs:{"placeholder":"PEC"},model:{value:(_vm.utente.pec),callback:function ($$v) {_vm.$set(_vm.utente, "pec", $$v)},expression:"utente.pec"}}),_vm._v("\n  Email utente:\n  "),_c('b-form-input',{attrs:{"placeholder":"Email Utente"},model:{value:(_vm.utente.emailUtente),callback:function ($$v) {_vm.$set(_vm.utente, "emailUtente", $$v)},expression:"utente.emailUtente"}}),_vm._v("\n  \n  Denominazione:\n  "),_c('b-form-input',{attrs:{"placeholder":"Denominazione"},model:{value:(_vm.utente.denominazione),callback:function ($$v) {_vm.$set(_vm.utente, "denominazione", $$v)},expression:"utente.denominazione"}}),_vm._v("\n  Indirizzo:\n  "),_c('b-form-input',{attrs:{"placeholder":"Indirizzo"},model:{value:(_vm.utente.indirizzo),callback:function ($$v) {_vm.$set(_vm.utente, "indirizzo", $$v)},expression:"utente.indirizzo"}}),_vm._v("\n  Città:\n  "),_c('b-form-input',{attrs:{"placeholder":"Città"},model:{value:(_vm.utente.citta),callback:function ($$v) {_vm.$set(_vm.utente, "citta", $$v)},expression:"utente.citta"}}),_vm._v("\n  CAP:\n  "),_c('b-form-input',{attrs:{"placeholder":"CAP"},model:{value:(_vm.utente.cap),callback:function ($$v) {_vm.$set(_vm.utente, "cap", $$v)},expression:"utente.cap"}}),_vm._v("\n  Provincia:\n  "),_c('b-form-input',{attrs:{"placeholder":"Provincia"},model:{value:(_vm.utente.provincia),callback:function ($$v) {_vm.$set(_vm.utente, "provincia", $$v)},expression:"utente.provincia"}}),_vm._v("\n  Email pagante:\n  "),_c('b-form-input',{attrs:{"placeholder":"Email pagante"},model:{value:(_vm.utente.emailPagante),callback:function ($$v) {_vm.$set(_vm.utente, "emailPagante", $$v)},expression:"utente.emailPagante"}}),_vm._v("\n  Codice fiscale pagante:\n  "),_c('b-form-input',{attrs:{"placeholder":"Codice fiscale pagante"},model:{value:(_vm.utente.codFiscPagante),callback:function ($$v) {_vm.$set(_vm.utente, "codFiscPagante", $$v)},expression:"utente.codFiscPagante"}}),_vm._v("\n  Partita IVA:\n  "),_c('b-form-input',{attrs:{"placeholder":"Partita IVA"},model:{value:(_vm.utente.piva),callback:function ($$v) {_vm.$set(_vm.utente, "piva", $$v)},expression:"utente.piva"}}),_vm._v("\n  Corrispettivo:\n  "),_c('b-form-input',{attrs:{"placeholder":"Corrispettivo"},model:{value:(_vm.utente.corrispettivo),callback:function ($$v) {_vm.$set(_vm.utente, "corrispettivo", $$v)},expression:"utente.corrispettivo"}}),_vm._v("\n\n  Data scadenza:\n  "),_c('b-form-input',{attrs:{"placeholder":"Data scadenza"},model:{value:(_vm.utente.dataScadenza),callback:function ($$v) {_vm.$set(_vm.utente, "dataScadenza", $$v)},expression:"utente.dataScadenza"}}),_vm._v("\n  Codice Fatturazione Elettronica:\n  "),_c('b-form-input',{attrs:{"placeholder":"Codice Fatturazione Elettronica"},model:{value:(_vm.utente.codiceUfficio),callback:function ($$v) {_vm.$set(_vm.utente, "codiceUfficio", $$v)},expression:"utente.codiceUfficio"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-form-checkbox',{attrs:{"switch":""},model:{value:(_vm.utente.fatturaDaEmettere),callback:function ($$v) {_vm.$set(_vm.utente, "fatturaDaEmettere", $$v)},expression:"utente.fatturaDaEmettere"}},[_vm._v("\n    Fattura da emettere\n  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{on:{"click":function($event){return _vm.aggiorna()}}},[_vm._v("Aggiorna")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RinnovaAbbonamento_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b2cd16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RinnovaAbbonamento_vue__ = __webpack_require__(547);
function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RinnovaAbbonamento_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22b2cd16_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RinnovaAbbonamento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"utente"},[_c('b-row',[_c('b-col',{staticClass:"mt-3"},[_c('h5',[_c('b',[_vm._v("Rinnova abbonamento utente")])]),_c('br')])],1),_vm._v(" "),_c('b',[_vm._v("Nome:")]),_vm._v(" "+_vm._s(_vm.utente.nome)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Cognome:")]),_vm._v(" "+_vm._s(_vm.utente.cognome)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("PEC:")]),_vm._v(" "+_vm._s(_vm.utente.pec)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Email utente:")]),_vm._v(" "+_vm._s(_vm.utente.emailUtente)+" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Data scadenza:")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.utente.dataScadenza))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Fattura da emettere:")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.utente.fatturaDaEmettere))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.rinnova()}}},[_vm._v("Aggiorna scadenza tra 1 anno")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('form',{attrs:{"action":"https://www.enotula.it/giustup.php","method":"post"}},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"radio","checked":"checked","name":"tipoAbbonamento","value":"GiustUp.it"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"username"},domProps:{"value":_vm.utente.codFisc}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"denominazione"},domProps:{"value":_vm.utente.denominazione}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"indirizzo"},domProps:{"value":_vm.utente.indirizzo}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"civico","value":""}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"citta"},domProps:{"value":_vm.utente.citta}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"cap"},domProps:{"value":_vm.utente.cap}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"provincia"},domProps:{"value":_vm.utente.provincia}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"emailCliente"},domProps:{"value":_vm.utente.emailPagante}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"codiceFiscale"},domProps:{"value":_vm.utente.codFiscPagante}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"partitaIva"},domProps:{"value":_vm.utente.piva}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"codiceUfficio"},domProps:{"value":_vm.utente.codiceUfficio}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"rivistaNome","value":"www.giustup.it"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"scadenzaAbbonamento"},domProps:{"value":_vm.utente.dataScadenza}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"username","value":"CNS"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"password","value":"CNS"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"split","value":"0"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"sender","value":"admin@giustup.it"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"totale"},domProps:{"value":_vm.utente.corrispettivo}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"pec"},domProps:{"value":_vm.utente.pec}}),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v("Emetti fattura")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Massima_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e407b5d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Massima_vue__ = __webpack_require__(552);
function injectStyle (ssrContext) {
  __webpack_require__(549)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Massima_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e407b5d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Massima_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"mt-2"},[_c('b-col',{attrs:{"cols":"12"}},[_c('b-nav',{attrs:{"tabs":"","align":"center"}},[_c('b-nav-item',{attrs:{"to":{ name: 'UltimeMassime' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"home"}}),_vm._v("\n                Le ultime massime\n            ")],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'RicercaMassime' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"search"}}),_vm._v("\n                Ricerca tra le massime\n            ")],1),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'NewsletterMassime' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"envelope"}}),_vm._v("\n                Iscriviti alla newsletter\n            ")],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"massima"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('Menu'),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{attrs:{"sm":"8"}},[_c('b-row',{staticClass:"text-center"},[_c('b-col',{staticClass:"text-left mt-2",attrs:{"cols":"8"}},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'Profilo', params: { codFisc: _vm.massima.codFisc } }}},[_c('img',{attrs:{"src":_vm.imgLink,"width":"25"}}),_vm._v("  \n                      "),_c('b',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.massima.avvocato))])]),_vm._v("\n                  (Redattore della Massima)\n              ")],1),_vm._v(" "),_c('b-col',{staticClass:"text-right mt-2",attrs:{"cols":"4"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Pubblicato il "+_vm._s(_vm.data))])]),_vm._v(" "),_c('b-col',{staticClass:"mt-2 pt-2",staticStyle:{"background-color":"#008bc0"},attrs:{"cols":"12"}},[_c('router-link',{attrs:{"to":{ name: 'Sentenza', params: { idNodo: _vm.massima.sentenzaId } }}},[_c('b',[_c('h5',{staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.massima.sentenzaTitolo))])])])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Materia: "+_vm._s(_vm.massima.sentenzaMateria))]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Sottomateria: "+_vm._s(_vm.massima.sentenzaSottoMateria))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-button',{staticClass:"mt-2",attrs:{"to":{ name: 'Sentenza', params: { idNodo: _vm.massima.sentenzaId } },"variant":"outline-danger"}},[_c('font-awesome-icon',{attrs:{"icon":"file-pdf"}}),_vm._v("\n                    Visualizza la sentenza "),_c('br'),_vm._v("\n                    (riservato agli iscritti)\n                  ")],1)],1),_vm._v(" "),_c('b-col',{staticClass:"mt-2 pt-2 font-weight-bold",staticStyle:{"background-color":"#c1f3ff","border":"4px solid #008bc0","border-bottom":"none"},attrs:{"cols":"12"}},[_c('b',[_vm._v("SINTESI")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.massima.premassima)}})]),_vm._v(" "),_c('b-col',{staticClass:"pt-2",staticStyle:{"border":"4px solid #008bc0"},attrs:{"cols":"12"}},[_c('b',[_vm._v("MASSIMA")]),_vm._v(" "),_c('div',{staticClass:"massima-text text-justify",domProps:{"innerHTML":_vm._s(_vm.massima.testo)}})])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ricerca_vue__ = __webpack_require__(237);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3615e3f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ricerca_vue__ = __webpack_require__(557);
function injectStyle (ssrContext) {
  __webpack_require__(554)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ricerca_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3615e3f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Ricerca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 554 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 555 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-list-group-item',[_c('b-row',[_c('b-col',[_c('router-link',{attrs:{"to":{ name: 'Massima', params: { idMassima: _vm.premassima.id }}}},[_c('p',{staticClass:"font-weight-bold",staticStyle:{"font-size":"larger"}},[_vm._v(_vm._s(_vm.premassima.sentenzaTitolo))])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b',[_vm._v("Materia: "+_vm._s(_vm.premassima.sentenzaMateria))]),_c('br'),_vm._v(" "),_c('b',[_vm._v("Sottomateria: "+_vm._s(_vm.premassima.sentenzaSottoMateria))])]),_vm._v(" "),_c('b-col',{staticClass:"text-left mt-2",attrs:{"cols":"6"}},[_c('router-link',{staticClass:"text-decoration-none",attrs:{"to":{ name: 'Profilo', params: { codFisc: _vm.premassima.codFisc } }}},[_c('img',{attrs:{"src":_vm.imgLink,"width":"20"}}),_vm._v("  \n            "),_c('b',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.premassima.avvocato))])])],1),_vm._v(" "),_c('b-col',{staticClass:"text-right mt-2",attrs:{"cols":"6"}},[_c('small',{staticClass:"text-muted"},[_vm._v("Pubblicato il "+_vm._s(_vm.data))])]),_vm._v(" "),_c('b-col',{staticClass:"text-justify mt-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.premassima.premassima)}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"ricerca"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('Menu'),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v("Ricerca fra le massime presenti")])]),_vm._v(" "),_c('b-col',{staticClass:"pt-4",attrs:{"sm":"12"}},[_c('b-input-group',{staticClass:"px-md-5 px-sm-0"},[_c('b-form-input',{staticClass:"text-center",attrs:{"id":"input-query","placeholder":"Cerca una massima..."},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.searchNew()}},model:{value:(_vm.form.query),callback:function ($$v) {_vm.$set(_vm.form, "query", $$v)},expression:"form.query"}}),_vm._v(" "),_c('b-input-group-append',[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":function($event){$event.preventDefault();return _vm.searchNew()}}},[_c('font-awesome-icon',{attrs:{"icon":"search"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3 px-md-5 px-sm-0"},[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"materia"}},[_vm._v("MATERIA:")])]),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-select',{attrs:{"id":"materia_1","options":_vm.data.materie1},on:{"change":_vm.changeMateria1},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.filterMaterie.liv1),callback:function ($$v) {_vm.$set(_vm.filterMaterie, "liv1", $$v)},expression:"filterMaterie.liv1"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-select',{attrs:{"id":"materia_2","options":_vm.data.materie2},on:{"change":_vm.changeMateria2},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.filterMaterie.liv2),callback:function ($$v) {_vm.$set(_vm.filterMaterie, "liv2", $$v)},expression:"filterMaterie.liv2"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-input-group',[_c('b-input-group-prepend',[_c('b-input-group-text',[_c('font-awesome-icon',{attrs:{"icon":"book"}})],1)],1),_vm._v(" "),_c('b-form-select',{attrs:{"id":"materia","options":_vm.data.materie},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('option',{domProps:{"value":""}},[_vm._v("Qualsiasi")])]},proxy:true}]),model:{value:(_vm.form.materia),callback:function ($$v) {_vm.$set(_vm.form, "materia", $$v)},expression:"form.materia"}})],1)],1)],1),_vm._v(" "),_c('b-row',{staticClass:"mt-4"},[_c('b-col',[(_vm.records && !_vm.records.length)?_c('h4',[_vm._v("Nessun risultato trovato!")]):_vm._e(),_vm._v(" "),(_vm.records)?_c('b-list-group',[_vm._l((_vm.records),function(result){return _c('premassima',{key:result.id,attrs:{"premassima":result}})}),_vm._v(" "),_c('infinite-loading',{ref:"infiniteLoading",on:{"infinite":_vm.infiniteHandler}},[_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],2):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__ = __webpack_require__(240);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_693fa79d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__ = __webpack_require__(560);
function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsletter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_693fa79d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Newsletter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"newsletter-massime"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('Menu'),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"sm":"2"}}),_vm._v(" "),_c('b-col',{staticClass:"text-center",attrs:{"sm":"8"}},[_c('b-row',[_c('b-col',[_c('h4',[_vm._v("Newsletter")])])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2"},[_c('b-col',[_vm._v("\n                  Se vuoi ricevere gratuitamente un'email settimanale con le ultime massime aggiunte, inserisci qui sotto la tua email.\n              ")])],1),_vm._v(" "),_c('b-row',{staticClass:"mt-3 px-sm-5"},[_c('b-form-input',{attrs:{"type":"email","placeholder":"Inserisci la tua email"},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1),_vm._v(" "),_c('b-row',{staticClass:"mt-2 justify-content-center"},[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){return _vm.addEmail()}}},[_vm._v("Iscrimi alla newsletter")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UltimeMassime_vue__ = __webpack_require__(241);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e93d71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UltimeMassime_vue__ = __webpack_require__(563);
function injectStyle (ssrContext) {
  __webpack_require__(562)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UltimeMassime_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44e93d71_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UltimeMassime_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 562 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"massima"},[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true},on:{"update:active":function($event){_vm.loading=$event}}}),_vm._v(" "),_c('Menu'),_vm._v(" "),_c('b-row',{staticClass:"mt-5"},[_c('b-col',{attrs:{"sm":"12"}},[_c('h3',[_vm._v("Le ultime massime inserite")])]),_vm._v(" "),_c('b-col',{staticClass:"pt-4 pb-4",staticStyle:{"background-color":"#008bc0"},attrs:{"sm":"12"}},[_c('b-list-group',_vm._l((_vm.massime),function(result){return _c('premassima',{key:result.id,staticClass:"mt-2",attrs:{"premassima":result}})}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preferenze_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076662b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preferenze_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(565)
}
var normalizeComponent = __webpack_require__(12)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preferenze_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_076662b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preferenze_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 565 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preferenze"},[_c('button',{staticClass:"btn btn-primary",attrs:{"id":"btn-preferenze"},on:{"click":function($event){return _vm.showPreferences()}}},[_c('font-awesome-icon',{attrs:{"icon":"cookie"}}),_vm._v("\n    Preferenze\n  ")],1),_vm._v(" "),_c('div',{staticClass:"modal modal-fullscreen-md-down",attrs:{"id":"modal","data-bs-backdrop":"static","data-bs-keyboard":"false","tabindex":"-1","aria-labelledby":"modalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content "},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title",attrs:{"id":"modalLabel"}},[_vm._v("Informativa cookies")]),_vm._v(" "),_c('button',{staticClass:"btn-modal-close",attrs:{"id":"btnChiudiModal","type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closeModal()}}})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(0),_vm._v(" "),_c('div',{attrs:{"id":"secondBody"}},[_c('form',{attrs:{"id":"form-preferenze","action":"/cookieconsent.php","method":"post"}},[_c('table',{attrs:{"id":"tablePreferenze"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',{staticClass:"th-preferenze",attrs:{"id":"tipo1"},on:{"click":function($event){return _vm.showDesc('tipo1', 'descrizione1')}}},[_vm._v("Cookie\n                      Strettamente\n                      Necessari (Tecnici)")]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"th-preferenze",attrs:{"id":"tipo2"},on:{"click":function($event){return _vm.showDesc('tipo2', 'descrizione2')}}},[_vm._v("Cookie di\n                      Performanza e Analitici")]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"th-preferenze",attrs:{"id":"tipo3"},on:{"click":function($event){return _vm.showDesc('tipo3', 'descrizione3')}}},[_vm._v("Cookie di\n                      Profilazione")]),_vm._v(" "),_c('td',{staticClass:"td-preferenze"},[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferences.profilazione),expression:"preferences.profilazione"}],staticClass:"checkbox-cookie",attrs:{"name":"profilazione","true-value":"1","false-value":"0","type":"checkbox","checked":""},domProps:{"value":_vm.preferences.profilazione,"checked":Array.isArray(_vm.preferences.profilazione)?_vm._i(_vm.preferences.profilazione,_vm.preferences.profilazione)>-1:_vm._q(_vm.preferences.profilazione,"1")},on:{"change":function($event){var $$a=_vm.preferences.profilazione,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=_vm.preferences.profilazione,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.preferences, "profilazione", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.preferences, "profilazione", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.preferences, "profilazione", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})]),_vm._v(" "),_c('p',{attrs:{"id":"descrizione3"}},[_vm._v("\n                        Questi cookie possono essere inseriti nel Sito da partner pubblicitari. Potrebbero essere\n                        utilizzati da queste società per elaborare un profilo degli interessi dell’Utente e mostrare\n                        annunci rilevanti su altri\n                        siti. Non sono conservati direttamente informazioni personali ma il loro funzionamento è\n                        basato\n                        sull’identificazione univoca del browser dell’Utente e dispositivo di navigazione su internet.\n                        Per i cookie di\n                        profilazione è necessario il consenso dell’Utente.\n                      ")])])]),_vm._v(" "),_c('tr',[_c('th',{staticClass:"th-preferenze",attrs:{"id":"tipo3"},on:{"click":function($event){return _vm.showDesc('tipo4', 'descrizione4')}}},[_vm._v("Cookie di\n                      Funzionalità")]),_vm._v(" "),_c('td',{staticClass:"td-preferenze"},[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferences.funzionalità),expression:"preferences.funzionalità"}],staticClass:"checkbox-cookie",attrs:{"name":"funzionalità","true-value":"1","false-value":"0","type":"checkbox","checked":""},domProps:{"value":_vm.preferences.funzionalità,"checked":Array.isArray(_vm.preferences.funzionalità)?_vm._i(_vm.preferences.funzionalità,_vm.preferences.funzionalità)>-1:_vm._q(_vm.preferences.funzionalità,"1")},on:{"change":function($event){var $$a=_vm.preferences.funzionalità,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=_vm.preferences.funzionalità,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.preferences, "funzionalità", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.preferences, "funzionalità", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.preferences, "funzionalità", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})]),_vm._v(" "),_c('p',{attrs:{"id":"descrizione4"}},[_vm._v("\n                        Questi cookie rendono possibile la personalizzazione del Sito riconoscendo gli Utenti e\n                        ricordando le loro preferenze. Possono essere create dal Titolare del trattamento o da\n                        fornitori\n                        terzi. Per i cookie di\n                        funzionalità è necessario il consenso dell’Utente.\n                      ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{attrs:{"id":"defaultFooter"}}),_vm._v(" "),_c('button',{staticClass:"btn-modal btn-modal-primary",attrs:{"id":"btnAccettaTutti","type":"button"},on:{"click":function($event){return _vm.acceptAll()}}},[_vm._v("\n            Accetta tutti\n            ")]),_vm._v(" "),_c('div',{attrs:{"id":"secondFooter"}},[_c('button',{staticClass:"btn-modal btn-modal-secondary",attrs:{"id":"btnAccettaSel","type":"button"},on:{"click":function($event){return _vm.acceptSelected()}}},[_vm._v("\n            Accetta selezionati\n            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal",attrs:{"id":"preferenzeModal","data-bs-backdrop":"static","data-bs-keyboard":"false","tabindex":"-1","aria-labelledby":"modalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-scrollable modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h2',{staticClass:"modal-title",attrs:{"id":"modalLabel"}},[_vm._v("Informativa cookies")]),_vm._v(" "),_c('button',{staticClass:"btn-modal-close",attrs:{"id":"btnChiudiPreferenze","type":"button","aria-label":"Close"},on:{"click":function($event){return _vm.closePreferences()}}})]),_vm._v(" "),_c('form',{staticClass:"modal-body",attrs:{"id":"preferences-form"}},[_c('table',[_vm._m(4),_vm._v(" "),_c('tbody',[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Cookie di Profilazione")]),_vm._v(" "),_c('td',[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferences.profilazione),expression:"preferences.profilazione"}],staticClass:"checkbox-cookie-pref",attrs:{"name":"profilazione","false-value":"0","true-value":"1","type":"checkbox","checked":""},domProps:{"value":_vm.preferences.profilazione,"checked":Array.isArray(_vm.preferences.profilazione)?_vm._i(_vm.preferences.profilazione,_vm.preferences.profilazione)>-1:_vm._q(_vm.preferences.profilazione,"1")},on:{"change":function($event){var $$a=_vm.preferences.profilazione,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=_vm.preferences.profilazione,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.preferences, "profilazione", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.preferences, "profilazione", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.preferences, "profilazione", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})])])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Cookie di Funzionalità")]),_vm._v(" "),_c('td',[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.preferences.funzionalità),expression:"preferences.funzionalità"}],staticClass:"checkbox-cookie-pref",attrs:{"name":"funzionalità","false-value":"0","true-value":"1","type":"checkbox","checked":""},domProps:{"value":_vm.preferences.funzionalità,"checked":Array.isArray(_vm.preferences.funzionalità)?_vm._i(_vm.preferences.funzionalità,_vm.preferences.funzionalità)>-1:_vm._q(_vm.preferences.funzionalità,"1")},on:{"change":function($event){var $$a=_vm.preferences.funzionalità,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=_vm.preferences.funzionalità,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.preferences, "funzionalità", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.preferences, "funzionalità", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.preferences, "funzionalità", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn-modal btn-modal-secondary",attrs:{"id":"btnAccettaSelezionatiPreferenze","type":"button"},on:{"click":function($event){return _vm.acceptSelected()}}},[_vm._v("Accetta selezionati")]),_vm._v(" "),_c('button',{staticClass:"btn-modal btn-modal-primary",attrs:{"id":"btnAccettaTuttiPreferenze","type":"button"},on:{"click":function($event){return _vm.acceptAll()}}},[_vm._v("Accetta tutti")])])])])]),_vm._v(" "),_c('div',{attrs:{"id":"containerPreferenze"}})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"defaultBody"}},[_vm._v("\n            Questo sito Web utilizza i cookie per personalizzare l’esperienza di navigazione. I cookie che sono\n            classificati come necessari vengono memorizzati sul browser dell’Utente in quanto essenziali per\n            l’abilitazione delle\n            funzionalità di base. Il Sito si serve inoltre di cookie e altre tecnologie per garantire l’affidabilità\n            dello stesso Sito, misurarne le performance, fornire un’esperienza personalizzata e contenuti commerciali\n            e\n            annunci\n            personalizzati. Questi cookie vengono memorizzati nel browser dell’Utente solo con il suo consenso come\n            descritto nella nostra "),_c('a',{attrs:{"href":"/cookie-policy.html"}},[_vm._v("cookie-policy")]),_vm._v(" La chiusura di questo banner,\n            mediante il simbolo X\n            in alto a destra, comporta l'applicazione delle impostazioni di default e dunque la continuazione della\n            navigazione in assenza di cookie o altri strumenti di tracciamento diversi da quelli tecnici.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',{staticClass:"btnChangeModal"},[_c('button',{staticClass:"btn-modal-back filter-white",attrs:{"type":"button","aria-label":"Close"}})]),_vm._v(" "),_c('th',[_vm._v("Preferenze")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"td-preferenze"},[_c('input',{staticClass:"checkbox-cookie",staticStyle:{"display":"none"},attrs:{"name":"tecnici","type":"checkbox","checked":""}}),_vm._v(" "),_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{staticClass:"checkbox-cookie",attrs:{"type":"checkbox","checked":"","disabled":""}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})]),_vm._v(" "),_c('p',{attrs:{"id":"descrizione1"}},[_vm._v("\n                        Questi cookie sono necessari al funzionamento del Sito e non possono essere disattivati. Di\n                        solito essi sono installati solo a seguito di azioni intraprese dall’Utente che possano\n                        qualificarsi come richiesta di\n                        servizi, quali ad esempio impostare le Sue preferenze sulla privacy, effettuare il login o\n                        compilare moduli. È possibile impostare il browser in modo tale che esso blocchi tali cookie o\n                        invii una notifica circa la\n                        loro esistenza, ma alcune parti del Sito non saranno funzionanti. Questi cookie non conservano\n                        alcun dato personale e il loro utilizzo non richiede il consenso dell’Utente.\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"td-preferenze"},[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{staticClass:"checkbox-cookie",attrs:{"name":"analytics","type":"checkbox","checked":"","disabled":""}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})]),_vm._v(" "),_c('p',{attrs:{"id":"descrizione2"}},[_vm._v("\n                        Questi cookie consentono di conteggiare le visite e di determinare le fonti del traffico, così\n                        da poter misurare e migliorare la performance del Sito. Aiutano a capire quanti Utenti passano\n                        sul Sito. Tutte le\n                        informazioni raccolte da questi cookie sono in forma aggregata e dunque anonima. Questi cookie\n                        non conservano alcun dato personale e il loro utilizzo non richiede il consenso dell’Utente.\n                      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Impostazioni di personalizzazione e cookie")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Cookie tecnici")]),_vm._v(" "),_c('td',[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{staticClass:"checkbox-cookie-pref",attrs:{"name":"tecnici","type":"checkbox","checked":"","disabled":""}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Cookie di Performanza e Analitici")]),_vm._v(" "),_c('td',[_c('label',{staticClass:"preferenzeSwitch"},[_c('input',{staticClass:"checkbox-cookie-pref",attrs:{"name":"analytics","type":"checkbox","checked":"","disabled":""}}),_vm._v(" "),_c('span',{staticClass:"preferenzeSlider round"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],attrs:{"id":"app"},on:{"logout":function($event){return _vm.cancelNominativo()}}},[_c('header',[_c('b-navbar',{attrs:{"toggleable":"md","type":"dark","variant":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav-collapse"}}),_vm._v(" "),_c('b-navbar-brand',{staticStyle:{"font-size":"x-large"},attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(568),"width":"30","height":"30","alt":"Giustup logo"}}),_vm._v(" GiustUp.it\n      ")]),_vm._v(" "),_c('preferenze'),_vm._v(" "),(_vm.nominativo)?_c('b-collapse',{attrs:{"is-nav":"","id":"nav-collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',{staticClass:"mr-3",attrs:{"href":"/","active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"search"}}),_vm._v(" Home\n          ")],1),_vm._v(" "),_c('b-nav-item-dropdown',{staticClass:"mr-3",scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('font-awesome-icon',{attrs:{"icon":"envelope"}}),_vm._v(" Newsletter\n            ")]},proxy:true}],null,false,2628113291)},[_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'Newsletter' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"envelope"}}),_vm._v(" Newsletter Sentenze di Merito\n            ")],1),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'NewsletterAmministrative' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"envelope"}}),_vm._v(" Newsletter Sentenze Amministrative\n            ")],1)],1),_vm._v(" "),_c('b-nav-item',{staticClass:"mr-3",attrs:{"to":{ name: 'Privacy' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"gavel"}}),_vm._v(" Info sulla privacy\n          ")],1),_vm._v(" "),_c('b-nav-item',{staticClass:"mr-3",attrs:{"to":{ name: 'Utente' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"user-circle"}}),_vm._v(" Abbonamento\n          ")],1),_vm._v(" "),(_vm.giorniRimasti && _vm.giorniRimasti <= 25 && _vm.giorniRimasti >= 0)?_c('b-nav-text',{staticClass:"mr-3"},[_vm._v("\n            Giorni rimanenti: "),_c('span',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.giorniRimasti)+" giorni rimanenti")])]):_vm._e(),_vm._v(" "),(_vm.giorniRimasti && _vm.giorniRimasti < 0)?_c('b-nav-text',{staticClass:"mr-3"},[_c('span',{staticClass:"testo-scaduto text-warning"},[_vm._v("Abbonamento scaduto!")])]):_vm._e(),_vm._v(" "),(_vm.nominativo)?_c('b-nav-item',{staticClass:"mr-3",attrs:{"to":{ name: 'Profilo', params: { codFisc: _vm.codFisc } },"active-class":"active"}},[_c('b-img',{attrs:{"rounded":"circle","src":_vm.getAvatarUrl(_vm.codFisc),"width":"25"}}),_vm._v("  "+_vm._s(_vm.nominativo)+"\n          ")],1):_vm._e(),_vm._v(" "),(_vm.admin)?_c('b-nav-item-dropdown',{scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_vm._v("\n              Admin\n            ")]},proxy:true}],null,false,2188552928)},[_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'GestioneUtenti' },"active-class":"active"}},[_vm._v("Gestione utenti")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'SocialSentenze' },"active-class":"active"}},[_vm._v("Gestione social")]),_vm._v(" "),_c('b-dropdown-item',{attrs:{"to":{ name: 'AdminNewsletter' },"active-class":"active"}},[_vm._v("Iscritti newsletter")])],1):_vm._e(),_vm._v(" "),_c('b-nav-item',{staticClass:"mr-3",attrs:{"to":{ name: 'Logout' },"active-class":"active"}},[_c('font-awesome-icon',{attrs:{"icon":"sign-out-alt"}}),_vm._v(" Esci\n          ")],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('main',{staticClass:"mt-1 mb-3"},[_c('keep-alive',{attrs:{"exclude":"sentenza"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_vm._v(" "),_c('footer',{staticClass:"bg-dark text-white"},[_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"text-center p-3"},[_c('b-col',{staticClass:"py-2",attrs:{"sm":"12","md":"4"}},[_vm._v("\n          Condizioni generali, privacy e cookies"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"https://www.facebook.com/giustup.it/","target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":['fab', 'facebook']}}),_vm._v(" Seguici su Facebook!\n          ")],1)]),_vm._v(" "),_c('b-col',{staticClass:"py-2",attrs:{"sm":"12","md":"4"}},[_vm._v("\n          Editrice: "),_c('b',[_vm._v("Presslex della Dott.ssa Chiara Morocchi")]),_c('br'),_vm._v("\n          Via Dante Alighieri 17 - Castelfranco"),_c('br'),_vm._v("\n          c.a.p. 52026 Castelfranco Piandiscò (AR)"),_c('br'),_vm._v("\n          C.F. MRCCHR73E67D583D - P.I. 02124850518"),_c('br'),_vm._v("\n          Fax: +39 055.56.09.352"),_c('br'),_vm._v("\n          Email: "),_c('a',{attrs:{"href":"mailto:admin@giustup.it"}},[_vm._v("admin@giustup.it")]),_vm._v(" - PEC: giustup@pec.it"),_c('br')]),_vm._v(" "),_c('b-col',{staticClass:"py-2",attrs:{"sm":"12","md":"4"}},[_vm._v("\n          Bonifico intestato a: PressLex della Dott.ssa Chiara Morocchi"),_c('br'),_vm._v("\n          Banca del Valdarno"),_c('br'),_vm._v("\n          Filiale di Castelfranco e Pian di Scò (AR)"),_c('br'),_vm._v("\n          IBAN: IT71O0881105453000000303325"),_c('br'),_vm._v("\n          BIC\\SWIFT: ICRA IT RRMJ0\n        ")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.72a3471.png";

/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */,
/* 609 */,
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_table_dist_bootstrap_table_min_css__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_table_dist_bootstrap_table_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_table_dist_bootstrap_table_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jquery_js__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_table_dist_bootstrap_table_js__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_table_dist_bootstrap_table_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_table_dist_bootstrap_table_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_table_dist_bootstrap_table_vue_esm_js__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_treegrid_css_jquery_treegrid_css__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery_treegrid_css_jquery_treegrid_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery_treegrid_css_jquery_treegrid_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery_treegrid_js_jquery_treegrid_min_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery_treegrid_js_jquery_treegrid_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery_treegrid_js_jquery_treegrid_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_table_dist_extensions_treegrid_bootstrap_table_treegrid_js__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_table_dist_extensions_treegrid_bootstrap_table_treegrid_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_table_dist_extensions_treegrid_bootstrap_table_treegrid_js__);













__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('BootstrapTable', __WEBPACK_IMPORTED_MODULE_6_bootstrap_table_dist_bootstrap_table_vue_esm_js__["a" /* default */]);

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

window.$ = window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[390]);


// WEBPACK FOOTER //
// static/js/app.f38a96e7a674599f33bd.js